/**
 *
 * @type {typeof import("./zh_TW")}
 *
 */
module.exports = {
	'global.normal': {
		'add': '新增',
		'modify': '修改',
		'update': '更新',
		'cancel': '取消',
		'view': '检视',
		'config': '设定',
		'edit': '编辑',
		'delete': '删除',
		'refresh': '重新整理',
		'export': '汇出',
		'exportInfo': '导出资料',
		'sendOut': '送出',
		'pleaseSelect': '请选择',
		'startTime': '开始时间',
		'endTime': '结束时间',
		'sure': '确定',
		'close': '关闭',
		'show': '显示',
		'informal': '不拘',
		'normal': '正常',
		'abnormal': '异常',
		'remove': '移除',
		'today': '今天',
		'disable': '停用',
		'enable': '启用',
		'error': '错误',
		'noInfo': '无资料',
		'finish': '完成',
		'correct': '正确',
		'yes': '是',
		'no': '否',
		'departmentName': '部门名称',
		'staff': '员编',
		'name': '姓名',
		'employeeNumber': '员工编号',
		'addANewStroke': '新增一笔',
		'all': '全部',
		'dept': '部门',
		'viewBtn': '查看',
		'selectAll': '全选',
		'january': '一月',
		'february': '二月',
		'march': '三月',
		'april': '四月',
		'may': '五月',
		'june': '六月',
		'july': '七月',
		'august': '八月',
		'september': '九月',
		'october': '十月',
		'november': '十一月',
		'december': '十二月',
		'weekToNum1': '一',
		'weekToNum2': '二',
		'weekToNum3': '三',
		'weekToNum4': '四',
		'weekToNum5': '五',
		'weekToNum6': '六',
		'weekToNum7': '日',
	},
	'components.grids': {
		'fetchErrMsg': '读取数据错误',
		'emptyWarning': '没有符合查询条件的数据，请放宽条件重新查询',
		'sureDeleteIt': '确定要删除吗?',
		'deleteCountMsg': '确定要删除此 <%= count %> 笔数据吗?',
		'successCount': ' (成功 <%= success %> 笔',
		'successCounts': ' (成功 <%= success %> 笔',
		'failCount': '，失败 <%= fail %> 笔',
		'failCounts': '，失败 <%= fail %> 笔',
		'usedCount': '，使用中 <%= used %> 笔',
		'usedCounts': '，使用中 <%= used %> 笔',
		'errorCount': '，错误 <%= unexpected %> 笔',
		'errorCounts': '，错误 <%= unexpected %> 笔',
		'simpleSearch': '简易搜寻',
		'advancedSearch': '进阶查询',
		'advancedSearchConfig': '进阶查询条件设定中',
		'counditionCount': '<%= count %> 个条件',
		'allCount': '共 <%= count %> 笔',
		'allCounts': '共 <%= count %> 笔',
		'matchFewCount': '符合 <%= count %> 笔',
		'matchFewCounts': '符合 <%= count %> 笔',
	},
	'components.utils': {
		'today': '今天',
		'to': '至',
		'noInfo': '无信息',
		'seeMore': '查看更多',
	},
	'hp.home': {
		'hello': '哈哈',
		'noAnnouncementYet': '尚无公告',
		'noNotifictionItemYet': '尚无通知',
		'gettingpaid': '薪资已发放！',
		'notice': '提醒您，依「个人资料保护法」之规定，取得或使用员工资料时，绝不泄漏、交付或以其他方式使非经合法授权之任何第三人知悉。',
		'know': '我知道了',
	},
	'hp.m5.m510010.form': {
		'programError': '程序错误',
		'noApplicationPermission': '您已无申请权限，请重新确认',
		'youNeedToUploadAtLeast': '至少需上传一个附件',
		'theSignoffProcess': '未产生签核流程，无法启动表单',
		'failedToWriteToForm': '写入表单失败',
		'attachmentUpdateFailed': '附件更新失败',
		'enterAReasonUpToWords': '输入原因，最多<%=max%>字',
		'attachmentLabel': '附件',
		'youDoNotCurrentlyHaveAnyDataToChangeYourTimeOfDuty': '您目前没有可异动的假勤资料',
		'atPresentTheSystemAllows': '目前系统允许异动时间内，无任何假勤数据，',
		'allAppliedLeaveInformationMustWait': '所有已申请的假勤数据，须等待签核完成后，才能进行异动。',
		'clickTheButtonBelowToSee': '点击下方按钮了解签核进度',
		'understandSignoffProgress': '了解签核进度',
		'lastMonth': '上个月',
		'thisYear': '本年度',
		'originalApplicationTime': '原申请时间：<%=start%>至<%=end%>，',
		'actualResults': '实际结果：',
		'noNeedToJudge': '不须判断',
		'judgingCardInformation': '判断刷卡资料',
		'remindYou': '提醒您',
		'pleaseHelpMeAdjust': '确定，请帮我调整',
		'effectiveDate': '生效日期',
		'clearReselection': '清除重选',
		'failedToLoadDataBeforeThe': '加载异动前数据失败',
		'project': '项目',
		'beforeTheChange': '异动前',
		'afterTheChange': '异动后',
		'changeTheProject': '异动项目',
		'totalItems': '共<%=temp1%>项',
		'changePersonnel': '异动人员',
		'pleaseEnterANumericType': '请输入数字型态',
		'mustBeLessThan': '必须小于 <%=num%>',
		'mustBeGreaterThan': '必须大于 <%=num%>',
		'pleaseEnterANumber': '请输入数字',
		'required': '必填',
		'pleaseSelectOvertimeFirst': '请先选择加班时间',
		'otherOvertimeRulesLoadedIncorrectly': '其他加班规定加载错误',
		'overtimeHoursIs0PleaseReselectOvertime': '加班合计时数为0，请重新选择加班时间',
		'pleaseEnterAStartAndEndTime': '请输入开始与结束时间',
		'actualAndHoursResultsThatComplyWithCompanyOvertimeRules': '您申请的加班时间经系统比对出勤数据后，将调整为符合公司加班规则的实际时间与时数结果。',
		'pleaseReselectOvertime': '请重新选择加班时间',
		'overtimeCheckError': '加班检查错误',
		'actualResultsAdjustedToComplyWithCompanyHoursOfOvertimeRules': '已将您申请的时数，调整为符合公司加班规则的实际结果。原申请时间：<%=otStart%>至<%=otEnd%>，',
		'companyOvertimeCategoryRules': '系统根据您输入的加班时间，依公司加班类别规则区分如下',
		'simultaneousRelease': '同时发放',
		'overtimePay': '加班费',
		'compensatoryLeave': '补休假',
		'costCenterItem': '(成本中心：<%=name%>，加班费 <%=otName%>，补休假 <%=calName%>)',
		'noCostCenterItem': '<%=name%>，加班费 <%=otName%>，补休假 <%=calName%>',
		'attachmentWriteError': '附件写入错误',
		'serverError': '服务器错误',
		'totalHours': '假勤合计时数',
		'costCenter': '成本中心设定',
		'typeNoLongerOpen': '已不开放此申请类型',
		'deduction': '扣除',
		'notDeduction': '不扣除',
	},
	'hp.m5.m510010.wf030': {
		'cannotRepeatTime': '申请时间不可重复',
		'applicant': '申请人',
		'forgetTheSwipeTime': '忘刷卡时间',
		'forgotToBrushTheReason': '忘刷原因',
	},
	'hp.m5.m510010.wf050': {
		'theLeaveCheckHasNotBeenPassed': '销假检查未过',
		'failedToWriteToTheFakeMasterFile': '写入销假主档失败',
		'theApplicationForAFakeSlipFailed': '销假单申请失败',
		'theProjectLoadingErrorCanBeChanged': '可异动假勤项目加载错误',
		'obtainingFalseAttendanceErrors': '取得假勤错误',
		'noneMessage': '无 <%=temp1%> <%=temp2%> <%=temp3%>',
		'falseAttendanceDataError': '假勤数据错误: <%=temp1%>',
		'theStartDateOfTheLeave': '假勤起始日',
		'endOfLeaveDay': '假勤结束日',
		'leaveProject': '假勤项目',
		'cancelType': '销假类型',
		'leaveCancelTime': '销假时间',
	},
	'hp.m5.m510010.wf010': {
		'theLeaveSlipApplicationFailed': '请假单申请失败',
		'theLeaveCheckHasNotBeen': '假勤检查未过',
		'failedToWriteToTheFake': '写入假勤主档失败',
		'pleaseSelectTheTimeOfAbsence': '请先选择假勤时间',
		'fakeProjectLoadingError': '假勤项目加载错误',
		'pleaseEnterAStartAndEnd': '请输入开始与结束时间',
		'getTheErrorOfTheDay': '取得事件发生日错误',
		'falseAttendanceCalculationError': '假勤计算错误',
		'pleaseSelectTheLeaveItemFirst': '请先选择假勤项目',
		'cancelTheDateOnWhichThe': '取消新增事件发生日',
		'theNewEventOccurredOnA': '新增事件发生日',
		'selectTheDateOnWhichThe': '选择已申请发生日',
		'servedAsAgentForOtherColleagues': '部分或全部的假勤时间已担任其他同仁的职务代理人',
		'issueHint': '需为 <%=X%> <%=Y%>的倍数，送出后将自动调整假勤时数',
		'startDateMustBeforeEndDate': '起始日期需早于结束日期',
	},
	'components.Dialog': {
		'correctInformation': '正确数据',
		'confirmTheImport': '确定汇入',
		'fileErrorTheFileFormatMust': '档案错误：档案格式须为Excel(.xlsx)，上限10MB。',
		'fileNameNotContainSpecialChar': '文件名不可包含特殊字符 \\ / : * ? " < > | # % &',
		'errorMsg': '错误讯息',
		'exceptionDescription': '异常说明',
		'dateFormatError': '不符合日期格式',
		'importDataError': '错误汇入数据',
		'importSuccess': '汇出完成',
		'verificationResult': '(验证结果)',
		'correct': '正确',
		'fieldCountError': '共<%= count %>个字段错误',
		'anomalousData': '异常资料',
		'downloadErrorData': '下载错误数据',
		'importResult': '(汇入结果)',
		'importCompleted': '汇入完成',
		'importCount': '汇入笔数',
		'importCompletedCloseWindow': '汇入完成，关闭窗口',
		'exportCompleted': '汇出完成',
		'exportFailed': '汇出失敗',
		'note': '备注',
		'fileUploadFailed': '文件上传失败，请重新上传',
		'invalidFileFormat': '文件内容格式无效，请重新上传',
		'uploadFailed': '上传失败',
		'importFailed': '汇入失敗',
		'fieldReminders': '有<%= count %>个字段提醒',
	},
	'components.Dialogs': {
		'identifyAdditions': '确定新增',
		'newInProgress': '新增中',
		'theWindowDoesNotCloseAfter': '新增后窗口不关闭',
		'identifyModifications': '确定修改',
		'underModification': '修改中',
		'notEntered': '(未输入)',
		'thisInformationCannotBeViewed': '无法检视此笔数据',
		'editTheProfile': '编辑数据',
		'modifyTheJourney': '修改历程',
		'previousStep': '上一步',
		'next': '下一步',
		'unableToLoadLongJobInformation': '无法加载长时作业信息',
		'pleaseClickToSelectTheImport': '请「点击」选择汇入档案，或将汇入档案「拖拉」于此处进行汇入作业',
		'theFileFormatIsIncorrect': '文件格式错误，或大小超过 10 MB。',
		'nonExistentFormat': '不存在的格式：<%=temp1%>',
		'fileNamesCannotContainSpecialCharacters': '文件名不可包含特殊字符 \\ / : * ? " < > | # % & ',
		'theAssignmentHasEndedPlease': '作业已结束，请重新整理后再试一次',
		'importTheResults': '汇入结果',
		'numberOfSuccesses': '成功笔数:',
		'numberOfFailures': '失败笔数:',
		'closeTheWindow': '关闭窗口',
		'downloadFailedData': '下载失败资料',
		'thatSRight': '正确',
		'totalFieldErrors': '共<%=temp1%>个字段错误',
		'verifyTheStatus': '验证状态',
		'correctData': '正确数据:',
		'processing': '处理中',
		'theDownloadIsComplete': '下载完成',
		'confirmTheDownload': '确定下载',
		'confirmTheDownloadUS': '确定下载',
		'downloading': '下载中 ...',
		'errorFreeDataIsAvailableFor': '无错误数据可下载',
		'fail': '失败',
		'succeed': '成功',
		'noData': '无资料:<%=temp1%>',
		'partialImport': '部分汇入',
		'importAll': '全部汇入',
		'cancelTheImport': '取消汇入',
		'abnormalData': '异常资料:<%=temp1%>',
		'downloadErrorData': '下载错误数据',
		'ifThereIsNoDataIn': '您所上传的档案内容无数据，请选择其他档案重新上传。',
		'afterPreviewingTheFirst': '以上预览您所上传档案中的前10笔数据(不含标题)，确认无误后，点击「开始检查数据」后，系统将开始执行汇入作业。<%=temp1%><%=temp2%>注意:若前10笔数据字段中皆为空值，系统预览时仍会呈现前10笔的空数据，且进行汇入作业时会自动略过空数据。',
		'nonExistentFormat2': '不存在的格式！',
		'ImportResult': '<%=temp1%> (汇入结果)',
		'ValidationResult': '<%=temp1%> (验证结果)',
		'ImportFilePreview': '<%=temp1%> (汇入档案预览)',
		'theImportIsComplete': '汇入完成',
		'startCheckingTheMaterials': '开始检查数据',
		'reUploadTheArchive': '重新上传档案',
		'cropThePicture': '裁切图片',
		'theUploadedImageIsInThe': '上传图片格式错误，或尺寸超过3MB。',
		'areYouSureYouWantTo': '确定要移除图片吗?',
		'removeTheImage': '移除图片',
		'DragAndDropAn': '+ 拖拉图片至此或点击并选取上传图片 ',
		'sending': '送出中 ...',
		'downloadTheImportSample': '下載匯入範例',
		'pleaseDownloadAndImportInTraditional': '请用繁中语系下载及汇入',
	},
	'components.Input': {
		'upToWords': '最多 <%=max%> 个字',
		'requiredField': '必填字段',
		'minimumWords': '最少 <%=min%> 个字',
		'theFormatDoesNotConform': '格式不符合',
		'pleaseEnterTheCorrectEmailFormat': '请输入正确的E-mail格式',
		'pleaseEnterDateFormatYYYYMMDD': '请输入日期格式(YYYY/MM/DD)',
		'pleaseEnterTimeFormathhmm': '请输入时间格式(hh:mm)',
		'pleaseEnterADFormatYYYY': '请输入公元年格式(YYYY)',
		'pleaseEnterTheFormatOfAD': '请输入公元年月格式(YYYY/MM)',
		'pleaseEnterTheFormatOfThe': '请输入公元月日格式(MM/DD)',
		'pleaseEnterTheDateTimeFormat': '请输入日期时间格式(YYYY/MM/DD hh:mm)',
		'pleaseEnterTheDateRangeYYYYMMDD': '请输入日期区间(YYYY/MM/DD ~ YYYY/MM/DD)',
		'pleaseEnterTheMobilePhoneNumber': '请输手机号码格式，例如：0988888888',
		'pleaseEnterTheCorrectPhoneNumber': '请输入正确电话号码格式，例如：\\n0288888888, 02-88888888, (02)88888888',
		'pleaseEnterTheExtensionFormatFor': '请输入分机格式，例如：99, 888, 1234',
		'pleaseEnterAPhoneOrMobile': '请输入电话或手机号码格式，例如：0288888888 或 0988888888',
		'pleaseEnterTheCorrectUniformNumbering': '请输入正确的统一编号格式',
		'pleaseEnterTheCorrectIPvFormat': '请输入正确的IPv4格式',
		'pleaseEnterTheCorrectIPv6Format': '请输入正确的IPv6格式',
		'rise': '起',
		'apocalypse': '讫',
		'aStartingValueIsRequired': '需要起始值',
		'anEndValueIsRequired': '需要结束值',
		'theStartingValueCannotBeLess': '起始值不能小于 <%=min%>',
		'theStartingValueCannotBeGreater': '起始值不能大于 <%=max%>',
		'theEndValueCannotBeLess': '结束值不能小于 <%=min%>',
		'theEndValueCannotBeGreater': '结束值不能大于 <%=max%>',
		'theStartValueCannotBeGreater': '起始值不能大于结束值',
		'pleaseEnterTheCorrectIDNumber': '请输入正确的身分证字号',
		'pleaseEnterAPassword': '请输入密码',
		'thePasswordLengthIsUpTo': '密码长度最多为 <%=max%>',
		'passwordLengthIsAtLeast': '密码长度至少为 <%=min%>',
		'total': '共<%=temp1%>日',
		'pleaseEnterTheDateFormat': '请输入日期格式(YYYY/MM/DD) ex: 2020/05/13',
		'pleaseEnterTheADFormat': '请输入公元年格式(YYYY) ex:2020',
		'pleaseEnterTheYearAndMonth': '请输入年月格式(YYYY/MM) ex:2020/05',
		'pleaseEnterTheMonthFormat': '请输入月份格式(MM) ex:08',
		'pleaseEnterMonthAndDayFormat': '请输入月日格式(MM/DD) ex:08/25',
		'pleaseEnterTheTimeFormat': '请输入时间格式(hh:mm) ex:23:15',
		'pleaseEnterTheHourFormat': '请以小时为单位输入（hh:mm）ex：23:00',
		'pleaseEnterTheDatetimeFormat': '请输入日期时间格式(YYYY/MM/DD hh:mm) ex:2020/05/13 23:15',
		'pleaseEnterANumericType': '请输入数字型态',
		'mustBeLessThan': '必须小于 <%=max%>',
		'mustBeGreaterThan': '必须大于 <%=min%>',
		'mustBeAMultiple': '必需为 <%=unit%> 的倍数',
		'startDate': '开始日期',
		'endDate': '结束日期',
		'aStartOrEndDateIs': '需要起始或结束日期',
		'aStartDateIsRequired': '需要起始日期',
		'anEndDateIsRequired': '需要结束日期',
		'theStartDateMustBeEarlier': '起始日期需早于结束日期',
		'theTimeRangeMustBeLess': '时间范围必需小于 <%=rangeMax%>',
		'theTimeRangeMustBeGreater': '时间范围必需大于 <%=rangeMin%>',
		'theDayBeforeYesterday': '前日',
		'day': '当日',
		'next': '次日',
		'pleaseSelectTheDepartment': '请挑选部门 ...',
		'searchDepartment': '搜寻部门 ...',
		'theOrganizationChart': '组织结构(<%=temp1%>)未启用或无部门数据',
		'countiesCitiesAndTownships': '县 市 乡 镇',
		'youCanSelectUpTo': '最多可选 <%=max%> 项',
		'atLeastMin': '最少需选 <%=min%> 项',
		'easyFiltering': '简易筛选',
		'advancedFiltering': '进阶筛选',
		'advancedFilterSettings': '进阶筛选条件设定中...',
		'selected': '已选取',
		'search': '搜寻 ...',
		'translate error': 'number',
		'deactivated': '已停用',
		'selectedItemIsInactive': '所选项目包含已停用选项，请重新选择',
		'noMatchingInformation': '无符合资料',
		'join': '加入',
		'unitYear': '年',
		'unitMonth': '月',
		'unitDay': '日',
	},
	'hp.m4.m410020': {
		'salaryMonth': '薪资月份',
		'salaryCate': '薪资类别',
		'payroll': '薪资袋',
		'return': '返回',
		'nonEmpAccessDenied': '非员工无查询权限',
		'payrollLogin': '薪资袋登入',
		'pwChangeOK': '密码变更成功',
		'pwForgotten': '忘记密码',
		'loginOK': '登入成功',
		'notice': '讯息',
		'pwMustChange': '必须变更密码',
		'loginError': '登入失败',
		'noApplication': '应用程序不存在',
		'pwGone': '员工薪资袋密码数据不存在',
		'pwBroken': '薪资袋密码状态错误',
		'pwInactive': '薪资袋密码待启用',
		'pwLocked': '薪资袋密码已锁定',
		'pwClosed': '薪资袋密码已停用',
		'waitLocked': '密码已锁定，请等待 <%= accountLockoutTime %> 分钟后再登入',
		'notifiedAdmin': '已通知系统管理员，请静待处理，谢谢。',
		'forgetExceeded': '忘记密码点按次数已超过上限！为保障您的密码安全，密码将改为停用，并已通知系统管理员处理，谢谢',
		'resetMailSent': '系统已寄发薪资袋重设密码函至您的信箱，请于30分钟内重新设定，逾期失效，谢谢。',
		'sendFatal': '发送失败',
		'pwPayroll': '薪资袋密码',
		'pwHintLogin': '为确保薪资数据安全，请协助输入电子薪资袋密码(非Portal登入密码)',
		'pwHintClose': '密码已停用，若有问题，请洽询系统管理员',
		'tellAdmin': '通知管理员',
		'tokenFault': 'TOKEN错误',
		'charRuleFailed': '文数字检查错误',
		'spCharRequired': '密码需有特殊符号检查错误',
		'sameAsPrevious': '新旧密码不可以一样',
		'pwConfirmFailed': '新密码不一致',
		'pwModify': '修改密码',
		'pwCurrent': '旧密码',
		'pwResetNoted': '已发送重设薪资袋密码通知',
		'remindedAdmin': '忘记密码已连络HR处理',
		'ajaxFatal': '读取失败',
		'payrollUnset': '员工未设定薪资袋格式',
		'payrollOutRange': '仅可查询 <%= qryLimitMonth %> 个月内的薪资袋数据，请重新查询',
		'operationTimedOut': '验证失效或操作逾时，请重新登入',
		'taxBonusHint': '课税属性总金额=奖金加项的应税 - 奖金扣项的应税',
		'taxSalayHint': '课税属性总金额=薪资结构的应税+薪资加项的应税 - 薪资扣项的应税',
		'attendAmtHint': '「当月加项金额/当月扣项金额」可能因金额异动或小数点关系而有落差，<%= br %>实际请以「薪资加项/薪资扣项」金额为主。',
		'bonus1st': '第一笔',
		'bonus2nd': '第二笔',
		'bonus3rd': '第三笔',
		'bonus4th': '第四笔',
		'bonus5th': '第五笔',
		'bonus6th': '第六笔',
		'bonus7th': '第七笔',
		'bonus8th': '第八笔',
		'failExceeded': '密码错误达 <%= cnts %> 次，请等待 <%= mins %> 分钟后再登入',
		'payrollNoFmt': '未设定薪资袋格式',
		'noSpeed': '未建立快速登入',
		'pubKeyFail': '密钥验证失败',
		'pubKeyBroken': '密钥操作异常',
		'authFatal': '辨识失败',
		'pwLocking': '密码锁定中',
		'pwClosing': '密码状态异常，请联络系统管理员',
		'pwResetFatal': '重设密码失败',
		'pwLostFatal': '申请忘记密码失败',
		'pwMaxClosed': '已超过次数，您的密码已改为停用，并已连络账号管理者',
		'noAnyPayData': '无任何薪资资料',
		'opFatal': '操作失败',
		'noPayData': '无薪资资料',
		'waitSalary': '请待有薪资数据后，再进行查询',
		'noMail': '申请重设密码失败，无mail可寄发通知函，请联络系统管理员，谢谢。',
		'noMailForAPP': '无 email 可寄发密码通知函，请联络系统管理员，谢谢。',
		'headerForAPP': '申请重设密码失败',
	},
	'hp.m4.m410040': {
		'queryInterval': '查询区间',
		'ifNoQueryIntervalIsSet': '若未设定查询区间，将预设查询<%=temp1%>~<%=temp2%>的资料',
		'selectAStartDate': '选择开始日期',
		'selectAnEndDate': '选择结束日期',
		'kabie': '卡别',
		'state': '状态',
		'theOvertimeAttendanceReasonWasUpdated': '超时出勤原因更新成功',
		'multipleOvertimeAttendanceReasonsAreUpdated': '多笔超时出勤原因更新成功',
		'noInformationTryToSearchAgain': '无信息，试试重新搜寻吧!',
		'failedToCountTheNumberOf': '计算请假表单、忘刷表单数量失败',
		'serialNumber': '序号',
		'dateOfWork': '工作日期',
		'banBing': '班别',
		'timeOfAttendance': '应出勤时间',
		'clockinTime': '打卡时间',
		'systemOperation': '系统作业',
		'overtimeAttendance': '超时出勤',
		'multipleFills': '多笔填写',
		'bodyTemperature': '体温',
		'remark': '备注',
		'oopsIHaventFilledIn': 'Oops ! 尚未填写',
		'cause': '原因:',
		'leave': '请假',
		'forgetToBrush': '忘刷',
		'editTheReasonForOvertimeAttendance': '编辑超时出勤原因',
		'pleaseFillInTheReason': '请填写原因',
		'incorrectOnboardingJourneyTime': '加载打卡历程时间错误',
		'thereIsNoRecordOfAny': '没有任何打卡纪录喔!',
		'overtimeAttendanceReason': '超时出勤原因',
		'theDescriptionMustBeLessThan': '说明内容必须少于100字内',
		'sendingOut': '送出中',
		'onboardingTimeoutAttendanceReasonError': '加载超时出勤原因错误',
		'updateDate': '更新日期',
		'selectAll': '全选',
		'expectedHoursOfAttendance': '应出勤时间:',
		'dateOfWork2': '工作日期:',
		'clockInJourneyTime': '打卡历程时间',
		'clockInTime': '打卡时间',
		'timeoutDescription': '超时出勤说明',
		'reason': '超时出勤原因',
		'genTestData': '随机产生打卡资料',
	},
	'hp.Header': {
		'theSwitchoverFailed': '切换失败',
		'successfullySwitchedTo': '成功切换至：<%=temp1%>',
		'individual': '个人',
		'announcement': '公告',
		'form': '表单',
		'classSchedule': '班表',
		'logOffTheSystem': '注销系统',
		'areYouSureYouWantTo': '确定要注销吗?',
		'failedToLogOffTheSystem': '注销系统失败',
		'announcementQueryError': '公告查询错误',
		'daysago': '<%=temp1%> 天前',
		'hoursago': '<%=temp1%> 小时前',
		'tempminutesago': '<%=temp1%> 分钟前',
		'minutesago': '0分钟前',
		'latestNotices': '最新通知',
		'readall': '全部读取',
		'removeall': '全部移除',
		'youdonthavethelatestnotice': '您没有最新通知！',
		'agentidentity': '代理身份',
		'basicinformation': '基本信息',
		'listofrelatives': '亲属名单',
		'accountsecurity': '账号安全',
		'switchidentities': '切换身份',
		'language': '语言：',
		'logout': '注销',
		'selectIdentity': '选择身份',
		'selectalanguage': '选择语言',
		'headFor': '前往',
		'NonEmployees': '(非员工) ',
		'personalSettings': '个人设定',
	},
	'components.EmpUtils': {
		'department': '部门',
		'headOfDepartment': '部门主管',
		'incumbentStatus': '在职状况',
		'dateRelated': '日期相关',
		'withholdingUnit': '扣缴单位',
		'laborProtectionCompilation': '劳保统编',
		'healthInsuranceCompilation': '健保统编',
		'posts': '职位',
		'grade': '职等',
		'rank': '职级',
		'jobCategory': '职务类别',
		'occupation': '职种',
		'identityCategory': '身分类别',
		'directAndIndirect': '直间接别',
		'separationOfResponsibilities': '责任区分',
		'preparationStatus': '编制状况',
		'workArea': '工作区域',
		'placeOfWork': '工作地点',
		'factoryBy': '厂别',
		'classAttributes': '班别属性',
		'salaryMethod': '计薪方式',
		'probationaryExpirationStatus': '试用期满状态',
		'basicData': '基本数据',
		'householdRegistrationAddressArea': '户籍地址地区',
		'mailingAddressArea': '通讯地址地区',
		'employee': '员工',
		'firm': '公司',
		'partTimeStatus': '部分工时/全时',
		'thisEmployeeViewPermissionIsNot': '无此员工检视权限',
		'noInformationOnThisEmployeeWas': '查无此员工数据',
		'readError': '读取错误',
		'reloadTheData': '重载资料',
		'pickEmployees': '挑选员工',
		'searchForNameEditors': '搜寻姓名员编...',
		'moreSearchCriteria': '更多搜寻条件',
		'companyAffiliation': '所属公司',
		'wordStatus': '在职状态',
		'employeeNumberOnwards': '员工编号起',
		'employeeNumber': '员工编号讫',
		'searcherNameExtension': '搜寻员编、姓名、分机、信箱...',
		'selectCompany': '公司',
		'setFilters': '设定筛选条件',
		'excludeSpecificPeople': '排除特定人员 ',
		'previewOfTheResults': '结果预览',
		'youCanOnlyRules': '最多只能 <%=max%> 个规则',
		'aMinimumOfRules': '最少需要 <%=min%> 个规则',
		'condition': '条件:',
		'exclude': '排除:',
		'firmEmp': '公司:',
		'establishFilters': '建立筛选条件',
		'memberCheck': '成员检核',
		'reviewTheFilters': '检视筛选条件',
		'editTheFilterCriteria': '编辑筛选条件',
		'thereAreCurrentlyNoOtherCompanies': '目前没有其他公司，无法继续作业',
		'dateOfArrival': '到职日期',
		'dateOfDeparture': '离职日期',
		'leaveWithoutPayDate': '留职停薪日期',
		'gender': '性别',
		'ageRange': '年龄范围',
		'seniorityRange': '年资范围',
		'staffingRange': '员编范围',
		'employeeCardNumberRange': '员工卡号范围',
		'nationality': '国籍',
		'organizationChart': '组织结构',
		'level': '层级',
		'noPermissions': '无权限',
		'numberOfExcluded': '排除人数:',
		'ifThereAreNoEligibleEmployees': '无符合条件的员工，无法排除',
		'accordingToTheFilterCriteria': '根据筛选条件，目前无符合条件员工',
		'organizationChartCategories': '组织结构类别',
		'numberOfSelectedPeople': '已选人数<%=temp1%>笔',
		'reviewMembers': '检核成员',
		'thereAreCurrentlyNoEligibleEmployees': '目前无符合条件员工',
		'sector': '部门1',
		'positionTitle': '职位(职称)',
		'gradeGrade': '职等/职级',
		'dateOfBirth': '出生日期',
		'maritalStatus': '婚姻状况',
		'highestEducation': '最高学历',
		'recentExperience': '最近经历',
		'companyPhone': '公司电话',
		'companyEMail': '公司E-mail',
		'mobilePhone': '移动电话',
		'personalEMail': '个人E-mail',
		'familyRegistrationTelephone': '户籍电话',
		'registeredAddress': '户籍地址',
		'homePhone': '住家电话',
		'mailingAddress': '通讯地址',
		'foreignAddress': '国外地址',
		'socialAccount': '社群账号1',
		'socialAccount2': '社群账号2',
		'emergencyContact': '紧急联络人(1)',
		'emergencyContactRelationship1': '紧急联络人关系(1)',
		'phone': '电话(1)',
		'mobilePhone1': '移动电话(1)',
		'emergencyContacts2': '紧急联络人(2)',
		'emergencyContactRelationships2': '紧急联络人关系(2)',
		'phone2': '电话(2)',
		'mobilePhone2': '移动电话(2)',
		'noInformationOnThisNonEmployee': '查无此非员工数据',
		'staffEditor': '员编:',
		'arrivalDate': '到职日:',
		'pickNonEmployees': '挑选非员工',
		'failedToReadNonEmployeeData': '读取非员工数据失败',
		'search': '搜寻...',
		'fromTheCodeNameOfThe': '所得人代号起',
		'theRecipientCodeName': '所得人代号讫',
		'nameOfTheRecipient': '所得人姓名/名称',
		'iDNumberCompanyCompilation': '身分证号/公司统编起',
		'iDorCompanyCompilation': '身分证号/公司统编讫',
		'categoryOfEarner': '所得人类别',
		'clickToPickOtherNonEmployees': '点选可挑选其他非员工',
		'employeeName': '员工姓名',
		'directIndirect': '直/间接',
		'workAreaLocation': '工作区域/地点',
		'workRules': '工时规则',
		'scheduledHours': '已排时数',
		'elapsedHoursOn': '已排时数(起)',
		'scheduledHoursToDate': '已排时数(迄)',
		'failedToReadEmployeeData': '读取员工数据失败',
		'unselect': '未选择员工',
		'selected': '已选择员工',
		'keywords': '员工关键词',
		'empNumberStart': '员工编号(起)',
		'empNumberEnd': '员工编号(迄)',
	},
	'hp.m5.m510010.wf080': {
		'unit': '份',
		'headerItem': '文件项目',
		'headerNum': '数量(份)',
		'applicationDocument': '申请文件',
		'reasonForApplying': '用途说明',
	},
	'hp.m5.m5Picker': {
		'wfForm': '表单',
		'amOtType': '加班类别',
		'pbRccc': '成本中心',
		'pbVarsCause': '核薪原因',
		'pbSalaryItem': '薪资科目',
		'pbCurrency': '币别',
		'edVarsCause': '异动原因',
		'osSNO': '扣缴单位(统编)',
		'osSNOCompilation': '统编',
		'osOrgType': '组织类别',
		'edJob': '职位',
		'edGrade': '职等',
		'edLevel': '职级',
		'edJobCat': '职务类别',
		'edJobDesct': '职务说明书',
		'edJobStyle': '职种',
		'edJobBiz': '名片职务',
		'edIdentity': '身分类别',
		'edArea': '工作区域',
		'edSite': '工作地点',
		'edFactory': '厂别',
		'amTemplate': '出勤规则模板',
		'amShift': '班别',
		'amCalendar': '行事历',
		'amAnnual': '特休规则',
		'amFlexible': '弹性假规则',
		'amOtRule': '加班规则',
		'amOtWorkHour': '工时规则',
		'amSectionRule': '时段班别规则',
		'amAttendRule': '出勤时数规则',
		'wfDocType': '文件类别',
		'osCompany': '公司',
		'edQuitCause': '离职原因',
		'edBizProperty': '出差性質',
		'edBizArea': '出差地點',
		'edBizTrans': '交通工具',
		'edBizTodo': '委辦事項',
	},
	'hp.m5.m510010.wf064': {
		'quitDateTip': '离职生效日为最后工作日，员工当天仍算在职',
		'selectDate': '选择日期',
		'quitCauseDescPla': '请输入文字',
		'homeTelPla': '例如：02 22881256',
		'mobileTelPla': '例如：0912345678',
		'personalEmailPla': '例如：104@gmail.com',
		'postCodePla': '请选择县市区域',
		'contactAddressPla': '请输入通讯地址',
		'handoverContentPla': '输入工作内容，最多1000字',
		'resignMoreStay': '离职生效日必需大于留停作业生效日',
		'hasResignation': '已有大于生效日后的离职数据',
		'resignMoreDueDate': '离职生效日必需大于等于到职日',
		'handoverUpdateFailed': '交接文件写入错误',
		'typeOfResignation': '离职类型',
		'resignationNumber': '离职编号',
		'effectiveDateOfSeparation': '离职生效日',
		'reasonForLeaving': '离职原因',
		'reasonForResignation': '离职原因说明',
		'contactAfterLeaving': '离职后联络方式',
		'homeTelLabel': '电话',
		'mobileTelLabel': '手机',
		'addressLabel': '地址',
		'handoverLabel': '交接工作资料',
		'handoverContentLabel': '交接工作内容',
		'handoverPersonLabel': '交接人',
		'handoverDocumentsLabel': '交接文件',
		'interviewRecordLabel': '面谈记录',
		'hrInterviewRecordLabel': 'HR 面谈记录',
		'reviewHrPla': '请输入面谈记录，最多1000字',
		'supervisorInterviewRecordLabel': '主管面谈记录',
		'reviewLeaderPla': '请输入面谈记录，最多1000字',
		'includeTurnoverRateLabel': '纳入离职率计算',
		'neverHireLabel': '永不录用',
		'neverHireReasonLabel': '永不录用原因',
		'neverHiredReasonPla': '请输入原因，最多1000字',
		'effectiveSetting': '生效设定',
		'resignationDateIsSalaryEffLabel': '离职日未到，计薪先行生效',
		'reasonForLeavingHasBeenDisabled': '离职原因已停用',
		'resignationIsNotEffectiveJobAlreadyExists': '离职未生效作业已存在',
		'reasonForLeavingHasBeenRemoved': '离职原因已删除',
		'handoverPersonEmploymentStatus': '交接人已非在职状态',
		'interviewDocuments':'面谈档案',
		'infoTel':'联络方式–电话',
		'infoPhone':'联络方式–手机',
		'infoEMail':'联络方式–Email',
		'infoAddress':'联络方式–地址',
	},
	'hp.m5.m510010.wf065': {
		'handoverPersonEmploymentStatus': '交接人已非在职状态',
		'stayReasonRemoved': '留停原因已删除',
		'theReinstatementDateIsGreaterThanStayDate': '预计复职日要大于留停生效日',
		'effectiveDateOfStayAndTypeIsNotRepeatable': '留停生效日+留停类型不可重复',
		'effectiveSateOfStayEqualToReinstatementDate': '留停生效日必需大于等于上次复职日',
		'dwellReasonDisabled': '留停原因已停用',
		'thereArePendingStayOperations': '尚有未生效的留停作业',
		'thereArePendingReinstatementOperations': '尚有未生效的复职作业',
		'noReinstatementOperations': '未有复职作业',
		'stayMoreDueDate': '留停生效日必需大于等于到职日',
		'handoverUpdateFailed': '交接文件写入错误',
		'reasonForStay': '留停原因',
		'stopCauseDescPla': '请输入文字',
		'stopDateTip': '留停生效日为最后工作日，员工当天仍算在职',
		'selectDate': '选择日期',
		'homeTelPla': '例如：02 28980098',
		'mobileTelPla': '例如：0912345678',
		'personalEmailPla': '例如：104@gmail.com',
		'postCodePla': '请选择县市区域',
		'contactAddressPla': '请输入通讯地址',
		'handoverContentPla': '输入工作内容，最多1000字',
		'addHandoverWorkContent': '新增交接工作内容',
		'stayTypeLabel': '留停类型',
		'stayTNumberLabel': '留停编号',
		'reasonForStayLabel': '留停原因说明',
		'effectiveDateOfStayLabel': '留停生效日',
		'estimatedReturnDateLabel': '预计复职日',
		'stayDateIsSalaryEffLabel': '留职停薪日未到，计薪先行生效',
		'contactAfterLeaving': '留停期间联络方式',
		'homeTelLabel': '电话',
		'mobileTelLabel': '手机',
		'addressLabel': '地址',
		'handoverLabel': '交接工作资料',
		'handoverContentLabel': '交接工作内容',
		'handoverPersonLabel': '交接人',
		'handoverDocumentsLabel': '交接文件',
		'insuranceInformationLabel': '保险资料',
		'healthStatusLabel': '健保状态',
		'laborInsuranceStatusLabel': '劳保状态',
		'thereIsNoEffectiveReinstatementDate': '尚未有生效之复职日',
		'parentalLeaveInfo': '育婴留停资讯',
		'ageNone': '年龄：--',
		'ageInfo': '年龄：<%=n%> 岁',
		'otherChild': '该子女其他申请资料',
		'times': '次数',
		'parentalLeaveSeniority': '育婴留停年资',
		'timesFormat': '<%=Y%> 年 <%=M%> 月 <%=D%> 日',
		'childRequired': '需填写子女姓名',
		'childCareTypeRequired': '需填写育婴留停种类',
		'notExistChild': '<%=n%> 不存在',
		'notChildApplicant': '<%=n%> 的关系非子女',
		'warningStayDate': '留停生效日当日子女大于等于 3 岁',
		'warningReinstatementDate': '预计复职日子女大于 3 岁',
		'warningSeniority': '员工年资未满6个月',
		'perviewChild': '<%=n%>（年龄：<%=y%> 岁）',
		'nameOfChild': '子女姓名',
		'typeOfParentalLeave': '育婴留停种类',
		'downloadChild': '<%=t%>，<%=c%> 次，育婴留停年资 ',
	},
	'sp.wf065.ed.emp.stop.Check': {
		'code11': '该公司没有此员工',
		'code12': '<%=n%> 不存在',
		'code13': '育婴留停种类不符合',
		'code14': '育婴留停情境不符合',
		'code15': '<%=n%> 的关系非子女',
		'code21': '申请超过次数',
		'code22': '留停期间不符合申请年资限制',
		'code23': '已超过可申请时间',
		'code31': '留停生效日当日子女大于等于 3 岁',
		'code32': '留停生效日当日子女大于等于 3 岁',
		'code33': '预计复职日子女大于 3 岁',
		'code34': '预计复职日子女大于 3 岁',
		'code41': '员工年资未满 6 个月',
		'code42': '员工年资未满 6 个月',
		'code51': '已有大于等于留停生效日或展延生效日的复职资料',
		'code52': '申请期间与子女出生时间不符',
	},
	'hp.RouteWrapper': {
		'loginFailedTheAccountStatus': '系统已自动登出，请重新登入',
		'verifyOfYourAccount': '您无使用该功能权限，请重新确认您使用的账号权限。',
	},
	'hp.Signin': {
		'pleaseSelectYourCompany': '请选择您所属的公司:',
		'passwordSettingFailed': '密码设定失败',
		'theAccountDoesNotExist': '账号不存在',
		'theAccountStatusIsAbnormalAnd': '账号状态异常，无法变更密码',
		'ifThePasswordDoesNotMeet': '密码不符合登入规则要求的长度或复杂性，请重新设定',
		'ifYouLogInTooMany': '登入错误太多次，账号将锁定 <%=temp1%> 分钟',
		'youVeLoggedInYou': '您已经登入过了，稍后将自动重新整理画面...',
		'loginFailed': '登入失败',
		'theAccountNumberOrPasswordIs': '账号或密码错误',
		'aDVerificationFailed': 'AD验证失败',
		'youAreCurrentlyUsingADevice': '您目前使用装置(IP未允许)没有存取此系统的权限',
		'ifTheAccountStatusIsAbnormal': '账号状态异常(锁定、关闭、未验证等)，请联络系统管理者',
		'accountPermissionsAreUnusualOrHave': '账号权限异常或没有权限',
		'enableTheAccount': '启用账号',
		'firstTimeUsingTheSystem': '第一次使用系统',
		'youMustEnableYourAccountFirst': '必需先启用账号',
		'steps': '步骤:',
		'Verification': '1. 验证',
		'account': '账号',
		'Settings': '2. 设定',
		'password': '密码',
		'EnableFinish': '3. 启用完成',
		'logIn': '登入',
		'forgotPassword': '忘记密码',
		'thePasswordModificationIsComplete': '密码修改完成',
		'hello': '<%=temp1%>您好,',
		'yourPassword': '您的密码',
		'yourPasswordHasBeen': '您的密码<%=temp1%>已经修改完成！',
		'canBeDirectly': '可直接<%=temp1%>，谢谢！',
		'logInToTheSystem': '登入系统',
		'setAPassword': '设定密码',
		'passwordPlaceholder': '密码',
		'confirmThePassword': '确认密码',
		'yourPasswordMustMeetTheFollowing': '您的密码必须符合以下要求',
		'theMinimumPasswordLengthIs': '密码长度最小<%=temp1%>字符',
		'thePasswordIsACombinationOf': '密码为英文数字组合',
		'thePasswordMustHaveASpecial': '密码需有特殊符号',
		'thePasswordContainsAtLeastOne': '密码至少包含一个大写英文字',
		'thePasswordIsEnteredTheSame': '两次密码输入相同',
		'account2': '账号:',
		'inTheSetting': '设定中',
		'logInToYourAccount': '登入帐号 Account',
		'rememberTheAccountNumber': '记住账号',
		'loginPassword': '登入密码 Password',
		'theRequestToResetThePassword': '申请重设密码失败',
		'youEnteredTheWrongAccountNumber': '您输入的账号有误。',
		'youAreUsingAnADAccount': '您使用的是AD账号，重设AD账号密码请联络公司MIS人员，谢谢！',
		'yourAccountIsNotEnabled': '您的账号未启用，请连络账号管理者再寄一次账号认证信',
		'yourAccountHasBeenClosed': '您的账号已关闭，请连络账号管理者，谢谢!',
		'failedToGenerateToken': '产生token失败',
		'failedToSendNotificationLetterWithout': '寄送通知信失败，无信件范本',
		'userAccount': '使用者账号',
		'applying': '申请中',
		'requestAPasswordReset': '申请重设密码',
		'yourHasBeenSent': '您的<%=temp1%>已经寄送到<%=temp2%>，请尽速取信，并点击链接进行密码重设，链接有效期限为<%=temp3%>分钟，谢谢！',
		'PasswordResetLetter': '「密码重设信函」',
		'weHaveNotifiedYourCompanyResponsible': '我们已经通知贵公司负责人员协助您重设密码。',
		'ifYouNeedToUseThe': '若急须使用系统，请主动联系贵公司负责人员。谢谢！',
		'logBackIn': '重新登入',
		'yourAccountIsLockedPlease': '您的账号锁定中，请连络账号管理者，谢谢',
		'yourAccountHasBeenClosedThx': '您的账号已关闭，请连络账号管理者，谢谢',
		'yourAccountIsNotVerified': '您的账号未认证',
		'theInputIsWrongTooMany': '输入太多次错误，账号已被锁定',
		'noAccountInformation': '无帐户信息',
		'theUserAccountDoesNotExist': '该使用者账号不存在',
		'passwordMinimumLengthCheckError': '密码最小长度检查错误',
		'thePasswordDoesNotMeetThe': '密码不符合密码设定要求，请重新设定',
		'theAccountStatusIsWrong': '账号状态错误',
		'theTimeHasNotYetCome': '时间未到',
		'duplicateLastPassword': '与上次密码重复',
		'yourAccountIsAnIntegratedAD': '您的账号为整合AD账号，无法修改密码',
		'authenticationModeError': '认证模式错误',
		'thePasswordWasEnteredIncorrectly': '密码输入错误',
		'theLinkToTheLetterIs': '信件连结已失效，请确认账号是否开启或已重新寄发账号认证信',
		'passwordCannotBeChanged': '无法变更密码',
		'thePasswordDoesNotMatch': '密码不一致，请确认',
		'blankInputIsNotAllowed': '不允许输入空白',
		'passwordRulesAreNotMet': '密码规则不符合',
		'theFirstTimeYouUseThe': '第一次使用系统<%=temp1%>必需先启用账号<%=temp2%><%=temp3%>步骤:<%=temp4%>1.验证<%=temp5%>与<%=temp6%><%=temp7%>2.设定<%=temp8%><%=temp9%>3.启用完成',
		'authenticationCode': '认证码',
		'theAccountIsEnabled': '账号启用完成',
		'yourAccountHasBeen': '您的账号<%=temp1%>已经启用完成！',
		'pleaseWithTheNew': '请用刚设定的新密码<%=temp1%>，谢谢！',
		'hello2': ' 您好,',
		'ClickOnThe': '1.点击信件<%=temp1%>',
		'EnableComplete': '2. 启用完成',
		'link': '连结',
		'VerifyThat': '1.验证<%=temp1%>与<%=temp2%>',
		'Set': '2.设定<%=temp1%>',
		'VerifyThat1': '1.验证<%=temp1%>',
		'failedToEnableAccount': '启用账号失败',
		'accountError': '账号错误',
		'linkValidationFailed': '连结验证失败',
		'invalidLink': '无效的连结',
		'thisLinkHasExpiredPlease': '此连结已过期，请重新申请！',
		'yourCurrentDeviceIPIs': '您目前使用装置(IP未允许)没有存取此系统的权限，请换有权限的装置或连络账号管理者，谢谢!',
		'anUnspecifiedErrorOccurred': '发生不明的错误',
		'verify': '验证中 ...',
		'theLinkHasAlreadyCompletedThe': '该链接已经完成设定新密码或者又有更新的申请；若是后者请使用最新收到mail中的连结，谢谢!',
		'youHaveSuccessfullyChangedThePassword': '您已经成功变更密码，请以新密码<%=temp1%>系统，谢谢！',
		'hello3': '您好，',
		'newPassword': '新密码',
		'user': '使用者',
		'eMail': '邮件信箱',
		'confirmTheNewPasswordAgain': '再次确认新密码',
		'confirmTheReset': '确定重设',
		'resetThePassword': '重设密码',
		'reset': '重设中',
		'invalidLinks': '无效连结',
		'resetPasswordFailedThisLink': '重设密码失败：此连结已过期，请重新申请！',
		'yourCurrentDeviceIPNot': '您目前使用装置(IP未允许)没有存取此系统的权限，请换有权限的装置或连络账号管理者',
		'theLinkHasAlreadyCompletedThePassword': '该链接已经完成设定新密码或者又有更新的申请；若是后者请使用最新收到mail中的连结',
		'ifYouDoNotHaveAn': '无 email 可寄发密码通知函，请联络系统管理员',
		'ifTheSystemIsAbnormalContact': '系统异常，请联络系统管理员',
		'requireSignInWithAadRuleMsg': '需要使用Microsoft帐号登入',
		'resetPasswordAadRuleMsg': '此帐号不适用，请使用 Microsoft 帐号登入',
		'theAccountDoesNotExistOrNotAadRule': '帐号不存在，或不适用于 Microsoft 帐号登录',
		'azureADVerificationFailed': 'Azure Active Directory验证失败',
		'companyNoAzureADLoginRules': '该公司无AzureAD登入规则',
		'oneTimePass': 'OTP密码',
		'fatalOtp': 'OTP 密码错误，请重新输入',
	},
	'hp.m5.m510020': {
		'startToEnd': '<%=temp1%> 至 <%=temp2%>',
		'yes': '有',
		'not': '无',
		'incomeTaxCalculationRules': '所得税计算规则',
		'summary': '摘要',
		'downtimeTelephone': '留停期间-电话',
		'duringTheStayPeriodMobilePhone': '留停期间-手机',
		'stayEmail': '留停期间-Email',
		'periodOfStayAddress': '留停期间-地址',
		'youCanSeeTheFullInformation': '您可至表单内页查看完整信息',
		'principal': '主要及其他承办人',
		'resubmittingFailed': '重送窗体失败',
		'notHavePermission ': '您已无 <%=name%> 的申请权限，无法重送窗体',
		'approverFormNo': '签核人/被异动人/表单编号',
		'changeApproverByBatch': '批次更改签核人',
		'ｗithdrawByBatch': '批次抽单',
		'unableToWithdraw': '无法抽单',
		'resubmit': '重送',
		'withdrawnCompleted': '抽单完成',
		'withdrawnFailed': '抽单失败',
		'beenWithdrawn': '窗体已被他人抽单、删单、签核完成、或已进行结算，因此无法抽单',
		'changedSuccessfully': '批次更改签核人成功',
		'ChangedFailed': '批次更改签核人失败',
		'fromTheOriginalSigner': 'Oops! 无任何原签核人的待签窗体',
		'notPossibleToChange': 'Oops ! 全部无法更改签核人',
		'skipAndProceed': '略过，继续更改签核人',
		'importSheetError': '因 excel 的 sheet 名称精简为 30 个字符后仍重复，建议您单独下载表单，或调整表单名称。',
	},
	'hp.SigninMobile': {
		'hello': '<%=temp1%>您好,',
		'yourAccountHasBeenLockedPlease': '您的账号已锁定，请于锁定效期之后再次登入本系统或连络账号管理者，谢谢！',
		'failedToVerifyTheAccount': '验证账号失败',
		'youEnteredTheWrongVerificationCode': '您输入的认证码有误。',
		'validating': '验证中',
		'verifyTheAccount': '验证账号',
	},
	'hp.Home': {
		'iMTheBest': '我最棒!',
		'specialBreak': '特休',
		'compensatoryLeave': '补休',
	},
	'hp.m5.m510010.wf040': {
		'theleaveCheckHasNotPassed': '假勤异动检查未过',
		'failedToAApplyForALeaveOfAbsenceTransactionOPrderk': '假勤异动单申请失败',
		'failedToWriteToLeaveMasterFile': '写入假勤主档失败',
		'theTotalNumberOfLeavesOfAbsenceCannotBe0': '请假合计时数不可为0',
		'pleaseSelectTheTimeOfAbsence': '请先选择假勤时间',
		'loadingErrorsForChangeableLeaveItems': '可异动假勤项目加载错误',
		'obtainingLeaveDataError': '取得假勤数据错误',
		'theOriginalApplicationLeaveTimeIsTheSame': '新增<%=formsetBasicName%>失败：异动后时间不得与原申请假勤时间相同',
		'pleaseReselectTheLeaveTime': '请重新选择假勤时间',
		'falseAttendanceCalculationError': '假勤计算错误',
		'pleaseSelectTheShiftLeaveItemFirst': '请先选择异动假勤项目',
		'noneMessage': '无 <%=temp1%> <%=temp2%> <%=temp3%>',
		'noneMessageHour': '无 <%=temp1%> <%=temp2%>',
		'falseAttendanceDataError': '假勤数据错误: <%=temp1%>',
		'theStartDateOfTheLeave': '假勤起始日',
		'endOfLeaveDay': '假勤结束日',
		'leaveProject': '假勤项目',
		'leaveDay': '假勤日期',
		'schedulingEmployeesAreNotAllowedToAskForLeave': '新增<%=formsetBasicName%>失败：不需排班员工不可请假',
		'leaveHoursCannotBe0Error': '新增<%=formsetBasicName%>失败：请假合计时数不可为0',
		'attachError': '新增<%=formsetBasicName%>失败：<%=message%>',
		'originalApplicationLeaveTime': '原申请假勤时间',
		'totalHoursOfLeave': '请假合计时数',
		'leaveTimeAfterTheChange': '异动后假勤时间',
		'changeReason': '异动原因',
		'noThisLeaveData': '该公司没有此请假资料',
		'oldTotalLeaveDate': '原请假合计时数',
		'newLeaveDate': '异动后请假合计时数',
		'theTimeOfLeaveAfterThe': '异动后的假勤时间必须在「整体」的出差起讫时间内',
		'changeType': '异动类型',
		'changeableLeaveItem': '可异动假勤项目',
	},
	'hp.m5.m510010.wf090': {
		'attendanceSheetApplicationFailed': '出勤单申请失败',
		'attendanceHoursCheckFailed': '出勤时数检查未过',
		'failedToWriteToAttendanceMasterFile': '写入出勤主档失败',
		'pleaseSelectTheAttendanceTimeFirst': '请先选择出勤时间',
		'otherTimeRequirementLoadingError': '其他出勤时数规定加载错误',
		'pleaseReselectTheAttendanceTime': '请重新选择出勤时间',
		'theActualTimeAndHoursResultOfTheAttendanceHoursRule': '您申请的出勤时间经系统比对出勤数据后，将调整为符合公司出勤时数规则的实际时间与时数结果。',
		'hourCheckError': '时数检查错误',
		'errorReadingAttendanceRules': '读取出勤规则错误',
		'attendancePeriod': '出勤时段',
		'attendanceHours': '出勤时数',
		'actualResultsAdjustedToComplyWithCompanyTimeOfDayRules': '您申请的时数并非为最终结果，尚待系统比对出勤数据后，调整为符合公司出勤时数规则的实际结果。',
		'actualResultsAdjustedToComplyWithCompanyHoursOfAttendanceRules': '已将您申请的时数，调整为符合公司出勤时数规则的实际结果。原申请时间：<%=attendStart%>至<%=attendEnd%>，',
		'attendanceTotalHoursLoadingError': '出勤总计时数加载错误',
		'totalHoursOfAttendance': '出勤总计时数',
		'attendanceHoursStatistics': '出勤时数统计',
		'costCenterItem': '成本中心：<%=name%>，出勤时数<%=hours%>',
		'applicationType': '申请类型',
		'attendanceTime': '出勤时间',
		'attendanceAttributionDate': '出勤归属日',
		'totalAttendanceHours': '出勤合计时数',
		'reasonForAttendance': '出勤原因',
		'typeNoLongerOpen': '已不开放此申请类型',
	},
	'hp.m5.m510010.wf020': {
		'overtimeApplicationFailed': '加班单申请失败',
		'overtimeCheckHasNotPassed': '加班单检查未过',
		'failedToWriteOvertimeMasterFile': '写入加班主档失败',
		'advanceOvertimeHoursLoadingError': '预先加班时间加载错误',
		'errorGettingAdvanceOvertimeHours': '取得预先加班时间错误',
		'withPreAppliedOvertime': '有预先申请加班',
		'actualResultsAdjustedToComplyWithCompanyOvertimeRules': '您申请的时数并非为最终结果，尚待系统比对出勤数据后，调整为符合公司加班规则的实际结果。',
		'totalOvertimeHoursLoadedIncorrectly': '加班总计时数加载错误',
		'totalOvertimeHours': '加班总计时数',
		'overtimeStatistics': '加班统计',
		'actualOvertime': '实际加班时间',
		'totalActualOvertimeHours': '实际加班合计时数',
		'advanceOvertime': '预先加班时间',
		'totalNumberOfOvertimeHoursWorkedInAdvance': '预先加班合计时数',
		'theSelectedAdvanceOvertimePayHas': '员工预先加班单不存在',
		'costCenterItem': '成本中心：<%=name%>，加班费 <%=otName%>，补休假 <%=calName%>',
		'clockInOut': '打卡时间',
		'totalOverTimeApplication': '加班总计时数(不含本次申请)',
		'mailClock': '打卡 ',
	},
	'hp.m5.m510010.wf022': {
		'exchangeMethod': '抵换方式',
		'overtimeCheckHasNotPassed': '加班单检查未过',
		'failedToApplyForPreOvertimeWorkOrder': '预先加班单申请失败',
		'failedToWritePreOvertimeMasterFile': '预先加班单申请失败',
		'appliedHoursWithTheAttendanceDataAgain': '您申请的时数并非最终结果，待申请加班单时，系统将再次比对出勤数据。',
		'overtime': '加班时间',
		'totalOvertimeHours': '加班合计时数',
		'failedToWriteToMasterFileOfPreOvertimeWorkSheet': '写入预先加班单主档失败',
		'deductRestTimeOldInitial': '根据公司规定而决定是否扣除休息时间',
		'deductRestTime': '扣除休息时间',
	},
	'hp.m5.m510010.wf060': {
		'theReasonForTheChangeIsDisabled': '异动原因已停用',
		'theReasonForTheChangeHasBeenDeleted': '异动原因已删除',
		'clockingInAndWorkingOvertimeOn': '工作日打卡转加班',
		'asAReminderIfYouAdjust': '提醒您，若调整职等，也需同步调整职级，避免职级变成空白。',
		'remindYouThatIfYouAdjust': '提醒您，若调整工作区域，也需同步调整工作地点，避免工作地点变成空白。',
		'atLeastOneProjectChange': '至少要有一个项目更动',
		'employeesOnTheDayOfChange': '异动日员工需在职',
		'theChangeProjectHasNotYet': '异动项目有未生效异动',
		'thereAreRelativelyNewChangesIn': '异动项目有较新的已生效异动',
		'ifThereIsALeaveRequest': '生效日以后已有请假数据，班别属性不可异动为不需排班',
		'thePreChangeShiftAndThe': '异动前班别与异动后班别，工作时间重迭，不可储存',
		'ifTheCardComparisonFieldNeeds': '若刷卡比对字段为需比对及产生异常、需比对不须产生异常时，则允许打卡方式字段异动后需有一项为是',
		'theSpecialBreakRuleIsNull': '特休规则异动后为空值',
		'overtimeRulesAreNullAfterChanges': '加班规则异动后为空值',
		'nullValueAfterAChangeIn': '工时规则异动后为空值',
		'theValueIsNullAfterThe': '刷卡比对异动后为空值',
		'theClassAttributeIsNullAfter': '班别属性异动后为空值',
		'theChangeInClassAttributesIs': '班别属性异动为不需排班(依时数申请)，不可设定班别、时段班别规则',
		'theChangeInClassAttributesIsNeedCalendar': '班别属性异动为不需排班(依时数申请)，需设定行事历、特休假规则、出勤时数规则、工作日打卡转加班、加班规则、工时规则',
		'theChangeInClassAttributesIsNotNeedCalendar': '班别属性异动为排班(依时段)，不可设定班别、行事历、出勤时数规则、工作日打卡转加班',
		'theChangeInClassAttributesIsNeedRule': '班别属性异动为排班(依时段)，需设定时段班别规则、特休假规则、加班规则、工时规则',
		'theChangeInClassAttributesIsNotNeedRule': '班别属性异动为排班(依班别)，不可设定班别、行事历、时段班别规则、出勤时数规则、工作日打卡转加班',
		'theChangeInClassAttributesIsNeedAnnual': '班别属性异动为排班(依班别)，需设定特休假规则、加班规则、工时规则',
		'theChangeOfClassAttributesIs': '班别属性异动为固定班，不可设定时段班别规则、出勤时数规则、工作日打卡转加班',
		'theClassAttributeChangeIsA': '班别属性异动为固定班，需设定班别、行事历、特休假规则、加班规则、工时规则',
		'ifTheEmployeeHasInformationOn': '员工有异动生效日之前的未生效留停及离职数据',
		'employeeAttendanceRulesNeedToExist': '<%=temp1%>：员工出勤规则需存在',
		'theNewPersonnelChangeOrderFailed': '新增人事异动单失败',
		'classAttributeChangeIsFixedClass': '<%=temp1%>班别属性异动为固定班，',
		'shiftAttributeChangeToShiftAccording': '<%=temp1%>班别属性异动为排班(依班别)，',
		'shiftAttributeChangeIsScheduledAccording': '<%=temp1%>班别属性异动为排班(依时段)，',
		'classAttributeChangeIsNotRequired': '<%=temp1%>班别属性异动为不需排班(依时数申请)，',
		'specialLeaveRules': '特休假规则',
		'settingsRequired': '需设定',
		'notConfigurable': '不可设定',
		'impeachmentLeaveRules': '弹休假规则',
		'noAttendanceRules': '无出勤规则',
		'selected': '已选<%=temp1%>项',
		'ifTheCalendarTimeBeforeAnd': '异动前后历日时间不同，删除生效日以后的班表资料才可生效此异动',
		'someWorkingHoursDoNotSupport': '部分工时不支援特休预给',
		'changedDescription': '异动说明',
	},
	'hp.m5.m510010.wf070': {
		'effectiveDate': '生效日 <%=date%>',
		'pleaseSelectACostCenter': '请选择成本中心',
		'apportionmentRate': '分摊比率',
		'holiday': '假日',
		'whetherHolidaysArePaid': '假日是否给薪',
		'remindYouThatTheSalaryUnit': '提醒您，计薪单位异动，请注意薪资项目的计算方式与最终金额！',
		'pleaseEnterANumber': '请输入数字',
		'thereIsNoSalaryDataFor': '员工无薪资数据',
		'hourlyEmployeesCannotSetAFull': '时薪员工不可设定全勤奖金',
		'thereAreAlreadyChangesToThe': '已有同一项目且异动生效日同一日的薪资规则异动',
		'theChangeProjectHasMoreInformation': '异动项目有比此笔异动生效日之后的异动数据',
		'thereIsNoEffectiveInformationFor': '异动项目有未生效数据',
		'employeesShouldBeEmployedOnThe': '异动生效日员工应该在职',
		'noSalarySettlementInformationIsAvailable': '异动生效日之后不可有薪资结文件数据',
		'costCenterChangeDataIsAvailable': '已有大于等于此异动生效日的成本中心异动资料',
		'theSumOfTheCostCenter': '成本中心比例总和不为100',
		'salaryCalculationInformationCannotBeAvailable': '异动生效日后不能有薪资计算数据',
		'employeePayRulesNeedToExist': '员工薪资规则需存在',
		'salaryAdjustmentInformationIsAvailableOn': '已有同一异动生效日的调薪资料',
		'addedFailureNoSalaryDataFor': '新增<%=temp1%>失败：员工无薪资数据',
		'costCenterProportionsMustAddUp': '成本中心比例相加需为 100%',
		'addFailurePayrollAccountCurrencyData': '新增<%=temp1%>失败：薪资科目+币别数据不可重复',
		'pleaseSelectTheReasonForThe': '请选择异动原因',
		'noPayrollData': '无薪资资料',
		'amount': '金额',
		'totalNTD': '总计(新台币)',
		'newTaiwanDollar': '新台币',
		'salaryStructure': '薪资结构',
		'payrollItems': '薪资项目',
		'pleaseSelectAReason': '请选择原因',
		'theReasonForTheChangeIsDisabled': ' PM ',
		'theReasonForTheChangeHasBeenDeleted': ' PM ',
		'ruleVars': '计算规则异动资讯',
		'varsCause': '薪资结构核薪原因',
		'structureVars': '薪资结构异动资讯',
		'payAlteredAfter': '异动生效日后已有调薪异动资料',
	},
	'hp.m5.m510010.wf021': {
		'overtimeCheckError': '加班单检查错误：',
		'theFormInformationIsIncomplete': '表单信息不完整',
		'overtimeWorkersDoNotIncludeEmployees': '加班人未包含套用签核流程的员工',
		'thereIsAnErrorInThe': '套用签核流程错误',
		'addANewStroke': '新增一笔',
		'sinceTheOvertimeHoursAreHours': '因加班时数为0小时，无法产生签核流程，请重新选择其他员工',
		'common': '共',
		'totalEmps': '加班共 <%=temp1%> 人',
		'employee': '人',
		'deducted': '扣除休息时间',
		'companyRegulations': '根据公司规定而决定是否扣除休息时间'
	},
	'hp.m5.m510010.wf021_row': {
		'advancedSearch': '进阶搜寻',
		'overtimePayCanOnlyBeClaimed': '仅能申请加班费',
		'youCanOnlyApplyForCompensatory': '仅能申请补休假',
		'overtimePayCompensatoryLeave': '加班费 + 补休假',
		'employeeNumberNameEnglishName': '员工编号/姓名',
		'listOfEmployees': '员工名单',
		'selected': '已选择',
		'importIn': '汇入',
		'bit': '位',
		'ifOvertimeAllowedDuringRest': '若休息时间允许加班',
		'deductedRestPeriods': '休息时间',
	},
	'hp.m5.m510010.wf011': {
		'batchLeaveApplicationIsSuccessful': '批次请假单申请成功',
		'batchLeaveRequestFailed': '批次请假单申请失败',
		'aMaximumOfGroupsCanBe': '假勤最多申请20组',
		'theLeaveApplicantDoesNotInclude': '请假人未包含套用签核流程的员工',
		'sinceTheNumberOfLeaveHours': '因请假时数为0小时，无法产生签核流程，请重新选择其他员工',
		'total': '<%=temp1%> - <%=temp2%> 共<%=temp3%><%=temp4%>',
		'of': '的',
	},
	'hp.m5.Commons': {
		'formNumber': '表单编号：<%=temp1%>',
		'addApproverPrior': '新增我签核前的签核人员',
		'exceedApprovalTimeTitle': '超过可签核时间',
		'overTimeLimitRejection': '因超过可签核时间，仅可驳回表单',
		'pendingAtOthers': '表单正待其他人员签核',
		'overrule': '驳回',
		'rejection': '驳回',
		'reject-pastTense': '驳回',
		'approved': '核准',
		'approval': '核准',
		'signOff': '签核',
		'preSignoff': '预签核',
		'operate': '操作',
		'failure': '<%=temp1%>失败',
		'theFormHasAlreadyBeenSigned': '这张表单已被他人签核，您已无需处理',
		'theFormCannotBeSignedPlease': '表单已无法签核，请确认假勤状态',
		'failure2': '<%=temp1%>失败: <%=temp2%>',
		'oopsThereIsAnAbnormalStatus': 'Oops！请假有异常状态',
		'ifSomeOfTheLeaveIn': '本表单部份假勤有异常状态，您可驳回此张表单，或取消驳回，待数据正确后再核准',
		'oopsThereIsAnAbnormalState': 'Oops！加班有异常状态',
		'ifThereIsAnAbnormalState': '本表单部份加班有异常状态，您可驳回此张表单，或取消驳回，待数据正确后再核准',
		'oopsThereIsAnAbnormalStatus2': 'Oops！薪资异动有异常状态',
		'oopsPersonnelAbnormalStatus': 'Oops！人事异动有异常状态',
		'oopsTheBatchLeaveHasAn': 'Oops！批次请假有异常状态',
		'ifSomeOfTheLeaveRequests': '本表单部份请假有异常状态，您可驳回此张表单，或取消驳回，待数据正确后再核准',
		'oopsBatchOvertimeHasAnAbnormal': 'Oops！批次加班有异常状态',
		'oopsAttendanceAbnormalStatus': 'Oops！出勤<%=temp1%>有异常状态',
		'time': '时段',
		'ifThereIsAnAbnormalStatus': '本表单部份出勤<%=temp1%>有异常状态，您可驳回此张表单，或取消驳回，待数据正确后再核准',
		'oopsThereIsAnAbnormalState3': 'Oops！预先加班有异常状态',
		'theNumberOfApplicationHoursIs': '申请时数有变动',
		'originalApplication': '原申请：',
		'actualApproval': '实际核可：',
		'signoffStatus': '签核状态：',
		'pendingYourSignOff': '待您签核',
		'waitingForYourReply': '待您回复',
		'downloadExceptionError': '下载异常<%=temp1%>错误',
		'list': '名单',
		'information': '信息',
		'theDownloadFormDidNotWork': '下载表单未施作',
		'downloadException': '下载异常<%=temp1%>',
		'yourSignatureResult': '您签核结果:',
		'currentProcessSignOff': '目前流程：签核中',
		'currentProcessApproved': '目前流程：核准',
		'endTheProcess': '结束流程',
		'currentProcessRejection': '目前流程：驳回',
		'currentProcessLottery': '目前流程：抽单',
		'currentProcessDeleteTheOrder': '目前流程：删单',
		'mainBusinessContractors': '业务主要承办人：',
		'contractorPhone': '承办人电话：',
		'drawOrders': '抽单',
		'deleteAList': '删单',
		'unarchive': '取消封存',
		'approved2': '已核准',
		'batchTempCompleted': '批次<%=temp1%>完成',
		'oopsNoneOfThemCanBe': 'Oops ! 全部无法签核',
		'approvedTemp': '已核准<%=temp1%>笔',
		'personnelRepeatsTempPen': '人员重复<%=temp1%>笔',
		'reselect': '重新选择',
		'iKnow': '我知道了',
		'skipAndProceedWithSignOff': '略过，继续签核',
		'restAssuredThatOtherFormsHave': '请放心，其他表单已核准',
		'youChoseForm': '你选取了<%=temp1%>张表单',
		'approvalSignOffComplete': '核准 > 签核完成',
		'signOffOnComments': '签核意见',
		'sign': '会签',
		'pleaseSelectTheCountersigner': '请选择会签人员',
		'pleaseSelectAPersonWhoAsked': '请选择询问意见人员',
		'syncNotificationsCheckable': '同步通知(可复选)',
		'selectSyncNotifiers': '请选择同步通知人员',
		'ifYouDoNotNeedTo': '若您不须新增，可直接确认<%=temp1%>',
		'allTemp': '全部<%=temp1%>',
		'pen': '已<%=temp1%><%=temp2%>笔',
		'restAssuredThatTheOtherForms': '请放心，其他表单已<%=temp1%>',
		'oopsAllCannotBe': '全部无法<%=temp1%>',
		'processedPens': '已处理<%=temp1%>笔',
		'restAssuredThatOtherFormsHave2': '请放心，其他表单已处理',
		'cause': '<%=temp1%>原因',
		'repeatSignOff': '重复签核',
		'inAdditionThisFormHasAlready': '另外这<%=temp1%>笔表单已被他人签核，所以您已无需处理',
		'inAdditionThisFormHasAlready2': '另外这 <%=temp1%> 笔表单已完成签核流程，所以您已无需处理',
		'duplicationOfPersonnel': '人员重复',
		'thePersonYouSelectedIsAlready': '您选取的人员已为签核 / 意见回复者 / 申请人，请重新选择或是继续签核其他表单',
		'thePersonYouSelectedIsAlready2': '您选取的人员已为签核 / 意见回复者 / 申请人',
		'hasServedAsASignator': '已担任签核者',
		'thoseWhoHaveRespondedToComments': '已担任意见回复者',
		'isAFormApplicant': '为表单申请人',
		'unableToSignOff': '无法签核',
		'inAdditionThisFormCannotBe': '另外这<%=temp1%>笔表单无法签核',
		'inAdditionThisFormCannotBe2': '另外这 <%=temp1%> 笔表单因如下原因无法签核',
		'cannotSignOffTheseAs': '另外这 <%=count%> 笔表单不可<%=action%>',
		'restrictCountersignTitle': '无法使用会签功能',
		'restrictCountersignMsg': '所选表单仅具备核准权限，无法使用会签功能',
		'restrictAskMsg': '所选表单仅具备核准权限，无法使用询问意见功能',
		'systemError': '系统错误',
		'theAskForOpinionFeatureIs': '无法使用询问意见功能',
		'theSelectedWindowSheetIsThe': '所选表单为最后一关，无法使用询问意见功能',
		'theFormHasRespondedToComments': '表单已回复意见',
		'theSignOffProcessHasEnded': '签核流程已结束，无法回复',
		'respondToComments': '回复意见',
		'opinion': '意见',
		'enterYourOpinionUpToWords': '输入意见，最多100字',
		'youHaveAlreadyServedAsA': '已担任签核人，请重新选择',
		'alreadyAResponderToTheOpinion': '已经是意见回复者，请重新选择',
		'confirmTheAddition': '确认新增',
		'completeTheAdditionOfPreSigners': '完成新增预签核人',
		'thisFunctionIsToAddA': '这个功能是在您签核【前】，新增一位签核人来审批表单，<%=temp1%>您必须等待该签核人的签核结果，才能继续审批流程。',
		'pleaseSelectASignOff': '请选择签核人员',
		'ifYouDoNotNeedTo2': '若您不须新增，可直接确认驳回',
		'confirmTheRejection2': '确认驳回',
		'rejected': '已驳回',
		'ifYouDoNotNeedTo3': '若您不须新增，可直接确认核准',
		'confirmApproval': '确认核准',
		'askForOpinions': '询问意见',
		'endProcess': '结束流程<%=temp1%>',
		'applied': '已申请',
		'toBeSigned': '待签核',
		'replied': '已回复',
		'toBeReplied': '待回复',
		'pleaseEnterAReason': '请输入原因',
		'cause2': '原因：',
		'cause3': '原因',
		'opinion2': '意见：',
		'theChangeOfSignOffWas': '更改签核人成功',
		'noNewSignOffIsSelected': '未选择新签核人',
		'forFormApplicantsPleaseSelectAgain': '为表单申请人，请重新选择',
		'noChangeInSignOff': '没有更改签核人',
		'changeTheSignoffper': '更改签核人',
		'formNumber2': '表单编号：',
		'raw': '原始',
		'change': '更改',
		'systemExceptionDataWriteFailed': '(系统异常，数据写入失败)',
		'theCounterSignerAndThePerson': '会签人员与询问意见人员不可相同',
		'addSignOffFormer': '新增签核人* (前)',
		'theRemainingWereNotSigned': '尚有 <%=temp1%> 笔表单未签核，请重新选择',
		'ifSomeOfTheAbnormalItems': '本表单部分异动项目有异常状态，您可驳回此张表单，或取消驳回，待资料正确后再核准',
		'notified': '已通知',
		'notNotified': '待通知',
		'changed': '更改签核人',
		'viewChanged': '查看调整',
		'notifiedCkpDesc': '通知对象',
		'sysSigned': '系统代签',
		'flowEnd': '结束',
		'agent': '代理人',
		'changeSignerFail': '更改签核人失败',
		'signersLostSync': '签核人信息已更新，请重新整理后再试一次',
		'duplicatedOldEmp': '同一关的原签核人员不可重复，请重新选择',
		'duplicatedNewEmp': '同一关卡已有相同的签核人员，请确认是否更改。',
		'oldSigner': '原签核人员',
		'newSigner': '新签核人员',
		'oldSigner2': '原签核人',
		'newSigner2': '新签核人',
		'changer2': '更改人',
		'changeTime2': '更改时间',
		'notifyTime': '通知时间',
		'notifiedEmp': '被通知人',
		'downloadSummaryTable': '下载总表',
		'downloadForm': '下载窗体',
		'downloadTime': '下载时间：',
		'systemAnomaly': '(系統異常)',
		'person': '主要承办人',
		'personTel': '主要承办人电话',
		'latestTime': '最后处理时间',
		'formNo': '表单编号',
		'downloadTime2': '下载时间',
		'onlyApprove': '仅核准',
		'oopsFormId17Title': 'Oops！表单有异常状态',
		'oopsFormId17Msg': '本表单部分时间有异常状态，您可驳回此张表单，或取消驳回，待数据正确后再核准',
		'isMultiTip3': '需全员核准',
		'isMultiTip4': '仅需一人核准',
		'oopsCancelLeaveAnAbnormalStatus': 'Oops！销假有异常状态',
		'ifCancelLeaveTheAbnormalItems': '本窗体有异常状态，您可驳回此张窗体，或取消驳回，待数据正确后再核准',
		'systemReject': '（系统驳回）',
	},
	'hp.m5.Commons,Decision.Footer': {
		'approve': '核准中',
		'reject': '驳回中',
		'terminate': '抽单中',
		'delete': '删单中',
	},
	'hp.m5.Commons.Decision.Mail': {
		// 'title': '(CN)簽核中...',
		'signingOffMsg': '签核中，请稍候…',
		'signOffConfirmMsg': '请确定是否要<%=action%>？',
		'confirmBtn': '确定',
		'cancelBtn': '取消',
		'cancelledMsg': '已取消，未送出签核',
		'notExist': '查无窗体数据',
		'beWithdrawn': '窗体已被抽单',
		'beDeleted': '窗体已被删单',
		'beSignedOff': '窗体已被签核',
		'cannotSignOff': '无法签核，请查看窗体信息',
		'signOffSuccess': '核准成功',
		'rejectSuccess': '驳回成功',
	},
	'hp.m5.m510010.index': {
		'profileLoadingError': '个人资料加载错误',
		'unableToApply': '无法申请',
		'youDonTCurrentlyHaveA': '您目前没有可申请的表单',
		'theAdditionSuccess': '新增<%=temp1%>成功',
		'theNewFailed': '新增<%=temp1%>失败',
		'toFindOutPleaseProceedWith': '了解，请继续申请',
		'returnToRefill': '返回重填',
		'leaveHoursCanBeRequested': '可申请假勤时数',
		'leaveStatistics': '假勤统计',
		'generalLeaveWork': '一般假勤',
		'noUpperLimit': '无上限',
		'compensatoryLeave': '补休',
		'elasticFake': '弹性假',
		'secondary': '次',
	},
	'components.AttachFile': {
		'unableToUploadExecutableFileE': '不能上传执行档，',
		'maximumFileSizeMB': '档案大小上限 3MB',
		'filesExceedTheLimitOfMB': '档案超过上限 3 MB',
		'unsupportedFileTypes': '不支援的档案类型',
		'pleaseSelectAtLeastFiles': '请选择至少 <%=temp1%> 个档案!',
		'theFileNameCannotContainSpecial': '档案名称不可包含特殊字元 <%=temp1%>',
		'fileSizeExceedsLimit': ' 档案大小超过限制!',
		'uploadFailed': '上传失败!<%=temp1%>',
		'deleteFailed': '删除失败!',
		'noFileSelected': '没有选择档案!',
		'uploadTheFile': '上传档案',
	},
	'hp.m5.commonsDetail': {
		'applicationTime': '申请时间',
		'costCenter': '成本中心',
		'overtimeCategory': '加班类别',
		'overtimePeriod': '加班时段',
		'workOvertime': '加班',
		'overtime': '加班时间',
		'hours': '时数',
		'waysOfWorkingOvertime': '加班抵换方式',
		'support': '支领',
		'missedMealFee': '误餐费',
		'payForMissedMeals': '支领误餐费',
		'reasonForOvertime': '加班原因',
		'failedToLoadJudgmentCardSwipingTimeSetting': '加载判断刷卡时间设定失败',
		'theDayTheEventOccurred': '事件发生日',
		'theReasonForTheDayThe': '事件发生日原因',
		'timeOff': '假勤时间',
		'leaveDate': '请假日期',
		'jobAgent': '职务代理人',
		'signOffAgent': '签核代理人',
		'reasonForTakingLeave': '请假原因',
		'contentOfTheApplication': '申请内容',
		'leavePerson': '请假人',
		'overtimers': '加班人',
		'costCenterByEmployeePayroll': '依员工薪资成本中心',
		'reasonsForTheWriteOff': '销假原因',
		'holidayTemp': '假日<%=temp1%>',
		'totalSalary': '总薪资',
		'totalItems': '共<%=temp1%>项',
		'shift': '班别',
		'formNo': '申请单编号',
		'shiftAdjustmentTime': '调班时间',
	},
	'hp.service.m5.service-m510010_wf010': {
		'err490': '尚未设定系统串接栏位',
		'err490Last': '尚未设定系统串接栏位，无法回抛资料',
		'err491': '未产生签核流程，无法启动表单',
		'err492': '写入表单失败',
		'err493': '附件写入错误',
		'err494': '写入假勤主档失败',
		'err498': '申请假勤失败 (其他原因)',
		'err499': '加扣项科目不存在',
		'err500': '加扣期间员工未到职',
		'err501': '加扣金额必须大于 1',
		'err502': '加扣币别不存在',
		'err503': '加扣金额最多小数点后 X 位',
		'err504': '成本中心归属方式不存在',
		'err505': '成本中心不存在',
		'err506': '成本中心若为「按员工薪资成本中心」，无需填写成本中心及分摊金额',
		'err507': '成本中心若为「自定义成本中心」，成本中心及分摊金额为必填',
		'err508': '分攤成本最多小数点后 X 位',
		'err509': '分摊金额加总需等于加扣金额',
		'err510': '特休假名称不存在',
		'err511': '特休假已停用',
		'err512': '特休年度不存在',
		'err513': '特休例外人员结转设置年度假勤重复',
		'err514': '该年度假勤已结转',
		'err515': 'X 年度无特休假',
		'err516': '结转方式不存在',
		'err517': '优先处理不存在',
		'err518': '所选择的结转方式与优先处理字段的必填状态无法对应',
		'err519': '结转后期限不存在',
		'err520': '结转后期限若为「于下一特休假年度均可休」，无需填写天数及日期',
		'err521': '结转后期限若为「于下一特休假年度 X 天内休完」，天数为必填，且无需填写日期',
		'err522': '结转后期限若为「于下一特休假年度 MM/DD 内休完」，日期为必填，且无需填写天数',
		'err523': '天数仅可为正整数',
		'err524': '天数必须为大于等于 1 的正整数',
		'err525': '天数必须为小于等于 99 的正整数',
		'err526': '日期格式不正确',
		'err527': '最多 500 个字符',
		'err528': '最多可上传5个文件',
		'err529': '成本中心重复',
		'err530': '档案超过上限 3 MB',

	},
	'hp.service.m5.service-m510010_wf021': {
		'theBatchOvertimeOrderApplicationWas': '批次加班单申请成功',
	},
	'hp.m5.m510010.wf011_row': {
		'bit': '位',
	},
	'app.api.wf.api-wf040': {
		'employeesWhoDoNotNeedTo': '不需排班员工不可请假',
	},
	'hp.service.m5.service-m510010_wf060': {
		'thereAreNoChangesInPersonnel': '人事异动项目有未生效异动',
		'thereAreRelativelyNewChangesIn': '人事异动项目有较新的已生效异动',
		'notInEffect': '未生效',
	},
	'hp.m4.m410120': {
		'changeTheAccountID': '变更账号ID',
		'changeTheLoginPassword': '变更登入密码',
		'changeThePaybagPassword': '变更薪资袋密码',
		'changeThePasswordWhenLoggingIn': '变更登入系统时的密码。',
		'payrollBag': '薪资袋',
		'pleaseBeAssuredThatThisIs': '请放心，这是变更电子薪资袋的密码，与登入时的密码并不相同。',
		'identifyTheChange': '确定变更',
		'theAccountIDHasBeenChanged': '账号ID变更成功',
		'theAccountIDWasChangedIncorrectly': '账号ID变更错误',
		'theOriginalAccountIDIsInconsistent': '原账号ID不一致',
		'accountDataDoesNotExist': '账号数据不存在',
		'theNewAccountIDIsThe': '新账号ID与旧帐号ID相同',
		'enterTheSameIDAsThe': '输入的原账号ID与新账号ID相同',
		'originalAccountNumber': '原账号',
		'newAccount': '新账号',
		'pleaseEnterANewAccountNumber': '请输入新账号',
		'theLoginPasswordWasChangedSuccessfully': '变更登入密码成功',
		'failedToChangeLoginPassword': '变更登入密码失败',
		'theOldPasswordWasEnteredIncorrectly': '旧密码输入错误',
		'theOldAndNewPasswordsCannot': '新旧密码不可以一样，请确认',
		'theNewPasswordIsInconsistentPlease': '新密码不一致，请确认',
		'originalPassword': '原<%=temp1%>密码',
		'newPassword': '新<%=temp1%>密码',
		'thePayrollBagPasswordWasChanged': '变更薪资袋密码成功',
		'failedToChangePayrollBagPassword': '变更薪资袋密码失败',
		'theApplicationDoesNotExist': '应用程序不存在',
		'theEmployeePaybagPasswordInformationDoes': '员工薪资袋密码数据不存在',
		'thePayrollBagPasswordStatusIs': '薪资袋密码状态错误',
		'payrollBagPasswordToBeEnabled': '薪资袋密码待启用',
		'thePayrollBagPasswordIsLocked': '薪资袋密码已锁定',
		'thePaybagPasswordHasBeenDeactivated': '薪资袋密码已停用',
		'enteredTooManyTimesByError': '输入太多次错误:账号已被锁定',
		'thePasswordWasChangedSuccessfully': '密码变更成功',
		'textAndNumberCheck': '文数字检查',
		'thePasswordMustBeCheckedFor': '密码需有特殊符号检查错误',
		'theOldAndNewPasswordsCannot2': '新旧密码不可以一样',
		'changeTheEmailLanguage': '变更邮件语系',
		'theUserLanguageFamilyWasModified': '邮件语系变更成功',
		'failedToModifyUserLanguage': '邮件语系变更失败',
		'mailLanguage': '邮件语系',
		'dataNotModified': '未修改资料',
		'languageDataError': '语系资料错误',
	},
	'hp.m4.m410121': {
		'filledIllustrate1': '如果您有多种通勤方式，请填写从家到办公室【最主要】的通勤方式。不需要考虑客户拜访行程的通勤方式。',
		'filledIllustrate2': '',
		'transName': '交通工具',
		'commuteStloc': '出发地',
		'commuteDsloc': '目的地',
		'commuteKM': '里程',
		'fillSelectedAddress': '请输入地址后从下拉菜单中选择正确地址',
		'GPSCoordinate': 'GPS 坐标',
		'add': '新增',
		'save': '保存',
		'showMap': '显示地图',
		'hideeMap': '关闭地图',
		'km': '公里',
		'lastSave': '最后保存时间：',
		'saveSuccessfully': '保存成功',
		'dataIsNotEdited': '数据未变更',
		'stlocAndDslocCanNotBeSame': '里程不能为 "0"，请调整交通工具的出发地和目的地',
		'selectTaichungStation': '请选择台中捷运车站',
		'selectTaipeiStation': '请选择台北捷运车站',
		'selectTaoyuanStation': '请选择桃园捷运车站',
		'selectHighSpeedStatsion': '请选择高铁车站',
		'requiredField': '必填字段',
		'serialNumber': '序号'
	},
	'wf.normal': {
		'waitingForApproval': '等待人员签核中...',
		'approvalCompleted': '签核完毕',
		'formHasBeenSigned': '表单已被他人签核',
		'formInAccess': '(CN)其它使用者正在簽核此表單，請稍後重試',
	},
	'wf.service.wf010': {
		'noThisForm': '查无此表单',
		'noThisLeave': '查无假勤资料',
		'cannotVerifyHour': '无法检查时数',
	},
	'app.api.wf.api-global': {
		'getWFReqBasic.404': '无法操作此表单',
		'isCalOrClose1': '假勤可能已计算或结档',
		'isCalOrClose2': '假勤可能已销假、计算或结档',
		'noOneNeedsToSignOff': '无人需签核',
	},
	'app.api.wf.api-wf010': {
		'noLimit': '无上限',
		'used': '已休',
		'remains': '尚可申请',
	},
	'app.api.wf.api-wf030': {
		'empNotWorking': '该日期此员工不在职',
		'FutureDateNotAllowed': '不可选择未来时间',
		'TheApplicationTimeIsDuplicate': '申请时间不可重复',
		'TheApplicationTimeIsDuplicate2': '已有相同打卡时间',
		'reachForgetCheckinLimit': '超过忘刷次数上限',
		'noFlowNoForm': '未产生签核流程，无法启动表单',
	},
	'app.api.wf.api-wf020': {
		'pleaseUpgradeToTheLatestVersionOfAPP': '请升级至APP最新版本后，才可申请加班单',
		'overtimeHoursAndInconsistentCostCenterAllocation': '加班抵换方式的加班费时数与成本中心分摊不一致',
		'hoursOfCompensatoryLeaveAndInconsistentCostCenterAllocation': '加班抵换方式的补休假时数与成本中心分摊不一致',
		'overtimeTotalHoursIsInconsistentCostCenterAllocation': '加班抵换方式的总合计时数与成本中心分摊不一致',
		'overtimePayAndCompensatoryLeaveFor': '成本中心的加班费及补休假不可同时为 0',
	},
	'components.HP': {
		'arrivalDate': '到职日',
	},
	'hp.service.service-am-utils': {
		'processed': '已处理',
		'work': '上班',
		'offWork': '下班',
		'overtimeTempBegins': '加班(<%=temp1%>)开始',
		'overtimeBegins': '加班开始',
		'overtimeTempEnds': '加班(<%=temp1%>)结束',
		'endOfOvertime': '加班结束',
		'restTempGoOut': '休息(<%=temp1%>)外出',
		'restAndGoOut': '休息外出',
		'restTempReturns': '休息(<%=temp1%>)返回',
		'restBack': '休息返回',
		'takeLeaveTempToGoOut': '请假(<%=temp1%>)外出',
		'takeTimeOffWorkToGo': '请假外出',
		'leaveTempIsReturned': '请假(<%=temp1%>)返回',
		'leaveToReturn': '请假返回',
		'testTest': '测试测试',
	},
	'hp.m5.m510030': {
		'pleaseSelectACompany': '请选择公司',
		'formName': '表单名称',
		'search': '搜寻',
		'searchForTheApplicantOrForm': '申请人/被异动人/表单编号',
		'batchApproval': '批次核准',
		'lotRejection': '批次驳回',
		'penSelected': '已选取<%=temp1%>笔',
		'formNumber': '表单编号',
		'summaryInformation': '摘要信息',
		'signoffAgent': '签核代理：<%=temp1%>',
		'dedcutedRestTime': '若休息时间允许加班，扣除休息时间',
		'notDedcutedRestTime': '若休息时间允许加班，不扣除休息时间'
	},
	'hp.m5.m510031': {
		'signOffOnTheResults': '签核结果',
		'commentsHaveBeenRepliedTo': '已回复意见',
		'noResponse': '无回复意见',
		'agentSignOff': '代理人签核',
		'formSignOffStatus': '状态',
		'completed': '已完成',
		'terminated': '已终止',
		'otherLevelsAreSignedOff': '其他关卡签核中',
		'signoffTime': '签核时间',
		'whenYouSignOff': '您签核时间',
		'youSignOffOnTheResults': '您签核结果',
		'overrule': '驳回',
		'approved': '核准',
	},
	'app.api.wf.api-wf060': {
		'retiredOrganizationalCategoriesDepartmentsCannotBe': '已停用的组织类别，不可异动部门',
	},
	'app.service.wf.service-wf060': {
		'theChangeOfClassAttributesIs': '班别属性异动为固定班，',
		'theChangeInClassAttributesIs': '班别属性异动为排班(依班别)，',
		'theChangeInClassAttributesIsection': '班别属性异动为排班(依时段)，',
		'needsToBeSet': '<%=temp1%>需设定<%=temp2%>',
		'cannotBeSet': '<%=temp1%>不可设定<%=temp2%>',
		'classAttributeChangeIsNotRequired': '班别属性异动为不需排班(依时数申请)，',
		'attachEdError': '附文件写入人事资料失败',
		'attachPbError': '附文件写入出勤资料失败',
	},
	'app.api.wf.api-wf070': {
		'salaryAccountCurrencyDataIsNot': '薪资科目+币别数据不可重复',
		'attachError': '附文件写入薪资资料失败',
	},
	'hp.service.m5.service-global': {
		'signOffSignoff': '代<%=temp1%>签核',
		'signatureResult': '<%=temp%>代签-<%=result%>',
		'notAnApplicantOrProcessorWith': '非「申请者」或是「有编辑权限的处理人」',
		'hasBeenDrawnBySomeoneElse': '已被他人抽单',
		'hasBeenDeletedByOthers': '已被他人删单',
		'hasBeenSignedOffBySomeone': '已被他人签核',
		'theFormStatusIsNotSignoff': '表单状态非签核中',
		'formNumberFailedToDelete': '表单编号：<%=temp1%> 删除失败',
		'unableToDeleteOrder': '无法删单',
		'systemDetectsTheCauseOfAnomaly': '系统判断异常原因',
		'attendanceTime': '出勤申请时间',
		'anomalousData': '异常名单',
	},
	'app.api.wf.api-track': {
		'thereIsNoSuchForm': '无此表单',
		'theFormCannotBeResent': '无法重送表单',
	},
	'wf.service.wf011': {
		'failedToDeleteBatchesOfLeaveRequests': '批次请假单删除失败，',
	},
	'wf.service.wf020': {
		'theOvertimeCategoryIsInconsistentAfterTheCreditCardInformationIsAdjusted': '刷卡数据调整后之加班类别与起单之加班类别不一致',
		'theAllocationAfterTheTransactionIsInconsistent': '异动后的加班/补休时数和成本中心分摊不一致',
		'inconsistentCardInformationAfterAdjustment': '刷卡数据调整后之加班类别与起单之加班类别不一致',
	},
	'wf.api.wf021': {
		'new.err495': '单张表单的加班组数不可超过10组',
		'new.err496': '单张表单的加班总人数不可超过100人',
	},
	'wf.service.wf021': {
		'failedToDeleteBatchesOfOvertimeOrders': '批次加班单删除失败，',
		'zeroOverTime': '因加班时数为0小时，无法产生签核流程，请重新选择其他员工',
		'totally': '共',
	},
	'wf.service.wf040': {
		'noThisForm': '查无此表单',
		'employeesWhoDoNotNeedTo': '不需排班员工不可请假',
	},
	'wf.service.wf064': {
		'nonEffectiveResignationJob': '尚有未生效的离职作业',
		'theResignationDateMustBeGreaterThanTheStayEffectiveDate': '离职生效日必需大于留停作业生效日',
		'theLeavingDateMustBeGreaterThanTheStartingDate': '离职生效日必需大于等于到职日',
	},
	'wf.service.wf065': {
		'thereArePendingStayOperations': '尚有未生效的留停作业',
		'thereArePendingReinstatementOperations': '尚有未生效的复职作业',
		'noReinstatementOperations': '未有复职作业',
		'theStayDateMustBeGreaterThanTheDutyDate': '留停生效日必需大于等于到职日',
		'theStayDateMustBeGreaterThanTheLastReinstatementDate': '留停生效日必需大于等于上次复职日',
		'effectiveDateOfStayAndStayYypeCannotBeRepeated': '留停生效日+留停类型不可重复',
	},
	'h2.service.am.attend': {
		'totalCountOIs0': '合计时数为0',
	},
	'hp.H2Inputs': {
		'laborInsuranceInsuredUnits': '劳保投保单位',
		'healthInsuranceInsuredUnits': '健保投保单位',
		'departmentalLevel': '部门层级',
	},
	'sp.wf020.am.emp.ot.check': {
		'code01': '该日期此员工不在职或无班别时间数据',
		'code11': '该公司没有此员工',
		'code12': '该公司没有此加班类别',
		'code13': '无法读取加班参数',
		'code14': '加班区间早于系统最早假勤日期',
		'code15': '加班区间晚于系统最晚假勤日期',
		'code16': '加班区间超出加班申请期限',
		'code17': '加班区间没有特休假勤',
		'code18': 'HR未开放该加班时段',
		'code19type1': '在职状态为未到职',
		'code19type2': '在职状态为留职停薪',
		'code19type3': '在职状态为离职',
		'code20': '加班区间不可申请加班',
		'code21': '加班区间超过可加班时间',
		'code22': '加班区间为禁止加班时间',
		'code23': '加班不能与其他项目重复',
		'code24': '需要提供附件',
		'code25': '加班必须事先申请',
		'code26': '加班须在加班事实发生后<%=A%>天内申请完',
		'code27': '需要填写加班原因',
		'code28': '加班时数小于最少单位',
		'code29': '加班时数大于最多单位',
		'code30': '该行事历不可加班',
		'code31': '合计时数不可以为0',
		'code32': '加班已结算',
		'code33': '加班区间不在加班归属日内',
		'code34': '此员工不属于此加班折换方式适用对象',
		'code35': '加班数据不存在',
		'code36': '加班申请规则错误',
		'code37': '加班不允许事先申请',
		'code38': '不需排班员工不可折换补休',
		'code39': '预先加班单为必填',
		'code40': '员工预先加班单不存在',
		'code41': '实际加班时间未落于预先加班时间内',
		'code42': '加班需在加班开始前申请完成',
		'code42type1': '加班需在 加班开始前<%=A%>工作日 申请 完',
		'code42type2': '加班需在 加班开始前<%=A%>工作日 签核 完',
		'code42type3': '加班需在 加班结束后<%=A%>工作日 申请 完',
		'code42type4': '加班需在 加班结束后<%=A%>工作日 签核 完',
		'code42type5': '加班需在 加班开始前<%=A%>历日 申请 完',
		'code42type6': '加班需在 加班开始前<%=A%>历日 签核 完',
		'code42type7': '加班需在 加班结束后<%=A%>历日 申请 完',
		'code42type8': '加班需在 加班结束后<%=A%>历日 签核 完',
		'code42type9': '加班需在 加班开始前<%=A%>小时 申请 完',
		'code42type10': '加班需在 加班开始前<%=A%>小时 签核 完',
		'code42type11': '加班需在 加班结束后<%=A%>小时 申请 完',
		'code42type12': '加班需在 加班结束后<%=A%>小时 签核 完',
		'code43': '加班不允许预先申请',
		'code90': '重新计算加班时数与成本中心分摊不一致',
		'code91': '加班抵换方式有变动',
		'code44': '有签核中的调班单',
	},
	'sp.wf020.am.emp.ot.checkDelete': {
		'code11': '加班已结算',
		'code12': '加班已取消',
		'code13': '员工加班换补休数据文件已结算',
		'code14': '员工加班换补休数据文件已使用',
		'code15': '加班数据不存在',
	},
	'sp.wf010.am.emp.leave.check': {
		'code11': '该公司没有此员工',
		'code12': '该公司没有此加班类别',
		'code13': '请假区间内不在职',
		'code14': '员工不适用此假勤项目',
		'code15': '无法读取假勤参数',
		'code16': '假勤区间早于系统最早假勤日期',
		'code17': '假勤区间晚于系统最晚假勤日期',
		'code18': '假勤区间超出假勤申请期限',
		'code19': '尚有前置假剩余时数',
		'code20': '假勤不能与其他项目重复',
		'code21': '假勤不允许事后申请',
		'code22': '假勤必须在实际发生后<%=A%>天内申请完',
		'code23': '需要有请假代理人',
		'code24': '需要填写请假原因',
		'code25': '需要提供附件',
		'code26': '剩余时数小于最小单位',
		'code27': '试用期满日后才能申请',
		'code28': '生日当月才能申请',
		'code29': '生日当日才能申请',
		'code30': '请假时数小于最少请假单位',
		'code31': '请假时数大于最多请假单位',
		'code32': '合并其他请假时数超过上限',
		'code33': '合并其他请假次数超过上限',
		'code34': '剩余时数不足',
		'code35': '合计时数不可以为0',
		'code36': '假勤已销假',
		'code37': '假勤已结算或薪资已结档',
		'code38': '职务代理人不存在或不在职',
		'code39': '超过可休区间',
		'code40': '无<%=A%>可休时数',
		'code41': '部分工时员工无<%=A%>可休时数',
		'code42': '员工请假主档不存在',
		'code43': '事件发生日未设定',
		'code44': '请假区间与加班区间重复',
		'code45': '特休资料已结算',
		'code46': '补休资料已结算',
		'code47': '弹性假数据已结算',
		'code48': '同天多班别者,不能请假勤为 "上下半天规则" 的假勤',
		'code49': '不需排班员工不可申请请假时段',
		'code50': '职务代理人已请假',
		'code51': '部分或全部的假勤时间已担任其他同仁的职务代理人',
		'code52': '不可同时担任多位员工的代理人',
		'code53': '该行事历别不可代理他人',
		'code54': '代理他人期间不可请假',
		'code55': '事件发生日资料不存在',
		'code56': '事件发生日与说明与其它假勤资料重复',
		'code57': '假勤截止日不可小于该笔最大结档日',
		'code58': '可休时数大于全时劳工',
		'code70': '代理人不在职务代理人清单中',
		'code71': '有签核中的调班单',
	},
	'sp.wf010.am.emp.leave.checkByHour': {
		'code11': '该公司没有此员工',
		'code12': '该公司没有此加班类别',
		'code13': '请假区间内不在职',
		'code14': '员工不适用此假勤项目',
		'code15': '无法读取假勤参数',
		'code16': '假勤区间早于系统最早假勤日期',
		'code17': '假勤区间晚于系统最晚假勤日期',
		'code18': '假勤区间超出假勤申请期限',
		'code20': '假勤项目及日期重复',
		'code21': '假勤不允许事后申请',
		'code22': '假勤必须在实际发生后<%=A%>天内申请完',
		'code23': '需要有请假代理人',
		'code24': '需要填写请假原因',
		'code25': '需要提供附件',
		'code31': '请假时数大于最多请假单位',
		'code32': '合并其他请假时数超过上限',
		'code33': '合并其他请假次数超过上限',
		'code34': '剩余时数不足',
		'code35': '合计时数不可以为0',
		'code37': '假勤已结算或薪资已结档',
		'code38': '职务代理人不存在或不在职',
		'code39': '超过可休区间',
		'code40': '无<%=A%>可休时数',
		'code41': '部分工时员工无<%=A%>可休时数',
		'code42': '员工请假主档不存在',
		'code43': '事件发生日未设定',
		'code44': '事件发生日资料不存在',
		'code45': '特休资料已结算',
		'code46': '补休资料已结算',
		'code47': '弹性假数据已结算',
		'code48': '请假时数+出勤时数不可超过 24 小时',
		'code50': '职务代理人已请假',
		'code51': '部分或全部的假勤时间已担任其他同仁的职务代理人',
		'code52': '不可同时担任多位员工的代理人',
		'code53': '该行事历别不可代理他人',
		'code54': '代理他人期间不可请假',
		'code56': '事件发生日与说明与其它假勤资料重复',
		'code60': '需要填写班别',
		'code61': '班别已停用',
		'code62': '不需排班员工不可填写班别',
		'code71': '有签核中的调班单',
	},
	'sp.wf010.am.emp.leave.checkDelete': {
		'code11': '假勤已结算',
		'code12': '假勤已销假',
		'code13': '员工特休数据已结算 ( 上期 )',
		'code14': '员工特休数据已结算 ( 本期 )',
		'code15': '员工补休数据已结算',
		'code16': '员工弹休数据已结算',
		'code21': '请假主档ID错误',
	},
	'sp.wf010.am.emp.biz.checkDelete': {
		'code21': '出差主档ID错误',
	},
	'sp.wf050.am.emp.leave.cancel.check': {
		'code11': '该公司没有此员工',
		'code12': '该公司没有此请假资料',
		'code13': '销假区间超出销假申请期限',
		'code14': '行事历已经变更',
		'code15': '没有足够的销假时数',
		'code16': '销假期间重复',
		'code17': '该销假假勤为其他申请假勤的前置假',
		'code18': '销假时数小于最少请假单位',
		'code19': '合计时数不可以为0',
		'code20': '销假已结算',
		'code21': '请假时数大于剩余时数',
		'code22': '销假期间必须在请假期间的范围内',
		'code23': '员工特休数据已结算 ( 上期 )',
		'code24': '员工特休数据已结算 ( 本期 )',
		'code25': '员工补休数据已结算',
		'code26': '员工弹休数据已结算',
		'code27': '没有该日期区间的请假数据',
		'code28': '销假主档不存在',
		'code29': '请假资料在途中',
		'code30': '假勤已结算',
		'code31': '请假已计薪',
		'code32': '因假勤单位异动，销假时数大于请假时数',
		'code33': '已有特休加班资料',
		'code35': '工作时间已经异动',
		'codeL19': '尚有前置假剩余时数',
		'codeL20': '假勤不能与其他项目重复',
		'codeL32': '合并其他请假时数超过上限',
		'codeL33': '合并其他请假次数超过上限',
		'codeL44': '请假区间与加班区间重复',
	},
	'sp.wf050.am.emp.leave.cancel.checkDelete': {
		'code11': '销假已结算',
		'code12': '员工特休数据已结算 ( 上期 )',
		'code13': '员工特休数据已结算 ( 本期 )',
		'code14': '员工补休数据已结算',
		'code15': '员工弹休数据已结算',
		'code21': '请假主档ID错误',
		'code22': '员工销假主档ID错误',
		'code23': '请假已结算',
		'codeL19': '尚有前置假剩余时数',
		'codeL20': '假勤不能与其他项目重复',
		'codeL32': '合并其他请假时数超过上限',
		'codeL33': '合并其他请假次数超过上限',
		'codeL44': '请假区间与加班区间重复',
		'codeL34': '剩余时数不足',
		'codeL40': '无<%=A%>可休时数',
	},
	'sp.wf022.am.emp.preot.check': {
		'code01': '该日期此员工不在职或无班别时间数据',
		'code11': '该公司没有此员工',
		'code12': '该公司没有此加班类别',
		'code13': '无法读取加班参数',
		'code14': '预先加班时间早于系统最早假勤日期',
		'code15': '预先加班时间晚于系统最晚假勤日期',
		'code16': '加班区间超出加班申请期限',
		'code17': '加班区间没有特休假勤',
		'code18': 'HR未开放该加班时段',
		'code19type1': '在职状态为未到职',
		'code19type2': '在职状态为留职停薪',
		'code19type3': '在职状态为离职',
		'code20': '加班区间不可申请加班',
		'code21': '加班区间超过可加班时间',
		'code22': '加班区间为禁止加班时间',
		'code23': '加班不能与其他项目重复',
		'code24': '需要提供附件',
		'code25': '加班必须事先申请',
		'code26': '加班须在加班事实发生后<%=A%>天内申请完',
		'code27': '需要填写加班原因',
		'code28': '预先加班时数小于最少单位',
		'code29': '预先加班时数大于最多单位',
		'code30': '该行事历不可加班',
		'code31': '合计时数不可以为0',
		'code32': '加班已结算',
		'code33': '加班区间不在加班归属日内',
		'code34': '此员工不属于此加班折换方式适用对象',
		'code35': '加班数据不存在',
		'code36': '加班申请规则错误',
		'code37': '加班不允许事先申请',
		'code38': '加班需事先申请',
		'code39': '加班不允许事后申请',
		'code40': '员工预先加班单不存在',
		'code41': '实际加班时间未落于预先加班时间内',
		'code42type1': '加班需在 加班开始前<%=A%>工作日 申请 完',
		'code42type2': '加班需在 加班开始前<%=A%>工作日 签核 完',
		'code42type3': '加班需在 加班结束后<%=A%>工作日 申请 完',
		'code42type4': '加班需在 加班结束后<%=A%>工作日 签核 完',
		'code42type5': '加班需在 加班开始前<%=A%>历日 申请 完',
		'code42type6': '加班需在 加班开始前<%=A%>历日 签核 完',
		'code42type7': '加班需在 加班结束后<%=A%>历日 申请 完',
		'code42type8': '加班需在 加班结束后<%=A%>历日 签核 完',
		'code42type9': '加班需在 加班开始前<%=A%>小时 申请 完',
		'code42type10': '加班需在 加班开始前<%=A%>小时 签核 完',
		'code42type11': '加班需在 加班结束后<%=A%>小时 申请 完',
		'code42type12': '加班需在 加班结束后<%=A%>小时 签核 完',
		'code43': '加班不允许预先申请',
		'code90': '重新计算加班时数与成本中心分摊不一致',
		'code91': '加班抵换方式有变动',
		'code44': '有签核中的调班单',
	},
	'sp.wf022.am.emp.preot.checkDelete': {
		'code11': '加班已取消',
		'code12': '加班数据不存在',
	},
	'sp.wf090.am.emp.attend.check': {
		'code01': '该公司没有此员工',
		'code03': '出勤时数不可超过 24 小时',
		'code04': '出勤起始时间晚于结束时间',
		'code05': '出勤时数与成本中心分摊不一致',
		'code06': '未提供附件',
		'code07': '未填写出勤原因',
		'code08': '出勤时数小于最少单位',
		'code09': '出勤时数大于最多单位',
		'code10': '合计时数不可以为0',
		'code11': '出勤不能与其他出勤项目重复',
		'code12': '出勤不能与加班重复',
		'code13': '出勤不能与请假重复',
		'code14': '员工未设定出勤时数规则',
		'code15': '员工不在职',
		'code16': '不允许事先申请出勤时数',
		'code17': '出勤时间早于系统最早假勤日期',
		'code18': '员工于(出勤时段)期间的班别属性不允许申请出勤时数',
		'code19': '不可申请计薪前<%=A%>的出勤数据',
		'code20': '支领出勤时数与微调值加总小于0',
		'code21': '员工于(出勤时段)期间的班别属性不允许申请出勤时数',
		'code22': '刷卡资料不足',
		'code23': '出勤归属日超过出勤时间',
		'code24type1': '出勤时数单需在出勤结束日期后<%=A%>日历天申请完成',
		'code24type2': '出勤时数单需在出勤结束日期后<%=A%>工作天申请完成',
		'code25': '申请期限参数有误',
		'code26': '成本中心资料不可为空',
	},
	'sp.wf090.am.emp.attend.checkCardmatch': {
		'code11': '打卡比对错误',
	},
	'sp.wf020.am.emp.ot.checkCardmatch': {
		'code11': '打卡比对错误',
	},
	'sp.wf090.am.emp.attend.checkDelete': {
		'code11': '出勤时数已结算',
		'code12': '出勤时数主档ID错误',
	},
	'sp.wf021.wf.batch.ot.do': {
		'code01': '该日期此员工不在职或无班别时间数据',
		'code10': '工时规则错误',
		'code11': '打卡比对错误',
		'code12': '该公司没有此加班类别',
		'code13': '无法读取加班参数',
		'code14': '加班区间早于系统最早假勤日期',
		'code15': '加班区间晚于系统最晚假勤日期',
		'code16': '加班区间超出加班申请期限',
		'code17': '加班区间没有特休假勤',
		'code18': 'HR未开放该加班时段',
		'code19type1': '在职状态为未到职',
		'code19type2': '在职状态为留职停薪',
		'code19type3': '在职状态为离职',
		'code20': '加班区间不可申请加班',
		'code21': '加班区间超过可加班时间',
		'code22': '加班区间为禁止加班时间',
		'code23': '加班不能与其他项目重复',
		'code24': '需要提供附件',
		'code25': '加班必须事先申请',
		'code26': '加班须在加班事实发生后<%=A%>天内申请完',
		'code27': '需要填写加班原因',
		'code28': '加班时数小于最少单位',
		'code29': '加班时数大于最多单位',
		'code30': '该行事历不可加班',
		'code31': '合计时数不可以为0',
		'code32': '加班已结算',
		'code33': '加班区间不在加班归属日内',
		'code34': '此员工不属于此加班折换方式适用对象',
		'code35': '加班数据不存在',
		'code36': '加班申请规则错误',
		'code37': '加班不允许事先申请',
		'code38': '不需排班员工不可折换补休',
		'code39': '预先加班单为必填',
		'code40': '员工预先加班单不存在',
		'code41': '实际加班时间未落于预先加班时间内',
		'code42type1': '加班需在 加班开始前<%=A%>工作日 申请 完',
		'code42type2': '加班需在 加班开始前<%=A%>工作日 签核 完',
		'code42type3': '加班需在 加班结束后<%=A%>工作日 申请 完',
		'code42type4': '加班需在 加班结束后<%=A%>工作日 签核 完',
		'code42type5': '加班需在 加班开始前<%=A%>历日 申请 完',
		'code42type6': '加班需在 加班开始前<%=A%>历日 签核 完',
		'code42type7': '加班需在 加班结束后<%=A%>历日 申请 完',
		'code42type8': '加班需在 加班结束后<%=A%>历日 签核 完',
		'code42type9': '加班需在 加班开始前<%=A%>小时 申请 完',
		'code42type10': '加班需在 加班开始前<%=A%>小时 签核 完',
		'code42type11': '加班需在 加班结束后<%=A%>小时 申请 完',
		'code42type12': '加班需在 加班结束后<%=A%>小时 签核 完',
		'code43': '加班不允许预先申请',
		'code90': '重新计算加班时数与成本中心分摊不一致',
		'code91': '加班抵换方式有变动',
		'code44': '有签核中的调班单',
	},
	'sp.wf011.wf.batch.leave.do': {
		'code11': '该公司没有此员工',
		'code12': '该公司没有此加班类别',
		'code13': '请假区间内不在职',
		'code14': '员工不适用此假勤项目',
		'code15': '无法读取假勤参数',
		'code16': '假勤区间早于系统最早假勤日期',
		'code17': '假勤区间晚于系统最晚假勤日期',
		'code18': '假勤区间超出假勤申请期限',
		'code19': '尚有前置假剩余时数',
		'code20': '假勤不能与其他项目重复',
		'code21': '假勤不允许事后申请',
		'code22': '假勤必须在实际发生后<%=A%>天内申请完',
		'code23': '需要有请假代理人',
		'code24': '需要填写请假原因',
		'code25': '需要提供附件',
		'code26': '剩余时数小于最小单位',
		'code27': '试用期满日后才能申请',
		'code28': '生日当月才能申请',
		'code29': '生日当日才能申请',
		'code30': '请假时数小于最少请假单位',
		'code31': '请假时数大于最多请假单位',
		'code32': '合并其他请假时数超过上限',
		'code33': '合并其他请假次数超过上限',
		'code34': '剩余时数不足',
		'code35': '合计时数不可以为0',
		'code36': '假勤已销假',
		'code37': '假勤已结算',
		'code38': '职务代理人不存在或不在职',
		'code39': '超过可休区间',
		'code42': '员工请假主档不存在',
		'code43': '事件发生日未设定',
		'code44': '请假区间与加班区间重复',
		'code45': '特休资料已结算',
		'code46': '补休资料已结算',
		'code47': '弹性假数据已结算',
		'code48': '同天多班别者,不能请假勤为 "上下半天规则" 的假勤',
		'code49': '不需排班员工不可请假',
		'code50': '职务代理人于请假区间 <%=S%>~<%=E%> 已请假',
		'code51': '部分或全部的假勤时间已担任其他同仁的职务代理人',
		'code52': '不可同时担任多位员工的代理人',
		'code53': '该行事历别不可代理他人',
		'code54': '代理他人期间不可请假',
		'code55': '事件发生日资料不存在',
		'code56': '事件发生日与说明与其它假勤资料重复',
		'code71': '有签核中的调班单',
	},
	'sp.signIn.ac.user.checkPwd': {
		'code11': '登入成功',
		'code12': '登入成功,但须提醒修改密码',
		'code17': '默认密码启用账号',
		'code18': '变更密码',
		'code19': 'AD认证',
		'code21': '登入失败',
		'code22': '账号锁定中',
		'code23': '账号已关闭',
		'code24': '账号未认证',
		'code26': '输入太多次错误,账号已被锁定',
		'code31': '应用程序不存在',
		'code32': '账号不存在',
		'code33': '账号状态错误',
		'code34': '认证模式错误',
		'code35': '账号多公司',
		'code36': '未开启APP 功能',
		'code37': '账号登入公司已关闭，请联络权限管理者',
		'code38': '账号登入公司已关闭，请联络104服务人员',
		'code91': '需要使用Microsoft帐号登入',
	},
	'sp.auth.ac.user.checkPwdChange': {
		'code11': '启用成功',
		'code19': 'AD认证',
		'code21': '密码输入错误',
		'code22': '账号锁定中',
		'code23': '账号已关闭',
		'code24': '账号未认证',
		'code25': '输入太多次错误,账号已被锁定',
		'code31': '应用程序不存在',
		'code32': '账号不存在',
		'code33': '账号状态错误',
		'code34': '认证模式错误',
		'code41': '密码最小长度检查错误',
		'code42': '文数字检查错误',
		'code43': '密码需有特殊符号检查错误',
		'code44': '时间未到',
		'code45': '与上次密码重复',
		'code46': '新旧密码不可以一样',
		'code47': '密码至少包含一个大写英文字',
	},
	'sp.auth.ac.user.checkPwdReset': {
		'code11': '密码变更成功',
		'code19': 'AD认证',
		'code21': '密码输入错误',
		'code23': '账号已关闭',
		'code24': '账号未认证',
		'code25': '输入太多次错误,账号已被锁定',
		'code31': '应用程序不存在',
		'code32': '账号不存在',
		'code33': '账号状态错误',
		'code34': '认证模式错误',
		'code39': 'TOKEN错误',
		'code41': '密码最小长度检查错误',
		'code42': '文数字检查错误',
		'code43': '密码需有特殊符号检查错误',
		'code44': '时间未到',
		'code45': '与上次密码重复',
		'code46': '新旧密码不可以一样',
		'code47': '密码至少包含一个大写英文字',
	},
	'app.service.wf.service-global': {
		'sinceThereAreMoreThanOvertime': '因加班人超过100人，仅可于Portal签核',
		'holiday': '假日',
		'noneOfThemCanBeSigned': '全部无法签核',
	},
	'app.service.am.service-personal-clock': {
		'theEmployeeDoesNotHaveThis': '员工无此笔数据',
		'theReasonForOvertimeAttendanceCannot': '此笔数据无法填写超时出勤原因',
	},
	'hp.service.m4.service-m410070': {
		'thePreviousPeriodWasExtended': '上期展延',
		'thisIssue': '本期',
	},
	'app.service.am.service-personal-leave': {
		'cancelledLeave': '已销假',
	},
	'app.service.am.service-manager': {
		'totalOf': '<%=temp1%>月累计请假纪录共<%=temp2%><%=temp3%><%=temp4%>',
		'totalOfAbnormal': '<%=temp1%>月累计异常出勤纪录共<%=temp2%>笔',
	},
	'app.service.auth': {
		'quickLoginNotCreated': '未建立快速登入',
		'keyVerificationFailed': '密钥验证失败',
		'keyOperationException': '密钥操作异常',
		'theUserAccountDoesNotExist': '该使用者账号不存在',
		'accountLocked': '账号锁定中',
		'accountClosed': '账号已关闭',
		'accountNotAuthenticated': '账号未认证',
		'theAPPFunctionIsNotTurnedOn': '未开启APP 功能',
		'invalidRefreshToken': '验证失败 (请更新 accessToken 再试一次)',
		'cannotCreateRefreshToken': '无法产生新token连结',
		'verifyToken490': 'token 无效 (JWT)',
		'verifyToken491': 'token 过期 (JWT)',
		'verifyToken492': 'user 不存在 (可能员工已经被删除了，或相关数据被停用或删除了)',
		'verifyToken493': 'token 无效 (作业已完成或逻辑已更换，请找最新信件的连结)',
		'noRelevantInformationFound': '找不到相关资料 (Ex: passwordRules)',
		'notOpenToUseAPP': '不开放使用APP',
		'adEnableFailed': 'AD启用失败',
		'userIsNotExist': '用户不存在',
		'abnormalAccountStatus': '账号状态异常',
		'passwordDoesNotMatch': '密码不符合登入规则要求的长度或复杂性',
		'forgetPwd490': '此帐号不适用，请使用 Microsoft 帐号登入',
		'forgetPwd491': '账号有误',
		'forgetPwd492': '您使用的是AD账号，重设AD账号密码请联络公司MIS人员，谢谢！',
		'forgetPwd493': '您的账号未启用，请连络账号管理者再寄一次账号认证信',
		'forgetPwd494': '您的账号已锁定，请于锁定效期之后再次登入本系统或连络账号管理者，谢谢！',
		'forgetPwd495': '您的账号已关闭，请连络账号管理者，谢谢!',
		'forgetPwd496': '产生token失败',
		'forgetPwd497': '寄送通知信失败，无信件范本',
		'forgetPwd498': '无 email 可寄发密码通知函，请联络系统管理员',
		'noRelatedRulesFound': '找不到相关规则',
		'wrongVersionNumberFormat': '版本号码格式错误',
		'aadEnableFailed': 'Azure Active Directory启用失败',
	},
	'app.service.head': {
		'userIsNotExist': '用户不存在',
		'noInfo': '无资料',
	},
	'app.service.presetCode': {
		'preset401': '认证失败 (请更新 accessToken 再试一次)',
		'preset403': '权限不足',
		'preset404': '用户不存在',
		'preset440': '参数错误 (请检查 parameters 或 request body 的字段、格式是否完整及正确)',
		'preset450': 'MulterError',
		'presetDB499': 'DB错误',
		'preset499': '系统异常(service 内 catch)',
		'preset500': '系统异常',
	},
	'app.service.file': {
		'invalidFileFormat': '无效的文件格式: ',
		'wrongFileName': '文件名不可包含特殊字符: ',
	},
	'app.service.am.attendStatistic': {
		'theEmployeeDoesNotHaveThis': '员工无此笔数据',
	},
	'app.service.am.clock': {
		'noCheckInLocations': '无可用的打卡地点',
		'notYetInTheCheckInRange': '尚未进入打卡范围',
		'unableToGetDBTime': '无法取得 DB 时间',
		'clockIn490': '工时检查错误',
		'clockIn491': '打卡时间重复',
		'clockIn493': '当日第一笔打卡必填体温',
		'clockIn494': '各班别第一笔打卡必填体温',
		'clockIn499': 'DB错误',
		'hyperthermia': '体温过高',
		'disabledWifi': 'Wifi 打卡功能已关闭',
		'noWifiMatch2': '请连结可允许打卡的 Wifi 讯号位置\n前往手机设定重新选择网路。',
		'noCheckInSetting': '无法完成打卡功能初始化(未开启打卡功能、或无可打卡地点)',
		'checkInSettingsError': '打卡设定取得失败',
		'noWifiCheckIn': '无可用的 Wi-Fi 打卡地点',
		'fahrenheit': '若為華氏體溫，僅接受範圍 95 ~ 113。',
		'celsius': '若为摄氏体温，仅接受范围 35 ~ 45。',
		'gpsTitle': 'GPS 打卡',
		'wifiTitle': 'Wi-Fi 打卡',
		'checkInWifi': '打卡 Wi-Fi 与适用 Wi-Fi 不一致。',
	},
	'app.service.ac.appReg': {
		'notAppRegRule': '使用者不适用手机绑定规则',
		'remind': '提醒您',
		'deviceBindingRequired': '需绑定装置后，才可正常使用。',
		'oneDevicePerAccountBinding': '(一个装置只能绑定一个帐号)',
		'deviceAlreadyBoundUseAnother': '此装置已绑定其他帐号，请改用其他装置绑定。',
		'accountAlreadyBoundToAnother': '此帐号已绑定其他装置。',
		'oneAccountOneDeviceBinding': '(一个帐号只能绑定一个装置)',
		'accountNotBoundToDevice': '此帐号尚未绑定装置',
		'unbindSuccess': '解除绑定成功',
		'notified': '已通知',
		'unbindNotificationSentPleaseWait': '已通知承办人解除绑定。请稍待相关人员处理。',
		'send': '已寄发',
		'verificationEmailSentUnbindUponSuccess': '已寄发验证函至您的信箱。成功验证后，将自动解除绑定。',
		'messageNotificationEstablished': '寄发信件失败，尚未建立讯息通知',
		'failedToSendVerificationLetter': '寄发验证函失败',
		'linkExpired': '此链接已过期，请重新申请',
		'invalidLink': '无效连结，请重新申请',
		'identitySuccessful': '身份验证成功，已自动解除手机绑定',
	},
	'hp.m5.preview.wf020': {
		'thereAreTempTypesOfOvertime': '加班類別共<%=temp1%>類',
	},
	'hp.m5.preview.wf011': {
		'aTotalOfOfPeopleOn': '请假共<%=temp1%>人',
	},
	'components.Grids': {
		'inquire': '查詢',
	},
	'workflow.common.formTable': {
		'formNo': '表单单号',
		'applicationTime': '申请时间',
	},
	'workflow.common.notification': {
		'portalUrl': 'Portal网址',
		'approveUrl': '核准URL',
		'rejectUrl': '驳回URL',
		'agentSettingUrl': '代理人设定网址',
	},
	'h2.pb.pb40910': {
		'payrollPwdDefault1': '「<%=A%><%=B%>」',
		'payrollPwdDefault2': '，默认密码<%=C%>需加上<%=D%>',
	},
	'hp.m5.m510010.wf100': {
		'pleaseSelectBizTime': '请先选择出差时间',
		'falseAttendanceCalculationError': '出差计算错误',
		'itineraryDetails': '详细出差行程资讯',
		'rowHeader': '行程',
		'theBusinessTripApplicationFailed': '新增出差行程申请单失败',
		'failedToWriteToTheFake': '写入出差行程主档失败',
		'bizTripType': '出差性质',
		'bizDate': '出差时间',
		'totalBizTripHours': '出差合计时数',
		'bizLocation': '出差地点',
		'transportation': '交通工具',
		'appointment': '委办事项',
		'bizReason': '出差原因',
		'servedAsAgentForOtherColleagues': '部分或全部的出差时间已担任其他同仁的职务代理人',
		'totalCountCannotBe': '合计时数不可以为0',
		'fakeProjectLoadingError': '出差項目加载错误',
		'substituteRequired': '需要有职务代理人',
		'segmentedBizTime': '分段出差时间',
		'totalBizTime': '分段出差合计时数',
	},
	'sp.wf100.am.emp.biz.check': {
		'code11': '该公司没有此员工',
		'code12': '该公司没有此加班类别',
		'code13': '请假区间内不在职',
		'code14': '员工不适用此假勤项目',
		'code15': '无法读取假勤参数',
		'code16': '假勤区间早于系统最早假勤日期',
		'code17': '假勤区间晚于系统最晚假勤日期',
		'code18': '假勤区间超出假勤申请期限',
		'code19': '尚有前置假剩余时数',
		'code20': '出差时间不能与其他出差重复',
		'code21': '假勤不允许事后申请',
		'code22': '假勤必须在实际发生后<%=A%>天内申请完',
		'code23': '需要有职务代理人',
		'code24': '需要填写请假原因',
		'code25': '需要提供附件',
		'code26': '剩余时数小于最小单位',
		'code27': '试用期满日后才能申请',
		'code28': '生日当月才能申请',
		'code29': '生日当日才能申请',
		'code30': '请假时数小于最少请假单位',
		'code31': '请假时数大于最多请假单位',
		'code32': '合并其他请假时数超过上限',
		'code33': '合并其他请假次数超过上限',
		'code34': '剩余时数不足',
		'code35': '合计时数不可以为0',
		'code36': '假勤已销假',
		'code37': '假勤已结算',
		'code38': '职务代理人不存在或不在职',
		'code39': '超过可休区间',
		'code40': '无<%=A%>可休时数',
		'code42': '员工请假主档不存在',
		'code43': '事件发生日未设定',
		'code44': '请假区间与加班区间重复',
		'code45': '特休资料已结算',
		'code46': '补休资料已结算',
		'code47': '弹性假数据已结算',
		'code48': '同天多班别者,不能请假勤为 "上下半天规则" 的假勤',
		'code49': '不需排班员工不可请假',
		'code50': '职务代理人已请假',
		'code51': '部分或全部的假勤时间已担任其他同仁的职务代理人',
		'code52': '不可同时担任多位员工的代理人',
		'code53': '该行事历别不可代理他人',
		'code54': '代理他人期间不可请假',
		'code55': '事件发生日资料不存在',
		'code56': '事件发生日与说明与其它假勤资料重复',
		'code57': '假勤截止日不可小于该笔最大结档日',
		'code60': '不需排班员工不可申请出差',
		'code61': '出差时间不能与其他出差重复',
		'code62': '分段出差时间需介于整体出差时间内',
		'code63': '分段时间不可重叠',
		'code70': '代理人不在职务代理人清单中',
	},
	'sp.wf050.am.emp.leave.cancel.check.byHour': {
		'code11': '该公司没有此员工',
		'code12': '该公司没有此请假资料',
		'code13': '销假区间超出销假申请期限',
		'code23': '员工特休数据已结算 ( 上期 )',
		'code24': '员工特休数据已结算 ( 本期 )',
		'code25': '员工补休数据已结算',
		'code26': '员工弹休数据已结算',
		'code29': '请假资料在途中',
		'code30': '假勤已结算',
		'code33': '已有特休加班资料',
	},
	'components.custom-form.single-text.view': {
		'maxWords': '最多<%=temp1%>字',
		'pleaseEnterAnEMailAddress': '请输入E-mail',
	},
	'hp.m3.m310510': {
		'kindED': '人事类',
		'kindAM': '出勤类',
		'kindPB': '薪资类',
		'timeUnit': '时间单位',
		'year': '年',
		'season': '季',
		'period': '日期区间',
		'all': '全部',
		'active': '使用中',
		'deptLevel': '部门层级显示至',
		'fullComp': '全公司',
		'proofAll': '和全公司比较',
		'yearTitle': '<%=y1%>年~<%=y2%>年',
		'xLegend1': '<%=y1%>年Q<%=q1%>',
		'xLegend2': '<%=y1%>年  第<%=q1%>季',
		'xLegend3': '<%=y1%>年',
		'men': '男性',
		'women': '女性',
		'genderTitle': '性别统计',
		'genderTip':
			'■ 资料会根据 HR 设定的每天更新频率定时更新。\n\t\t\t■ 根据筛选条件的日期区间最后一天「在职、留停」的员工计算。\n\t\t\t■ 百分比会四舍五入到小数点第一位。\n\t\t\t■ 范例：2022 年 A 部门有 6 男 1 女，B 部门有 3 男 7 女。 2023/3/1  A 部门 1 位男性转调至 B 部门。\n\t\t\t当筛选条件为2022 年的A、B 部门时，A 部门为男86% (6人)、女14% (1人)，B 部门为男30% (3人)、女70% (7人) 。\n\t\t\t当筛选条件为2023 年的A、B 部门时，A 部门为男83% (5人)、女17% (1人)，B 部门为男36% (4人)、女64% (7人) 。',
		'genderCnt': '位',
		'ageTitle': '年龄统计',
		'ageTip':
			'■ 资料会根据 HR 设定的每天更新频率定时更新。\n\t\t\t■ 根据筛选条件的日期区间最后一天「在职、留停」的员工计算。\n\t\t\t■ 百分比会四舍五入到小数点第一位。\n\t\t\t■ 范例：2022 年 A 部门 4 人（35岁、41岁、42岁、43岁）。 2023 年 35 岁员工留停、42 岁员工离职。\n\t\t\t当筛选条件为 2022 年的 A 部门时，区间 31-40 岁 25%（1人）、41-50 岁 75%（3人）。\n\t\t\t当筛选条件为 2023 年的 A 部门时，区间 31-40 岁 33%（1人）、41-50 岁 67%（2人）。',
		'ageSlice': '以 X 为分析单位',
		'baseAge20': '以20岁为基础值',
		'season1': '第一季',
		'season2': '第二季',
		'season3': '第三季',
		'season4': '第四季',
		'xLegend4': '20岁以下',
		'xLegend5': '<%=XX%>岁以上',
		'quitTitle': '离职统计',
		'quitTip':
			'■ 资料会根据 HR 设定的每天更新频率定时更新。\n\t\t\t■ 根据筛选条件区间的离职员工计算。\n\t\t\t■ 同位员工若在筛选区间多次离职，则只计入最后一次的 1 人。\n\t\t\t■ 离职率 = 离职人数 / ((第一天在职人数 + 最后一天在职人数) / 2) *100%。\n\t\t\t■ 百分比会四舍五入到小数点第一位。\n\t\t\t■ 范例：筛选条件为以年为单位，2022~2023。\n\t\t\tA 员工在 2022、2023 年各离职 1 次。\n\t\t\tB 员工在 2023 年离职 2 次。\n\t\t\t2022/1/1 在职人数 10 人，2022/12/31 在职人数 30 人。\n\t\t\t2023/1/1 在职人数 30 人，2023/12/31 在职人数 40 人。\n\t\t\t2022 年离职员工 1 人，比例 1/20 = 5%。\n\t\t\t2023 年离职员工 2 人，比例 2/35 = 5.7%。',
		'quitLevel': '离职率超过 X 以橙色标示',
		'cover': '(含)',
		'xLegend6': '自愿离职(不含退休)',
		'xLegend7': '自愿离职(含退休)',
		'xLegend8': '非自愿离职',
		'stopTitle': '育婴留停复职统计',
		'stopTip':
			'■ 资料会根据 HR 设定的每天更新频率定时更新。\n\t\t\t■ 根据筛选条件区间的留停、复职员工计算。\n\t\t\t■ 同位员工若在筛选区间多次复职，则只计入最后一次的 1 人。\n\t\t\t■ 复职率 = (实际复职人数/应复职人数)*100%\n\t\t\t■ 百分比会四舍五入到小数点第一位。\n\t\t\t■ 范例：筛选条件为以年为单位，2022~2023。\n\t\t\tA 部门某员工应 2022 年复职，实际未复职。 B 部门某员工应 2023 年复职 2 次，实际 2023 年复职 2 次。\n\t\t\t则 A 部门复职率 0%、B 部门 100% 。',
		'stopLevel': '复职率低于 X 以橙色标示',
		'stopBack': '复职率',
		'stopExpect': '预计复职人数',
		'stopActual': '实际复职人数',
		'hurtTitle': '公伤病假统计',
		'hurtTip':
			'■ 资料会根据 HR 设定的每天更新频率定时更新。\n\t\t\t■ 根据筛选条件范畴内，至少有一天「在职」的员工计算。\n\t\t\t■ 包含「所有使用中、停用」且对照台湾法令假别为「公伤病假」的加总实际请假时数。\n\t\t\t■ 实际请假时数 = 请假时数 - 销假时数。皆仅计算「已核准」的假勤。\n\t\t\t■ 百分比 = (实际请假时数 / 总工时)*100%\n\t\t\t■ 百分比会四舍五入到小数点第一位。\n\t\t\t■ 范例：部门 2 位员工，3 月各需工作 20 天，每天工时 8 小时。 A 员工请半薪病假 4 小时且核准，B 员工请公伤病假 16 小时且签核中，则百分比为 4/(8*20*2) = 1.3%',
		'hurtLevel': '公伤病假率超过 X 以橙色标示',
		'hurtJoin': '全部(男女合并显示)',
		'hurtApart': '全部(男女分别显示)',
		'percent': '百分比',
		'hour': '小时',
		'hurtIssue': '实际请假时数',
		'hurtTotal': '总工时',
		'breedTitle': '产假/产检假/陪产假统计',
		'breedTip':
			'■ 资料会根据 HR 设定的每天更新频率定时更新。\n\t\t\t■ 根据筛选条件范畴内，至少有一天「在职」的员工计算。\n\t\t\t■ 包含「所有使用中、停用」且对照台湾法令假别为「产假、产检假、陪产假」的加总实际请假时数。\n\t\t\t■ 实际请假时数 = 请假时数 - 销假时数。皆仅计算「已核准」的假勤。\n\t\t\t■ 百分比 = (实际请假时数 / 总工时)*100%\n\t\t\t■ 百分比会四舍五入到小数点第一位。\n\t\t\t■ 范例：部门 2 位员工，3 月各需工作 20 天，每天工时 8 小时。 A 员工请陪产假 4 小时且核准，B 员工请产假 40 小时且签核中，则百分比为 4/(8*20*2) = 1.3%',
		'breedLevel': '产假/产检假/陪产假率超过 X 以橙色标示',
		'pay2Title': '薪资结构统计',
		'pay2Tip': `■ 资料会根据 HR 设定的每天更新频率定时更新。
			■ 根据筛选条件范畴内，至少有一天「在职」的员工计算。
			■ 仅计算薪资结构的薪资科目。
			■ 金额会四舍五入到整数位。`,
	},
	'hp.m1.m110010': {
		'type': '类型',
		'status': '状态',
		'search': '搜寻',
		'announcementTime': '发布时间',
		'titleOrPublishingUnit': '搜寻公告标题、发布单位',
		'startDate': '请选择日期(起)',
		'endDate': '请选择日期(讫)',
		'no': '编号',
		'category': '类别',
		'title': '公告标题',
		'readStatus': '是否读取',
		'publishingUnit': '发布单位',
		'read': '已读',
		'unread': '未读',
		'announcement': '公告',
		'bulletinPublishingUnit': '公告单位 :',
		'bulletinCategory': '类别：',
	},
	'hp.m1.m110020': {
		'addAnnouncement': '新增公告',
		'titleOrLastUpdater': '搜寻公告标题或最后更新人',
		'statistics': '读取人数',
		'lastUpdate': '最后更新',
		'suspendPublication': '暂停发布',
		'content': '公告内容',
		'category': '公告类别',
		'categoryMaintenance': '分类维护',
		'no': '公告编号',
		'general': '【一般公告】',
		'displayOnTheList': '显示于首页列表中',
		'important': '【重大公告】',
		'topOfTheHomepage': '首页上方置顶显示',
		'mandatory': '【强制公告】',
		'windowHomepage': '进入首页前以弹跳窗口显示',
		'pleaseSelect': '请选择',
		'enterTheTitle': '输入标题，最多50字',
		'attachmentLabel': '附件',
		'publishingSettings': '发布设定',
		'announcementTime': '公告时间',
		'startTime': '开始时间 YYYY / MM / DD hh:mm',
		'endTime': '结束时间 YYYY / MM / DD hh:mm',
		'bottomButton': '置底按钮',
		'noButtonRequired': '不需要按钮',
		'displayButton': '显示按钮',
		'publishingTarget': '发布对象',
		'publishingMethod': '发布方式',
		'endOfAnnouncement': '公告结束，是否保留于前台讯息中心',
		'keepIt': '是，请保留',
		'takeItDown': '不用保留，请下架',
		'publishingUnit': '发布单位',
		'optional': '（选填）',
		'noteUpToWords': '输入备注，最多50字',
		'saveAsDraft': '储存为草稿',
		'publish': '发布',
		'noticeOfInspection': '检示公告',
		'suspendPublicationDlg': '暂停发布此则公告  ?',
		'suspendSuccessfully': '暂停发布成功',
		'suspendFailed': '暂停发布失败',
		'afterSuspension': '暂停后，所有同仁皆无法看到公告',
		'deletedSuccessfully': '删除成功',
		'deletionFailed': '删除失败',
		'currentlyBeingPublished': '目前公告发布中，',
		'afterDeletion': '删除后，前、后台皆无法查阅此则公告',
		'publicationSuccessful': '发布公告成功！',
		'publicationfailed': '发布公告失败',
		'addingAttachmentFailed': '新增附件失败！',
		'addingContentFailed': '新增公告内容失败！',
		'contentIsRequired': '公告内容必填！',
		'contentToWords': '公告内容长度须小于 10,000 个字符',
		'formatError': '格式错误，仅接受http或https网址格式',
		'preview': '预览',
		'saving': '储存中',
		'publishing': '发布中',
		'displayedTop': '列表置顶',
		'weekTo1': '周一',
		'weekTo2': '周二',
		'weekTo3': '周三',
		'weekTo4': '周四',
		'weekTo5': '周五',
		'weekTo6': '周六',
		'weekTo7': '周日',
		'displayPerDay': '每天显示 <%=N%> 次',
		'updateAnnouncement': '更新发布此则公告  ?',
		'updatedSuccessfully': '更新发布成功',
		'editingAttachmentFailed': '编辑附件失败！',
		'editingContentFailed': '编辑公告内容失败！',
		'editingRulesFailed': '编辑规则内容失败！',
		'startDateChanged': '发布起日不可异动',
		'afterUpdatedAnnouncement': '发布后，所有同仁皆看到为更新后公告内容',
		'confirmUpdate': '确认更新',
		'editAnnouncement': '编辑公告',
		'updatedAndPublished': '更新发布',
		'enterToWords': '输入自定义编号，最多10字',
		'displayEveryday': '每天显示',
		'resetCalculation': '(每天 00:00重置计算次数)',
		'times': '次',
		'addToFavorites': '加入常用名单',
		'textDisplayed': '按钮显示文字，最多10字',
		'enterWebsite': '输入网址 / 连结',
		'downloadedSuccessfully': '下载成功',
		'downloadFailed': '下载失败',
		'emailSuccessfullySent': '发送催读信件成功',
		'emailFailedSend': '发送催读信件失败',
		'title': '公告标题 :',
		'period': '公告期间 :',
		'type': '公告类型 :',
		'shouldRead': '应读人数 :',
		'haveRead': '已读人数 :',
		'unreadNum': '未读人数 :',
		'readingRate': '阅读率',
		'lastSent': '上次发送时间 :',
		'sendReminderNotification': '发送催读通知',
		'download': '下载',
		'unread': '未读',
		'read': '已读',
		'numberOfRead': '阅读次数',
		'latestReading': '最近一次阅读时间',
		'announcement': '公告',
		'weekToNum1': '一',
		'weekToNum2': '二',
		'weekToNum3': '三',
		'weekToNum4': '四',
		'weekToNum5': '五',
		'weekToNum6': '六',
		'weekToNum7': '日',
		'bulletinPublishingUnit': '公告单位 :',
		'bulletinCategory': '类别：',
		'announcementReadingStatus': '公告阅读状态',
		'updatingInProgress': '更新发布中',
		'updateAndPublish': '更新发布',
		'wantToDelete': '删除此则公告 ?',
		'publishBtn': '发布',
	},
	'hp.m1.m110030': {
		'addCategory': '新增类别',
		'editCategory': '编辑类别',
		'zhTW': '繁体中文',
		'zhUS': 'English',
		'zhEN': '简体中文',
		'categoryName': '公告类别名称',
		'upTpword': '请输入20字以内',
		'deledtedCompleted': '删除公告分类完成!',
		'deletionFailed': '删除公告分类错误',
		'defaultAndCannotBeDeleted': '此为系统默认，不可删除',
		'wantToDelete': '确定要删除类别「 <%=name%>」吗?',
		'systemDefault': '系统默认',
		'additionCompleted': '新增公告类别成功',
		'addingFailed': '新增类别错误',
		'duplicateName ': '类别名称重复',
		'editionCompleted': '编辑公告分类完成！<%=name%>',
		'editingFailed': '编辑类别错误',
		'confirmToDeactivate': '确定停用此类别',
		'categoryNotBeDeleted': '该类别已发布将不会被删除',
		'confirmToActivate': '确定启用此类别',
	},
	'hp.m1.m110040': {
		'addListOfFavorites': '新增常用名单',
		'closeSetting': '关闭设定',
		'name': '常用名单名称',
		'selectTarget': '选择对象',
		'confirmDelete': '确定要删除常用名单「',
		'confirmDelete1': '」吗?',
		'deletedCompleted': '删除常用名单(<%=name%>)完成',
		'deleteFailed': '删除失败: 常用名单(<%=name%>)已经使用中',
		'deleting': '删除中',
		'noExisting': '目前没有任何常用名单',
		'additionCompleted': '新增常用名单完成',
		'addingFailed': '新增常用名单失败',
		'duplicateName': '常用名单名称重复',
		'editListOfFavorites': '编辑常用名单',
		'editionCompleted': '编辑常用名单完成',
		'editingFailed': '编辑常用名单失败',
	},
	'hp.m5.m510060': {
		'searchForAll': '申请人/签核人/被异动人/表单编号',
		'formStatus': '表单状态',
		'status': '状态',
		'approver': '签核人',
		'handlers': '主要及其他承办人',
		'stakeholders': '表单关系人',
	},
	'components.custom-form.file-upload.prompt': {
		'format': '格式',
		'detail': '详情',
		'executableFilesSuchAsExeCannot': '不可上传执行档，如 .exe 等',
		'noLimit': '不限制',
		'image': '图片',
		'file': '文档',
		'briefing': '简报',
		'trialBalance': '试算表',
	},
	'components.custom-form.number-format.view': {
		'enterANumber': '输入数字',
	},
	'components.custom-form.import-image.preview': {
		'preview': '预览',
	},
	'components.custom-form.date-range.date-range': {
		'startDate': '起始日期',
	},
	'components.custom-form.details': {
		'add': '新增',
	},
	'components.custom-form.remark': {
		'checkItems': '复选：请选择 <%=min%> ~ <%=max%> 个选项',
	},
	'hp.m4.m410081': {
		'month': '月份',
		'shiftName': '班别',
		'scheduledTime': '应打卡班时间',
		'systemCardTime': '系统打卡时间',
		'actualTime': '实际出勤时间',
		'attendStats': '出勤统计',
		'shouldWorkDays': '本月应上班天数',
		'actualWorkDays': '本月实际上班天数',
		'confirmBtn': '出勤记录确认',
		'confirmStatus': '确认状态',
		'unconfirmed': '未确认',
		'confirmed': '已送出，送出日期：',
		'submittedBy': '送出人员：',
		'actualCardTime': '实际出勤时间',
		'lastSubmitTime': '最后送出时间',
		'noCardNeeded': '不需打卡',
		'overAttend': '超时出勤',
		'normal': '正常',
		'genTestMonthlyData': '随机产生整月打卡资料',
		'err001': '请输入时间格式(mm/dd hh:mm)',
		'err002': '您填写的 X 出勤记录存在超时状况，请依照规定修改后重新提交。',
	},
	'hp.m4.m410080': {
		'searchRange': '出勤区间',
		'requestStatus': '申请状态',
		'deductedHours': '扣除时数',
		'vestingDate': '归属日:',
		'attendanceHoursDet': '出勤时数明细',
		'attVestingDate': '出勤归属日',
		'calendar': '行事历别',
		'inTransit': '在途中',
	},
	'hp.m3.m310310': {
		'shiftLabel': '排班标签',
		'label': '标签',
		'shiftKeyword': '卷标关键词搜寻',
		'useStatus': '使用状态',
		'source': '数据源',
		'addLabel': '新增标签',
		'import': '汇入',
		'serial': '序号',
		'labelCode': '标签代码',
		'labelName': '标签名称',
		'note': '备注',
		'lastUpdate': '最后更新',
		'addShiftLabel': '新增排班标签',
		'copyLabel': '复制标签',
		'pleaseSelectLabel': '请选择标签',
		'shiftLabelCode': '排班标签代码',
		'pleaseEnterLabelCode': '请输入标签代码',
		'shiftLabelName': '排班标签名称',
		'pleaseEnterLabelName': '请输入名称',
		'fillColor': '填满颜色',
		'wordColor': '文字颜色',
		'preview': '预览结果',
		'pleaseEnterText': '请输入文字',
		'editShiftLabel': '编辑排班标签',
		'shiftLabelDetail': '排班卷标详细数据',
		'latestUpdate': '最后修改时间',
		'confirmDelete': '确定要删除「<%=name%>」吗?',
		'shiftLabelImport': '排班标签汇入',
		'importShiftLabel': '汇入排班标签',
		'status': '状态',
		'rules': '填写规则',
		'format': '字段格式',
		'example': '范例',
		'required': '必填',
		'labelCodeConflict': '代码不可重复，限制 10 字以内',
		'useOrDeactivated': '使用中、停用',
		'upTo20Words': '限制 20 个字以内',
		'addShiftLabelCompleted': '新增排班标签完成',
		'addShiftLabelFailed': '新增排班标签失败',
		'labelNameNotRepeated': '标签名称不可重复',
		'labelCodeNotRepeated': '标签代码不可重复',
		'shiftLabelCodeNotContainComma': '排班标签代码不得包含 "，"',
		'shiftLabellNameNotContainComma': '排班标签名称不得包含 "，"',
		'labelCodeNotContainComma': '标签代码不得包含 "，"',
		'labelNameNotContainComma': '标签名称不得包含 "，"',
		'importFormat': '汇入类型',
		'downloadImportSample': '下载汇入范例',
		'fieldRequired': '必填字段',
		'importFileFormatRequired': '汇入方式为必填字段',
		'fileNameNotContainSpecialChar': '文件名不可包含特殊字符 \\ / : * ? " < > | # % &',
		'shiftLabelReadError': '读取排班卷标数据错误',
		'shiftLabelNotExist': '排班卷标数据不存在',
		'editShiftLabelCompleted': '编辑排班标签完成',
		'editShiftLabelFailed': '编辑排班标签失败',
		'deleteShiftLabelCompleted': '删除排班标签完成',
		'deleteShiftLabelFailed': '删除排班标签失败',
		'addShiftLabelImportFormat': '新增排班标签汇入格式.xlsx',
		'editShiftLabelImportFormat': '编辑排班标签汇入格式.xlsx',
		'backstage': '后台',
		'usageStatusNotExist': '使用状态不存在',
		'systemId': '系统ID',
		'errorMsg': '错误讯息',
		'duplicateCode': '代码重复',
		'duplicateTraditionalChineseName': '繁体中文名称重复',
		'duplicateEnglishName': '英文名称重复',
		'duplicateSimplifiedChineseName': '简体中文名称重复',
		'systemIdNotExist': '系统ID不存在',
		'duplicateDataExist': '存在相同数据',
		'shiftGroup': '排班群组',
		'group': '群组',
		'groupKeyword': '群组关键词搜寻',
		'commonShift': '常用班别',
		'commonLabel': '常用标签',
		'addGroup': '新增群组',
		'deleteShiftGroupMsg': '确定要删除此 <%=count%> 笔排班群组吗?',
		'groupName': '组名',
		'shiftManager': '班表负责人',
		'addShiftGroup': '新增排班群组',
		'copyGroup': '复制群组',
		'selectGroup': '请选择群组',
		'pleaseEnterGroupName': '请输入名称',
		'shiftLeaderAuthorityDescription': '班表负责人可视为小主管，具备排班、发布班表，并提出调班申请单及支持申请单之权限。',
		'shiftScheduleApprover': '班表核决者',
		'classListApproverAuthorityDescription': '班表核决者可视为大主管，具备审核发布班表，签核调班申请单及支持申请单之权限。',
		'shiftScheduleCoordinator': '班表承办人',
		'scheduleOrganizerPermissionsDescription': '班表承办人可视为HR，具备审核发布班表，签核调班申请单及支持申请单之权限。',
		'applicableRecipients': '适用对象',
		'scheduleValidationExplanation': '当您进行排班时，系统会再自动检查群组内适用对象，在实际的班表周期内是否至少有一天班别属性为排班人员，若某员工在周期内并未设定为排班人员，则无法排定此员工的班表。',
		'shiftScheduleCycle': '班表周期',
		'to': '至',
		'shiftsPerDay': '每日可排班别数',
		'shift1': '一段班',
		'shift2': '两段班',
		'shift3': '三段班',
		'shift4': '四段班',
		'editShiftGroup': '编辑排班群组',
		'shiftGroupDetails': '排班群组详细资料',
		'maxShiftsPerDayPerPerson': '班表可排<%=alias%>段班 (每人每日最多可排<%=shiftMax%>个班别)',
		'shiftGroupImport': '排班群组汇入',
		'importShiftGroup': '汇入排班群组',
		'companyName': '公司名称',
		'staffId': '员工编号',
		'workHourRegulationCycle': '固定周期、依照工时规则周期',
		'startMonth': '起始月',
		'fixedCycleRequired': '若班表周期设定为"固定周期"，则此字段为必填',
		'monthPosition': '前一个月、本月、次月',
		'startDate': '起始日',
		'monthDate': '1日...30日、31日',
		'endMonth': '结束月',
		'endDate': '结束日',
		'monthDateEnd': '1日...30日、31日、月底',
		'typeWorkRules': '工时规则种类',
		'workingHourRegulationCycleRequired': '若班表周期设定为"依照工时规则周期"，则此字段为必填',
		'workingHourRegulationOptions': '一般工时、双周变形、四周变形、八周变形',
		'workingHourCycleStartDate': '工时计算周期起始日期',
		'dateFormatDescription': "\"请填写日期，格式顺序为: 年月日 公元-可接受间隔符号为'/'、'-' 民国-可接受间隔符号为'/'、'-'、'国字'\"",
		'multipleCommonShiftsDescription': "若有多个常用班别，可输入多个班别代码或班别简称，并以 '，'间隔",
		'shift': '班别',
		'shiftCode': '班别代码',
		'shiftAbbreviation': '班别简称',
		'viewWorkingHourCalculationCycle': '检视工时计算周期',
		'previousCycle': '上一周期',
		'nextCycle': '下一周期',
		'viewCycle': '检视周期',
		'groupNameConflictNotAllowed': '组名不可重复',
		'shiftGroupDataNotExist': '排班群组数据不存在',
		'setAtLeastOneFilterCriteria': '请至少建立一个筛选条件',
		'startDateShouldBeEarlierThanEndDate': '开始时间必须早于结束时间。',
		'viewSchedulesLimitedTo8Weeks': '最多只能看到 8 周的班表',
		'addShiftGroupFailed': '新增排班群组失败',
		'addShiftGroupCompleted': '新增排班群组完成',
		'shiftGroupReadError': '读取排班群组数据错误',
		'editShiftGroupFailed': '编辑排班群组失败',
		'editShiftGroupCompleted': '编辑排班群组完成',
		'one': '一',
		'two': '两',
		'three': '三',
		'four': '四',
		'accordingToWorkHourRulesCycle': '依照<%=otWorkhourType%> 规则周期',
		'theStartDateOfWorkingHourCalculationCycleIs': '工时计算周期起始日期为 <%=date%>',
		'deleteShiftGroupCompleted': '删除排班群组完成',
		'deleteShiftGroupFailed': '删除排班群组错误失败',
		'editShiftGroupImportFormat': '编辑排班群组汇入格式.xlsx',
		'otherErrorMsg': '其他错误讯息',
		'staffIdNotExist': '员工编号不存在',
		'shiftScheduleCycleNotExist': '班表周期不存在',
		'startMonthNotExist': '起始月不存在',
		'startDateNotExist': '起始日不存在',
		'endMonthNotExist': '结束月不存在',
		'endDateNotExist': '结束日不存在',
		'typeWorkRulesNotExist': '工时规则种类不存在',
		'commonShiftNotExist': '常用班别不存在',
		'commonLabelNotExist': '常用标签不存在',
		'companyNotExist': '公司名称不存在',
		'duplicateSystemId': '系统ID重复',
		'importFileSameGroupName': '汇入档案内有相同名称的群组',
		'unauthorizedOperation': '未授权的操作',
		'employeeNotActiveEmployment': '员工非在职状况',
		'availableWorkHours': '可上班时间',
		'start': '开始',
		'end': '结束',
		'totalManpower': '加总人力',
		'employeeMgmt': '员工管理',
		'importEmployeeManagement': '汇入员工管理',
		'empNo': '员工编号',
		'empName': '员工姓名',
		'labelIsNotExist': '标签不存在',
		'invalidTimeFormat': '时间格式无效',
		'startTimeShouldBeEarlierThanEndTime': '开始时间必须早于结束时间。',
		'required': '必填',
		'mondayStart': '星期一开始',
		'mondayEnd': '星期一结束',
		'tuesdayStart': '星期二开始',
		'tuesdayEnd': '星期二结束',
		'wednesdayStart': '星期三开始',
		'wednesdayEnd': '星期三结束',
		'thursdayStart': '星期四开始',
		'thursdayEnd': '星期四结束',
		'fridayStart': '星期五开始',
		'fridayEnd': '星期五结束',
		'saturdayStart': '星期六开始',
		'saturdayEnd': '星期六结束',
		'sundayStart': '星期日开始',
		'sundayEnd': '星期日结束',
		'nationalHolidayStart': '国定假日开始',
		'nationalHolidayEnd': '国定假日结束',

		'incorrectDataImport': '错误汇入数据',
	},
	'hp.m3.m310080': {
		'exportCompleted': '汇出完成',
		'exportFailed': '汇出失败',
		'downloadDetailed': '下载明细表',
		'staffIdName': '员工编号 / 姓名',
		'totalAttHours': '出勤时数合计',
		'companyDept': '公司 / 部门',
		'attendancePeriod': '出勤区间:',
		'totalAttendanceHours': '出勤时数合计 <%=h%>小时 <%=m%>分钟',
		'min': '分钟',
		'detailedAttendanceReportTitle': '部属出勤时数明细表',
		'detailedAttendanceReport': '部属出勤时数明细表',
		'company': '公司名称',
		'chineseName': '中文姓名',
		'englishName': '英文姓名',
		'startDate': '出勤起始时间',
		'endDate': '出勤结束时间',
		'number': '时数',
		'unit': '单位',
		'deductingHours': '扣除时数区间',
		'searchRange': '查询区间：',
	},
	'hp.m4.m410060': {
		'leaveType': '假勤类别',
		'leaveTime': '假勤时间',
		'leaveHours': '假勤时数',
		'leaveResumptionHours': '销假时数',
		'actualHours': '实际时数',
		'substitute': '代理人',
		'leaveStartAndEendTime': '假勤起讫日期',
		'eventDateDescription': '事件发生日说明',
		'officialLeave ': '公司假',
		'annualLeave': '特休',
		'compensatoryTime': '补休',
		'flexibleLeave': '弹性假',
		'generalLeave': '一般假勤',
		'leaveResumptionLoadingError': '加载销假明细错误',
		'leaveResumptionDetails': '销假明细',
		'available': '可休期间',
	},
	'hp.m4.m410050': {
		'overtimeStartAndEndTime': '加班起讫时间',
		'overtimeHours': '加班时数',
		'deductedHours': '扣除时数',
		'redeemedForOvertimePay': '折换加班费',
		'redeemedForCompensatoryTime': '折换补休',
		'detailedOvertimeInformation': '加班详细信息',
		'available': '可休:',
		'availableNoExpiration': '可休: 无限期',
		'aboutToExpire': '即将到期',
		'expiryDate': '到期日',
		'noDetailedOvertime': '无加班详细信息',
		'noExpiration': '无限期',
	},
	'hp.m4.m410070': {
		'year': '统计年度',
		'rule': '可休规则',
		'noLimit': '无上限',
		'or': '或',
		'time': '次',
		'every': '每',
		'used': '已休',
		'remaining': '剩余',
		'approving': '签核中',
		'canApply': '可申请',
		'businessTrip': '出差',
		'annualLeaveEntitlement': '年度可休',
		'officialLeave': '公司假',
		'officialLeaveStatistics': '公司假统计',
		'annualLeaveStatistics': '特休统计',
		'startDateForLeave': '给假起始日',
		'endDateOfAllowableLeave': '可休到期日',
		'type': '类别',
		'available': '可休',
		'useding': '已使用',
		'total': '合计',
		'wantToTakeALeave': '我要休假',
		'compensatoryTimeStatistics': '补休统计',
		'restLimit': '可休额度',
		'source': '来源',
		'flexibleLeaveStatistics': '弹性假统计',
		'aAndBYear': '<%=A%> 年<%=B%>',
		'flexName': '弹性假名称',
		'leaveDate': '给假日期',
		'allowAdvanceUse': '允许预支',
		'deduction': '扣回',
		'generalLeaveStatistics': '一般假勤统计',
		'goOnABusinessTrip': '我要出差',
		'tripStartDate': '出差起始日',
		'tripEndDate': '出差结束日',
		'businessTripDuration': '出差时数',
		'leaveSart': '请假起始日',
		'leaveEnd': '请假结束日',
		'perYear': '年度可休 <%=A%> <%=B%>',
		'everyYear': '每 <%=A%> 年<%=B%>',
		'everyMonth': '每 <%=A%> 月<%=B%>',
		'everyDay': '每 <%=A%> 天<%=B%>',
		'everyTime': '每次',
		'birthMonth': '生日当月',
		'birthDay': '生日当日',
		'leavehours': '请假时数',
		'endDate': '到期日',
	},
	'hp.m3.m310040': {
		'abnormal': '异常状态',
		'leaveType': '异常状态各项目的计数，来自于该员工出勤纪录比对后的结果。',
		'oddLate': '异常-不拘',
		'oddLeaveEarly': '异常-迟到',
		'oddAbsenteeism': '异常-早退',
		'oddFailureToClockIn': '异常-旷职',
		'oddExcessAttendanceHours': '异常-未打卡',
		'oddOvertimeClockInTime': '异常-超时出勤',
		'oddOvertimeSwiping': '异常-加班刷卡时间不足',
		'overtimeClockInTime': '加班刷卡时间不足',
		'oddClockInOutData': '异常-刷卡资料不足',
		'explanation': '常状态各项目的计数，来自于该员工出勤纪录比对后的结果。',
		'explanationAll': '包含已核准与签核中状态。总合值因算法限制，约为概略值，细节请点击查看全部。',
		'late': '迟到',
		'leaveEarly': '早退',
		'absenteeism': '旷职',
		'failureToClockIn': '未打卡',
		'excessAttendanceHours': '超时出勤',
		'clockInOutData': '刷卡资料不足',
		'anomalousDetails': '出勤打卡异常明细',
		'searchRange': '查询期间:',
		'total': '共计',
		'anomalousData': '项异常',
		'haveBeenProcessed': '已处理',
		'waitForProcessing': '待处理',
	},
	'hp.m3.m310050': {
		'downloadMultiplierStatistical': '下载倍率统计表',
		'totalHourMin': '<%=h%>小时 <%=m%>分钟',
		'overtimeDetails': '加班明细',
		'searchRange': '查询期间:',
		'overtimeHourMin': '加班时数合计 <%=h%>小时 <%=m%>分钟',
		'vestingDate': '归属日:',
		'available': '可休期间：',
		'noExpiration': '无限期',
		'aboutToExpire': '即将到期',
		'subordinateOvertimeRateStatistics': '部属加班倍率统计表',
		'subordinateOvertimeRateCalendar': '部属加班倍率统计表–依行事历别统计',
		'subordinateOvertimeDetails': '部属加班明细表',
		'startDate': '加班起始时间',
		'endDate': '加班结束时间',
		'overtimeVestingDate': '加班归属日',
		'overtime': '加班',
		'deduction': '扣除',
		'compensatoryLeaveStart': '补休假可休起始日',
		'compensatoryLeaveEnd': '补休假可休截止日',
		'times1334': '1.334倍',
		'workingDay': '工作日',
		'times': ' 倍',
		'statisticsTitle': '部属加班倍率统计表',
		'rateCalendarTitle': '部属加班倍率统计表–依行事历别统计',
	},
	'hp.m3.m310060': {
		'statisticsloadingError': '加载公司年度假勤统计错误',
		'listMode': '列表模式',
		'sumMode': '总和模式',
		'leaveRecords': '假勤记录',
		'annualUnit': '特休 <%=n%> 小时',
		'compensatoryUnit': '补休 <%=n%> 小时',
		'flexibleUnit': '弹休假 <%=n%> 小时',
		'officialUnit': '公司假 <%=n%> 小时',
		'generalUnit': '一般假勤 <%=n%> 小时',
		'subordinateLeaveDetails': '部属假勤明细表',
		'leaveStartDate': '假勤起始时间',
		'leaveEndDate': '假勤结束时间',
		'leave': '假勤',
		'leaveResumption': '销假',
		'actual': '实际',
		'attachment': '附件名称',
		'leaveTime': '假勤时间',
		'approx': '约 <%=n%> 小时',
	},
	'hp.m3.m310070': {
		'keyword': '员工关键词',
		'leaveDataSearch': '部属出/假勤数据查询',
		'noData ': '没有符合查询条件的数据',
		'leaveSummary': '部属假勤总表',
		'downloadYear': '统计年度：',
		'used': '已休时数',
		'remaining': '剩余时数',
	},
	'hp.m3.m310110': {
		'subordinateProfileSearch': '部属个人资料查询',
		'salaryData': '薪资资料',
		'downloadingFailed': '加载个人信息错误',
		'jobAndYearOfService': '职务及年资',
		'eduAndWorking': '学经历资料',
		'skillsAndExpertise': '技能专长证照',
		'payrollLoadingError': '加载薪资袋错误',
		'noSalaryRule': '尚无已生效的薪资规则',
		'fromSalaryCalculation': '显示不计薪科目',
		'effectiveDate': '生效日期：',
		'salaryMethod': '计薪方式：',
		'salaryApproval': '核薪原因：',
		'changeHistory': '异动历程',
		'salaryAccount': '薪资料目',
		'partOfTheSalary': '是否计薪',
		'numberOfChanges': '异动次数：',
		'loginFailed': '登入失败：',
		'noData': '目前无资料',
		'listening': '听',
		'speaking': '说',
		'reading': '读',
		'writing': '写',
		'level': '程度',
	},
	'hp.m4.m410110': {
		'familyMembersError': '亲属名单加载错误',
		'changeDetails': '异动明细',
		'listOfFamilyMembers': '亲属名单',
		'changeDetailsOfFamilyMembers': '亲属名单异动明细',
		'rejectionOpinion': '驳回意见：',
		'relationship': '关系',
		'birthday': '生日',
		'nationality': '国籍',
		'dependents': '被扶养人',
		'idNumber': '身分证号',
		'alienResidentNumber': '外侨统一证号',
		'degreeOfDisability': '身障程度',
		'survivalStatus': '存殁',
		'requestTimeStart': '申请时间(起)',
		'requestTimeEnd': '申请时间(讫)',
		'auditStatus': '审核状态',
		'changeitems': '异动项目',
		'approver': '审核人',
		'auditTime': '审核时间',
		'result': '审核结果',
		'originalContent': '原内容',
		'contentAfterModification': '维护后内容',
		'blueTextRepresents': '蓝字代表申请异动项目',
		'deleted': '(删除)',
		'releativesData': '亲属名单数据不存在',
		'attachmentsError': '储存附件发生错误',
		'dependentsT': '被扶养人：',
		'reviewNotification': '您已在 <%=t%> 提交数据，请稍待管理者审核通知。',
		'wantToDelete': '确定要删除亲属名单:「',
		'wantToDelete1': '」 吗?',
		'exJessicaLo': '例:罗琪梦',
		'error': '错误',
		'category': '类别',
		'changeIems': '项目',
		'resultTd': '状态',
		'note': '备注',
		'approved': '核准',
		'rejected': '驳回',
		'releativesError': '<%=name%> 已有保险相关资料，无法删除',
		'updateError': '<%=s%>异动失败',
	},
	'hp.m4.m410100': {
		'profileLoadingError': '个人资料加载错误',
		'changeDetails': '异动明细',
		'personalSummary': '个人摘要',
		'contactInfo': '联络信息',
		'education': '学历',
		'workingExperiences': '经历',
		'skillsAndExpertise': '技能专长',
		'certifications': '证照',
		'disabilityCategory': '身障类别',
		'passportName': '护照姓名',
		'passportnumber': '护照号码',
		'exitDates': '入出境日期',
		'expirationDateOfResidencePermit': '居留证到期日',
		'intermediaryUnit': '中介单位',
		'contactPhoneNumber': '通讯电话',
		'primaryEmergencyContact': '主要紧急联络人',
		'noData': '(空白)',
		'secondaryEmergencyContact': '次要紧急联络人',
		'languageProficiency': '语言能力',
		'dialectProficiency': '方言能力',
		'level': '程度',
		'competency': '职能',
		'schoolNameChinese': '学校名称 (中文)',
		'departmentNameChinese': '科系名称 (中文)',
		'dateOfEnrollment': '入学日期',
		'dateOfDepartureFromschool': '离校日期',
		'departmentProgramCategory': '科系类别',
		'companyName': '公司名称',
		'dateOfEmployment': '就职日期',
		'dateOfResignation': '离职日期',
		'positionCategory': '职务类别',
		'managerialPosition': '是否担任管理职',
		'certificateName': '证照名称',
		'type': '种类',
		'certificateNumber': '证照号码',
		'issuingAuthority': '请填写发照单位',
		'approvalNumber': '核准文号',
		'trainingHours': '训练时数',
		'acquisitionDate': '取得日期',
		'cancellationDate': '注销日期',
		'changeDetailsOfProfile': '基本信息异动明细',
		'changeCategory': '异动类别',
		'category': '类别',
		'disabilityCategoryIsDuplicated': '身障类别重复',
		'exitDateRangeExists': '已有相同的出入境日期区间数据',
		'theSavedData': '出入境日期区间需大于已储存数据',
		'dateIsDuplicated': '居留证到期日重复',
		'exJessicaLoEN': '例: Jessica Lo',
		'age': '年龄',
		'year': '<%=n%>岁',
		'asShownOnPassport': '护照姓名 (as shown on passport)',
		'passportNumber': '护照号码 (Passport No)',
		'idNoARC': '外侨统一证号 (ID No)',
		'doesNotExist': '联络信息数据不存在',
		'areYouSave': '若异动员工的公司email，则Portal需重新认证账号才可使用。确定要储存吗？',
		'countyCityArea': '请选择县市区域',
		'permanentAddress': '请输入户籍地址',
		'registeredInformation': '同户籍',
		'mailingAddress': '请输入通讯地址',
		'exTel': '例: 02 22881256',
		'exCel': '例: 0912 345 678',
		'exEmail': '例: youremail@company.com',
		'exEmail2': '例: youremail@urself.com',
		'exSelect': '请选择',
		'listeningTemplate': '听<%=n%>',
		'speakingTemplate': '说<%=n%>',
		'readingTemplate': '读<%=n%>',
		'writingTemplate': '写<%=n%>',
		'listening': '听',
		'speaking': '说',
		'reading': '读',
		'writing': '写',
		'exCompetency': '请挑选「职能」(最多50项)',
		'eduDataDoesNotExist': '学历数据不存在',
		'reviewNotification': '您已在 <%=t%> 提交数据，请稍待管理者审核通知。',
		'youWantToDelete': '您要删除<%=d%>吗?',
		'exCollege': '例: 104系统大学',
		'exDepartments': '例: 工业工程系',
		'graduation': '毕业',
		'periodOfStudy': '就学期间',
		'expDoesNotExist': '经历数据不存在',
		'companyNameP': '请输入公司名称',
		'termOfEmployment': '任职期间',
		'certificationAddingFailed': '新增证照失败',
		'certificationDataDoesNotExist': '证照数据不存在',
		'laterThanThe': '生效日期大于有效日期',
		'laterThanTheAcquisitionDate': '取得日期大于注销日期',
		'expirationDateT': '有效日期：',
		'effectiveDateT': '生效日期：',
		'exTOEIC': '例: TOEIC',
		'exNo': '例: 12345678',
		'pleaseFillIssuingAuthority': '请填写发照单位',
		'number': '请填入时数',
		'date': '请选择日期',
		'underReview': '资料审核中',
		'loadingError': '<%=t%>加载错误',
		'updatedSuccessfully': '<%=s%>更新成功',
		'noMessageNotification': '无讯息通知模板',
		'noAssignedPersonnel': '无承办人员',
		'noFieldChanges': '无字段异动',
		'noRelatedFormSettings': '没有相关窗体设定',
		'pleaseRefreshAndRryAgain': '含有禁止操作字段，请重新整理后再试一次',
		'overridden': '需覆写此 method',
		'notRequireReview': '编辑不需审核数据',
		'editingRequiresToReview': '编辑需审核数据',
		'submit': '送出审核',
		'itWillTakeEffect': '以下字段填写后，需送出审核，由管理员进行审核，通过后即生效。',
		'afterApproval': '您已在 <%=t%> 提交数据，请稍待管理员审核通知。待审核通过后，再开放编辑以下字段。',
		'waitingForTheReviewProcess': '您已在 <%=t%> 提交数据，请稍待管理员审核通知，等待审核的过程中，您也可以继续编辑其他字段。',
		'wantToDeleteTheData': '你确定要删除此笔数据吗？',
		'hasBeenDeleted': '<%=d%>已删除',
		'deletionFailed': '<%=d%>删除失败',
		'notYetImplemented': '尚未实作 <%=n%> 的 renderBody()',
		'deleteTheData': '确定删除？',
		'administratorReviewAndNotification': '您已在 <%=t%> 提交数据，请稍待管理者审核通知。',
		'language': '语言',
		'identity': '身份',
		'dialect': '方言',
		'expirationDate': '有效日期',
	},
	'hp.m3.m310220': {
		'readingFailed': '读取统计失败',
		'shiftGroup': '群组',
		'searchRange': '时间区间',
		'items': '班别项目',
		'subtotal': '小计',
		'downloadFail': '下载班表人力统计失败',
		'notSchedule': '未排班',
		'leave': '请假',
		'allDayLeave': '全天请假',
		'overtime': '加班',
		'rotatingShiftsByShiftEmployees': '排班(依班别)员工',
		'rotatingShiftsByPeriodEmployees': '排班(依时段)员工',
		'allRotatingShiftsEmployees': '所有排班员工',
		'workTime': '工作时间：',
		'restTime': '休息时间：',
		'exportDate': '汇出日期：',
		'startendtime': '起讫时间：',
		'shiftTime': '班表起讫时间：',
		'dept': '部门：',
		'date': '日期',
		'manpowerStatisticsByClass': '班别人力统计',
		'manpowerStatisticsByShift': '排班人力统计',
		'shift': '排班班别',
		'workTimeTitle': '工作时间',
		'restTimeTitle': '休息时间',
		'allowableOvertimeHours': '可加班时间',
		'prohibitionOfOvertimeHours': '禁止加班时间',
		'shiftHours': '班别时数：<%=N%>小时',
		'dailyTotal': '日总计',
		'actualShiftHours': '实际班别时数：<%=N%>小时',
		'everyHourOfWorkMinuteOfRest': '每工作<%=H%>小时，休息<%=M%>分钟',
		'previousDay': '前日',
		'currentDay': '当日',
		'followingDay': '次日',
		'restTemp': '每<%=H%>小时要休息<%=M%>分钟',
		'weeklyTemp': '每周：每<%=H%>小时要休息<%=M%>分钟',
		'fixedTimeTemp': '固定時間：<%=S%> - <%=E%>',
	},
	'hp.m3.m310230': {
		'reportSettings': '报表设定',
		'manpowerStatisticsbyPeriod': '时段人力统计',
		'startendtime': '起讫时间',
		'shiftGroupIsNotSet': '未设定群组排班人员',
	},
	'hp.m4.m410090': {
		'62-bonusForExceeding': '62-所属投保单位给付全年累计逾当月投保金额四倍部分之奖金',
		'63-nonInsuredUnits': '63-非所属投保单位给付之薪资所得',
		'65-incomeFromProfessionalPractice': '65-执行业务收入',
		'66-dividendIncome': '66-股利所得',
		'67-interestIncome': '67-利息所得',
		'68-rentalIncome': '68-租金收入',
		'reportType': '报表类型',
		'corporateTaxIDNo.': '公司统编',
		'period': '保费期间',
		'result': '数据搜寻结果',
		'details': '明细',
		'insurancePremiumProofSearch': '保费明细查询',
		'proof': '证明',
		'laborInsurancePremiumDetailsItem': '劳保保费明细',
		'yearMonthOfHealth': '健保年月',
		'yearMonthOfLabor': '劳保年月',
		'actualPaidLaborInsurancePremium': '实缴劳保费',
		'healthInsurancePremiumDetailsItem': '健保保费明细',
		'relationship': '称谓',
		'actualPaidHelathInsurancePremium': '实缴健保费',
		'laborAndHealthInsurancePremiumDetails': '劳保、健保保费明细',
		'TotalActualPaidInsurancePremium': '实缴总保费',
		'proofOfLaborInsuranceAndHealthInsurancePremiums': '劳保、健保保费证明',
		'IDNumber': '身分证字号',
		'dateOfBirth': '出生年月日',
		'healthInsurancePremium': '健保费',
		'laborInsurancePremium': '劳保费',
		'totalInsurancePremium': '总保费',
		'nationalHealthInsurance': '全民健康保险',
		'certificateOfSupplementaryInsurancePremium': '各类所得(收入)扣缴补充保险费证明单',
		'unifiedBusinessNumberForDeductionUnit': '扣费单位统一编号',
		"taxpayersIDNo": '所得人身分证号',
		'incomeCategory': '所得(收入)类别',
		'taxpayersName': '所得人姓名',
		'taxpayersAddress': '所得人地址',
		'yearOfPayment': '所得给付年度',
		'totalAmountPaid': '给付总额',
		'amountOfSupplementaryInsurancePremiumWithheld': '扣缴补充保险费金额',
		'deductionUnit': '扣费单位',
		'name': '名称',
		'taxWithholders': '扣费义务人',
		'incomeCategoryExplain': '所得(收入)类别说明',
		'accurate': '以上数据经查证正确无误。',
		'corporateTaxIDNumber': '统一编号 :',
		'companyName': '公司名称 :',
		'companyAddress': '公司地址 :',
		'nameOfTheResponsiblePerson': '负责人姓名 :',
		'fiscalYear': '所得年度',
		'myself': '本人',
		'address': '地址',
		'page': '页次：第 <%=temp1%> 页／共 <%=temp2%> 页',
		'noInformation': '无数据，试试重新搜寻吧！',
		'amountInNT': '金额以新台币计',
		'dateOfCompilation': '制表日期 : ',
		'groupInsuranceApplicantNo': '投保单位代号',
		'proofOfPremium': '保费证明',
		'premiumDetails': '保费明细',
		'proofOfSupplementaryPremium': '补充保费证明',
		'healthInsurancePremiumDetails': '健保明细',
		'laborInsurancePremiumDetails': '劳保明细',
	},
	'hp.m4.m410030': {
		'fiscalYear': '所得年度',
		'noTaxWithholdingForm': '无扣缴凭单资料',
		'taxWithholdingFormSearch': '扣缴凭单查询',
		'theInquiryFunctionIsCurrentlyUnavailable.': '目前未开放查询功能',
		'parameterFileLoadingError': '参数档加载错误',
		'taxWithholdingFormLoadingError': '扣缴凭单加载错误',
		'noTaxWithholdingFormFor': '申请所得年度 <%=temp1%>，无扣缴凭单资料',
		'incomeLessThan1000 ': '申請所得年度$<%=temp1%>，所得未滿1,000元，不需扣繳憑單',
		'taxWithholdingForm': '-扣缴凭单.pdf',
	},
	'hp.m5.m510050': {
		'applicantApproverFormNo': '申请人/签核人/被异动人/表单编号',
		'deleteByBatch': '批次删单',
		'cancelArchivingByBatch': '批次取消封存',
		'generalForm': '一般窗体',
		'archivedForm': '封存窗体',
		'rquestLeaveOver': '申请时间/假勤时间/加班时间/调班时间',
		'unableToWithdrawOrDelete': '无法抽单或删单',
		'withdrawalFailed': '抽单失败: 窗体已被他人抽单、删单、签核完成、或已进行结算，因此无法抽单',
		'deletionFailed': '删单失败',
		'confirmDeletion': '确认删单',
		'deletionCompleted': '删单完成',
		'reason': '原因说明',
		'confirmWithdrawn': '确认抽单',
	},
	'hp.m4.m410200': {
		'shiftType': '班别属性：',
		'calendar': '行事历别：',
		'shift': '排班班别：',
		'noEmployeeAttendanceRulesOrCalendars': '未建立员工出勤规则或行事历的数据',
		'leaveOvertimeDetails': '请假加班明细',
		'annualSchedule': '年度班表查詢',
		'monthlySchedule': '月行事历查询',
		'loadingFailed': '加载先导数据失败',
		'beforeTheChange': '异动前',
		'afterTheChange': '异动后',
		'notScheduled': '未排班:',
		'loadingOfShiftDataFailed': '加载员工班表数据错误',
		'leaveAbbreviation': '假',
		'leave': '请假',
		'leaveTime': '请假时间:',
		'leaveResumption': '销假时间:',
	},
	'h2.am.ShiftingSidePanelComps': {
		'workingHoursStatistics': '工时统计',
		'hoursDays': '时数/天数',
		'scheduledHours': '排班时数',
		'numberOfUnscheduledDays': '未排班天数',
		'shouldBeScheduled': '应排',
		'alreadyScheduled': '已排',
		'difference': '差异',
		'statisticsOfFlexibleWorkingHoursIntervals': '变形工时区间统计',
		'period': '期间',
		'workingHours': '已排时数',
		'publicHolidays': '例假日',
		'restDays': '休息日',
		'theCycleDaysAreNotMet': '周期天数未满',
		'calendarStatistics': '行事历别统计',
		'shiftStatistics': '班别统计',
		'shift': '排班班别',
		'labelStatistics': '标签统计',
		'leaveOvertimeStatistics': '请假/加班统计',
		'hoursTimes': '时数/次数',
		'overtimeHours': '加班时数',
		'leaveHours': '请假时数',
		'totalFullDayLeaveInstances': '全天请假次数',
		'project': '项目',
		'hour': '小时',
		'day': '天',
		'days': '天数',
		'unitOfDays': '天数',
		'calendar': '行事历别',
		'shiftLabel': '排班标签',
		'times': '次数',
		'secondary': '次',
		'onlyWorkingDays': '只计算工作日',
	},
	'hp.m5.m510040': {
		'formName': '窗体名称',
		'firstSubstitute': '第一位代理人',
		'secondSubstitute': '第二位代理人',
		'agentStatus': '代理状态',
		'signOffAgentTime': '签核代理时间',
		'selectSubstitute': '选择代理人',
		'atLeastOneSubstitute': '必填至少1位',
		'proxyTime': '代理时间',
		'atLeastOneInterval': '必填至少1组',
		'setSubstituteApprover': '签核代理人设定',
		'batchSettings': '批次设定',
		'substituteApproverBatchSettings': '签核代理人设定 - 批次设定',
		'selectForms': '选择窗体',
		'applyTheSettings': '套用上方设定到所选择的窗体',
		'noFormDataFound': '查无窗体数据',
		'theModificationOfApproverSubstituteSettingsIsComplete': '修改签核代理人设定完成',
		'theModificationOfApproverSubstituteSettingsFailed': '修改签核代理人设定失败',
		'theFormDoesNotExist': '窗体不存在',
		'theEndDateOfTheProxyTimeIsBeforeTheSetDate': '代理时间迄日小于设定日时间，请重新设定',
		'noProxyTimeConflictIsAllowed': '代理时间重复，请重新设定',
		'theProxyStartAndEndTimesCannotOverlap': '代理起讫时间不可重复，请重新设定',
		'savedSuccessfully': '储存成功',
		'batchSettingsFailed': '批次设定错误',
		'pleaseSelectForms': '请选择窗体',
	},
	'hp.m3.m310210': {
		'subordinateShift': '员工班表信息',
		'downloadReport': '下载报表',
		'reports': '统计报表',
		'failedToExportTheReport': '导出报表失败',
		'noDataAvailableForExport': '无数据可导出，请重新设定汇出条件',
		'shiftStartEndTime': '班表起讫时间',
		'pleaseSetTheShiftStartEndTime': '请设定班表起讫时间',
		'allEmployees': '全体员工',
		'specificEmployees': '特定员工',
		'reportType': '报表名称',
		'shiftHoursSummary': '排班时数汇总表',
		'employeePeriod': '人力明细表（依员工／时段）',
		'shiftDate': '人力统计表（依班别／日期）',
		'shiftAndDate': '人力统计表（依班别 日期）',
		'periodDate': '人力统计表（依时段／日期）',
		'periodAndDate': '人力统计表（依时段 日期）',
		'totalShiftHours': '加总班别时数',
		'totalClockInHours': '加总刷卡时数',
		'totalOvertimeHours': '加总加班时数',
		'totalLeaveHours': '加总请假时数',
		'shiftReport': '排班报表',
		'totalManpowerHours': '加总人力／时数',
		'timeUnit': '时间单位：',
		'shiftToN': '班别(<%=N%>)',
		'shiftHours': '班别时数',
		'clockInHours': '刷卡时数',
		'employee': '员工：',
		'totalEmployee': '共<%=N%>位员工',
		'specificReport': '特定员工，',
	},
	'hp.m2.m210021': {
		'tree': '树形图',
		'pyramid': '金字塔图',
		'display': '展开到',
		'proportion': '显示比例',
		'deptHead': '显示部门主管',
		'closedDpet': '显示关闭部门',
		'deptHeadCount': '显示部门人数',
		'noCurrentSupervisor': '无现任主管',
		'noSupervisorAssigned': '未设定主管',
		'noCurrentDeputySupervisor': '无现任副主管',
		'noDeputySpuerviseorAssigned': '未设定副主管',
		'code': '代码',
		'name': '名称',
		'abbr': '简称',
		'supervisor': '主管',
		'deputySupervisor': '副主管',
		'upperDept': '上层部门',
		'organizationLevel': '组织层级',
		'deptAddress': '部门地址',
		'deptEnglishAddress': '英文地址',
		'tel': '电话',
		'fax': '传真',
		'note': '备注',
		'status': '状态',
		'noOrganizationalData': '无可查看组织结构的公司',
		'noMatchData': '咦，找不到符合的数据 !',
		'dataNotEffectSearchCriteria': '可能是数据尚未生效，建议您询问系统管理员或重新设定搜寻条件',
		'expandFromDept': '以此部门展开',
		'onlyDisplay': '只显示',
		'subDept': '以下部门',
		'onlyDisplaySunDept': '只显示以下部门',
		'restoreOrganizationChart': '还原全公司组织结构',
	},
	'hp.m3.m310410_new': {
		'theNameOfTheSchedule': '班表名称',
		'enterAScheduleName': '输入班表名称',
		'scheduleTime': '班表时间',
		'scheduleFrom': '班表时间 (起)',
		'timetableAttendance': '班表时间 (讫)',
		'holidaysTotalTempDays': '假节日(共<%=temp1%>日)',
		'shiftStaff': '排班人员',
		'pleaseSelectAShiftGroup': '请选择排班群组',
		'editMembers': '编辑成员',
		'pleaseSelectYourRegularClass': '请选择常用班别',
		'pleaseSelectAFrequentlyUsedTag': '请选择常用标签',
		'employeePreScheduling': '员工预排班表',
		'rowableTypes': '可排类型',
		'allowEmployeesToPrescheduleShiftsWhen': '允许员工预排班表时，可以排的类型。譬如允许员工排休息日，则员工不可排国定假日及例假日。<%=temp1%>若开放员工可排「请假」，仅代表员工可预先压请假，实际请假仍需提交申请单。',
		'employeesCanBeScheduledForShifts': '员工可排班别',
		'pleaseSelectTheEmployeeAvailableShifts': '请选择员工可排班别',
		'openSchedulingHours': '开放排班时间',
		'ifTheScheduleStartsAndEnds': '若班表起讫为7/1~7/30，开放排班时间为前10~5天，则员工可于6/21~6/26预排班。',
		'theScheduleStartsBeforeTheDate': '班表起日前',
		'pleaseEnter': '请输入',
		'sky': '天',
		'daysYouCanSchedule': '可于 <%=temp1%>~<%=temp2%> 排<%=temp3%>~<%=temp4%>的班表',
		'openToViewOtherEmployeesPre': '开放检视其他员工预排班表',
		'canEmployeesViewOtherStaffSchedules': '员工可否检视同份班表中的其他员工班表。',
		'editTheRoster': '编辑排班人员',
		'thereShouldBeAtLeastOne': '排班人员至少要一位',
		'aTotalOfPersonnelWereIncluded': '共纳入排班人员<%=temp1%>位',
		'storageToTheNextStep': '储存，至下一步',
		'itMustNotBeLessThan': '不可小于后方的时间',
		'failedToSaveScheduleTheAvailable': '储存班表失败：员工预排班表的可排类型，必须同时选入班别及标签。',
		'ifYouChangeTheScheduleTime': '若更改班表时间，班表内容将会清空，确定要更改吗？',
		'failedToAddASchedule': '新增班表失败',
		'theScheduleDoesNotExist': '班表不存在',
		'duplicateScheduleNames': '排班群组已停用，请重新选择',
		'shiftGroupDisabled': 'The shift group is disabled. Please select another one.',
		'thereAreNoScheduledStaffPlease': '无可排班人员，请重新确认',
		'saveAndPublishSchedules': '储存并发布班表',
		'theStorageScheduleWasSuccessful': '储存班表成功',
		'addedASchedule': '新增班表',
		'addedAScheduleDlg': '新增班表',
		'setScheduleProperties': '设定班表属性',
		'editTheSchedule': '编辑班表',
		'deleteTheScheduleAndYouRe': '删除班表完成!',
		'deleteAScheduleError': '删除班表错误',
		'areYouSureYouWantTo': '确定要删除此 <%=temp1%> 笔班表吗?',
		'scheduleStatus': '班表状态',
		'reasonsForRejection': '驳回原因',
		'unpublish': '取消发布',
		'stockpile': '储存',
		'cancelThisSchedule': '取消此班表？',
		'theScheduleHasnTBeenSaved': '班表尚未储存，确定要取消吗？',
		'goBackToThePreviousStep': '回到上一步',
		'pleaseMakeSureThatTheSchedule': '请确认已储存班表，避免数据遗失。',
		'areYouSureYouWantTo2': '确定回到上一步吗？',
		'time': '时间',
		'inShifts': '排班中',
		'toBeReviewed': '待审核',
		'published': '已发布',
		'reasonsForRejectionOfSchedules': '驳回班表原因',
		'className': '班表名称：',
		'dismissalOfThePerson': '驳回人',
		'timeOfRejection': '驳回时间',
		'unpublishTheSchedule': '取消发布班表',
		'theScheduleWasUnpublishedSuccessfully': '取消发布班表成功',
		'failedToUnpublishSchedule': '取消发布班表失败',
		'oKToUnpublish': '确定取消发布',
		'areYouSureYouWantTo3': '确定要取消发布此班表？',
		'manpowerStatistics': '人力统计',
		'failedToDownloadTheSummaryTable': '下载总表失败',
		'thereIsNoDataToExport': '无数据可导出，请重新设定汇出条件',
		'theDatePeriodMustBeWithin': '日期区间需在2个月内',
		'onlyPublishedSchedulesAreDownloaded': '仅下载已发布的班表',
		'exportTheObject': '导出对象',
		'approver': '审核人',
		'endDateAfterStartDate': '结束时间需晚于或等于开始时间',
		'maxPeople': '排班人员上限60人',
	},
	'hp.m3.m310410': {
		'myNewSchedule': '我新增的班表',
		'theScheduleIReviewed': '我审核的班表',
	},
	'hp.m3.m310410_statistics': {
		'actualShiftHoursHours': '实际班别时数：<%=temp1%>小时',
		'realTimeManpowerStatistics': '实时人力统计',
		'shiftStagingFailed': '班表暂存失败',
		'failedToReadParameters': '读取参数失败',
		'failedToExportShiftStatistics': '汇出班表统计失败',
		'realTimeClassManpowerStatistics': '实时班别人力统计',
		'realTimeManpowerStatisticsForPeriods': '实时时段人力统计',
		'downloadTheReport': '下载报表',
		'employees': '位员工',
		'startendtime': '时间',
		'realTimeShiftReport': '实时班别人力统计表',
		'realTimeSectionReport': '实时时段人力统计表',
	},
	'hp.m3.m310410_shifting': {
		'ndSection': '二段班',
		'failedToGetTheSchedule': '班表获取失败',
		'workingHours': '工作时间：<%=temp1%>',
		'allowableOvertimeHours': '可加班时间：',
		'prohibitionOfOvertimeHours': '禁止加班时间：',
		'clearThemAll': '全部清除',
		'overlappingWorkingHours': '工作时间重迭',
		'theCalendarTimeOfTheClass': '班别历日时间不同',
		'theOvertimeAttributionDaysOfThe': '班别加班归属日不同',
		'temp': '<%=temp1%> 与 <%=temp2%><%=temp3%>时间：<%=temp1%>',
		'temp1': '<%=temp1%>~<%=temp2%> and <%=temp3%>~<%=temp4%> <%=temp5%>',
		'overlapsWithRestTime': '',
		'shiftSchedules': '排班班别',
		'thereAreNoScheduledShiftsOn': '工作日未排班',
		'theClassIsFullAndNo': '班别已排满，无法再新增班别',
		'aMaximumOfScheduleTagsCan': '每个班别最多新增 <%=temp1%> 个排班标签',
		'thereAreDaysOfClassesAre': '有<%=temp1%>天班别已排满，无法再新增班别',
		'thereAreStaffClassesAreFull': '有<%=temp1%>位员工班别已排满，无法再新增班别',
		'scheduleStatistics': '班表统计',
		'theScheduleHasBeenScheduledSection': '班表已排定<%=temp1%>段班，不可减少可排班别数',
		'thereIsAnErrorInThe': '班表存在错误，无法储存暂存档。',
		'theImportWasSuccessful': '汇入成功',
		'thereIsNoScheduleInformationTo': '没有班表数据可储存',
		'thereIsAnErrorInThe2': '班表存在错误，无法储存。',
		'performAComparisonOfStoredData': '进行储存数据比对',
		'saveTheError': '储存错误',
		'someOfTheStaffHaveChanged': '部分员工已排时数已变更，要离开网站吗？',
		'optionToCollapse': '选项收合',
		'shiftsCanBeScheduledDaily': '每日可排班别',
		'incomingClassScheduling': '汇入班别排班',
		'importTimeSlotScheduling': '汇入时段排班',
		'roundRobinScheduling': '循环排班',
		'clearTheSchedule': '清空班表',
		'importEmployeeSchedules': '汇入员工预排',
		'batchJobs': '批次作业',
		'other': '其他',
		'areYouSureYouWantTo': '确定要清空此班表的所有班表数据?',
		'day': '第<%=temp1%>天: <%=temp2%>',
		'breaksOverlapWithMultipleShifts': '休息时间与多个班别工作时间重迭',
		'theSetupIsComplete': '设定完成',
		'noTimeSlotSchedulingEmployeeData': '无时段排班员工数据',
		'areYouSureYouWantTo2': '确定要套用新规则，取代现在的班表数据?',
		'theClassScheduleScreenImportFormat': '班表画面汇入格式.xlsx',
		'selectThePersonOnTheRoster': '选择排班人员',
		'timeManagementRulesAreNotBeing': '未符合工时管理规则',
		'theTimeRuleCheckFailed': '工时规则检查失败',
		'thereIsNoExportMaterial': '无导出资料',
		'employeesOtherEmployeesEmployeesATotal': '<%=temp1%> <%=temp2%> 位员工 + 其他员工 <%=temp3%> 位员工，共 <%=temp4%> 位员工',
		'scheduleStartAndEndTimes': '班表起讫时间',
		'theTypeOfWorkException': '工时异常类型',
		'violationOfTheRules': '违反规则',
		'exceptionDate': '异常日期',
		'allEmployeesInTheShiftAre': '班表内所有员工都符合工时规则检查',
		'theTypeOfWorkException2': '工作异常类型',
		'anomalyIntervals': '异常区间',
		'workProjects': '工时项目',
		'schedulesStoreResults': '班表储存结果',
		'saveShiftFailed': '储存排班失败',
		'shiftStaff': '排班人员:',
		'classScheduleStartsAndEndsTimetable': '班表起讫时间:',
		'workingHoursRuleReminder': '<%=temp1%>笔 (工时规则提醒: <%=temp2%>笔)',
		'executionResult': '执行结果',
		'theResultOfTheWorkHour': '工时异常检查结果',
		'reminderCount': '提醒笔数',
		'numberOfStrokesIsProhibited': '禁止笔数',
		'pen': '<%=temp1%>笔',
		'remindersOfAbnormalWorkingHours': '工时异常提醒',
		'theTimeRulesAreNotBeing': '未符合工时规则',
		'scheduledEmployeesHaveBeenSelected': '已选取排班员工',
		'schedule': '排班表',
		'offDays': '请假天数',
		'offFullDays': '全天请假天数',
		'deformPeriod': '变形工时周期切换',
		'shifting': '班表数据',
		'leaveName': '假节日名称',
		'restTemplate': '周期：每<%=H%>小时休息<%=M%>分钟',
		'sumFile': '排班总表',
		'totalStaff': '全体员工 <%=N%> 位',
		'totalStaff2': '全体员工 <%=N%> 位',
		'shiftResult': '储存班表结果',
		'failSchedule': '错误班表画面导入格式',
		'areYouSureYouWantTo3': '确定批次清除班表数据？',
	},
	'hp.m3.m310410_extra': {
		'employees': '<%=temp1%> <%=temp2%> 位员工',
		'checkTheWorkingHours': '检查工时',
		'exportSchedules': '汇出班表',
		'failedToExportSchedules': '汇出班表失败',
		'allEmployeesInTheSchedule': '班表内所有员工',
		'partOfTheStaff': '部份员工',
		'theScheduleDisplaysInformation': '班表显示信息',
		'classScheduleContent': '班表内容',
		'showHolidayNonWorkingDay': '显示假节日(非工作日)',
		'calendarExportFormat': '行事历别汇出格式',
		'shiftExportFormat': '排班班别汇出格式',
		'shiftLabelExportFormat': '排班标签导出格式',
		'someDatesArePastTheSchedule': '部分日期超过班表异动期限',
		'schedulingDataIsAvailable': '已有排班资料',
		'violationOfWorkingHoursRulesReminders': '违反工时规则（提醒）',
		'employeesAreNotScheduledEmployeesOn': '员工部分日期不是排班员工',
		'importClassSchedules': '汇入班别排班班表',
		'theImportFormatIsIncorrect': '汇入格式错误',
		'theNumberOfShiftsThatEmployees': '员工可排班别数不同',
		'scheduleDatesAreNotConsecutive': '班表日期不连续',
		'theNumberOfScheduleDaysExceeds': '班表天数超过限制',
		'exceedingTheNumberOfShiftsThat': '超过可排班别数',
		'pleaseDoNotChangeTheImport': '请勿异动班表汇入格式，否则可能造成班表无法汇入。',
		'ifYouAreSureThatYou': '汇入后一律覆盖预览的班表内容，若您确定要更新班表数据，务必点击「储存班表」按钮，才会更新成功。',
		'theCalendarIsCombinedWithDifferent': '行事历别班别合并，不含标签',
		'theCalendarIsCombinedWithTags': '行事历别班别合并含标签',
		'calendarClassesAreNotCombined': '行事历别班别不合并',
		'numberOfShiftTags': '排班标签数',
		'importFormat': '汇入类型',
		'calendarTempOrClass': '行事历别<%=temp1%>或班别',
		'incorrectFormatting': '格式不正确',
		'required': '(必填)',
		'optional': '(非必填)',
		'abnormalData': '异常资料:',
		'downloadTheResultsOfTheTime': '下载工时检查结果',
		'importTimeSlotSchedules': '汇入时段排班班表',
		'employeesOtherEmployeesEmployeesATotal': '<%=temp1%> <%=temp2%> 位员工 + <%=temp3%> 其他员工 <%=temp4%> 位员工，共 <%=temp5%> 位员工',
		'classScheduleStartsAndEndsTimetable': '班表起讫时间：',
		'shiftStaff': '排班人员：',
		'succeed': '成功：',
		'failed': '失败：',
		'workingHoursRuleReminderTransactions': '<%=temp1%>笔(工时规则提醒:<%=temp2%>笔)，<%=temp3%>',
		'itCannotBePublishedBecauseThere': '！因尚有失败数据，所以无法发布',
		'confirmTheRelease': '确定发布',
		'theReleaseWasSuccessful': '发布成功',
		'reminderOfWorkingHours': '<%=temp1%>笔 (工时规则提醒: <%=temp2%>笔)',
		'importEmployeeSchedules': '汇入员工预排班表<%=temp1%>',
		'onceAnEmployeeScheduleIsImported': '！汇入员工预排班表后，员工即无法进行预排作业。',
		'pleaseCheckAtLeastOneEmployee': '请至少勾选一位员工',
		'previewStatus': '预排状态',
		'importSchedules': '汇入班表',
		'reflowIsAllowed': '允许重排',
		'toBeContinued': '未完成',
		'imported': '已汇入',
		'notImported': '未汇入',
		'totalPeople': '共<%=temp1%>人',
		'peopleWhoHaveCompletedThePre': '已完成预排<%=temp1%>人',
		'tempPeopleWhoHaveNotCompleted': '未完成预排 <%=temp1%> 人',
		'lastSent': '上次发送时间：<%=temp1%>',
		'sendReminderNotifications': '发送催排通知',
		'theReminderLetterWasSentSuccessfully': '发送催排信件成功',
		'openReschedule': '开放「<%=temp1%>」重排班表？',
		'statisticalReports': '统计报表',
		'scheduleStatisticsReport': '排班统计报表',
		'failedToReportForm': '导出报表失败',
		'partOfTheStaff2': '部分员工',
		'theNameOfTheReport': '报表名称',
		'employee2': '<%=temp1%> <%=temp2%> 位员工',
		'sectionImportSample1': '行事历别班别合并，不含标签(时段)',
		'sectionImportSample2': '行事历别班别合并含标签(时段)',
		'sectionImportSample3': '行事曆別班別不合併(时段)',
		'scheduleOrShift': '行事历别及班别',
		'feteOrShift': '假节日名称及班别简称',
		'unauthorized': '员工在班表区间内不是排班人员或无权限',
		'containsError': '栏位内容错误',
		'staffIdRequired': '员工编号必填',
		'has': '有',
		'fatal': '错误信息',
		'shiftMemberOnly': '仅可导入该班表的被排班人员',
		'shiftDeadlineExceeded': '超过班表异动期限',
		'notShiftingStaff': '员工当日不是排班员工',
		'unauthorizedSection': '员工在班表区间内不是时段排班人员或无权限',
		'calendarMissed': '找不到设置的行事历别',
		'shiftMissed': '找不到设置的排班班别',
		'calendarAndShiftMissed': '找不到设置的行事历别或班别',
		'tagMissed': '找不到设置的排班标签',
		'tagNoMapping': '标签没有对应班别',
		'jobFrom': '工作起始时间',
		'jobEnd': '工作结束时间',
		'restFrom': '休息起始时间',
		'restEnd': '休息结束时间',
		'noFixShift': '固定班不可导入',
		'noWorkShift': '班别排班不可导入',
		'unauthorizedType': '班别属性非排班(依时段)或无权限',
		'staffMissing': '员编不存在',
		'dateMalformed': '时间格式错误',
		'workPartial': '工作时间不完整',
		'restPartial': '休息时间不完整',
		'repetitiveShift': '排班数据重复',
		'defyBanRule': '违反工时规则（禁止）',
	},
	'hp.m3.m310410_cycle_dup': {
		'failedToLoadEmployeeProfile': '加载员工数据失败',
		'employeesScheduledForAllTimeSlots': '班表内所有时段排班员工',
		'employeesScheduledForAllShiftsIn': '班表内所有班别排班员工',
		'specificEmployees': '特定员工',
		'startAndEndTime': '起迄时间',
		'startEndTime': '起迄时间(起)',
		'startEndTimeYet': '起迄时间(迄)',
		'dayNth': '第N天',
		'classesAndLabels': '班别及标签',
		'customizeWorkingHoursAndLabels': '自定义工作时间及标签',
		'pleaseSelectAClass': '请选择班别',
		'customizeWorkingHours': '自定义工作时间',
		'breaks': '休息时间',
		'copyTheCalendar': '复制行事历',
		'failedToMountCalendarData': '加载行事历数据失败',
		'calendarPreview': '行事历预览',
		'schedulingPatterns': '排班方式',
		'roundRobinClassOrder': '循环班别顺序',
		'employees': '员工名单',
	},
	'hp.m3.m310410_audit': {
		'rejectionOfSchedules': '驳回班表',
		'determineTheRejection': '确定驳回',
		'mandatoryReasonForRejectionMaximumWords': '必填驳回原因，最多300字。',
		'theSystemIsAbnormalAndThe': '系统异常，数据写入失败',
		'reviewTheSchedule': '检视班表',
		'rejectionOfTheScheduleIsCompleted': '驳回班表完成',
		'approvalSuccessful': '核准成功',
		'theScheduleHasBeenApprovedBy': '<%=temp1%>笔班表已被他人签核，所以您已无需处理',
		'reviewTheReasonForTheRejection': '查看驳回原因',
	},
	'h2.am.Shifting': {
		'leave': '假',
		'leavePeriod': '请假时间:',
		'cancellationTime': '销假时间:',
		'customShiftFailureTheBreakOverlaps': '自定义班别失败:休息时间与多个班别工作时间重迭',
		'customizeYourClass': '自定义班别',
		'workingHours': '工作时间',
		'customClassFailed': '自定义班别失败:',
		'confirm': '确认',
		'timeSlotScheduling': '时段排班',
		'noEditingPermissions': '无编辑权限',
		'tempHours': '<%=temp1%>小时',
		'tempDays': '<%=temp1%>天',
		'violationOfWorkingHourRules': '违反工时规则',
		'scheduleError': '班表错误',
		'ifThereIsNoInformationThat': ' 没有符合查询条件的数据，请放宽条件重新查询',
		'ifThereIsNoDataThat': ' 没有符合查询条件的数据，点选下方按钮直接选择排班员工',
		'selectTheEmployee': '选择员工',
		'failedToCreateATag': '创建标签失败',
		'otherErrors': '其他错误',
		'enterAnEmployeeKeywordQuery': '输入员工关键词查询',
		'editTheEmployee': '编辑员工',
		'fieldSettings': '字段设定',
		'notYetInService': '未到职',
		'regularShifts': '固定班',
		'dimission': '离职',
		'stay': '留停',
		'theRevisionPeriodHasPassed': '已超过修改期限',
		'thereIsNoNeedToSchedule': '不需排班',
	},
	'h2.am.ShiftingSidePanel': {
		'theResultOfTheWorkRule': '工时规则检查结果',
		'examine': '检查',
		'lastCheckTime': '最后检查时间',
		'youHavenTCheckedYourSchedule': '您还未检查过班表',
		'complyWithTimeRulesChecks': '符合工时规则检查',
		'forbid': '禁止',
		'remind': '提醒',
		'manHourStatistics': '工时统计',
		'beforeStorage': '储存前',
		'afterStorage': '储存后',
		'difference': '差异',
		'shouldBeArranged': '应排',
		'scheduled': '已排',
		'leaveAndOvertimeDetails': '请假加班明细',
		'scheduleCheckResults': '班表检查结果',
	},
	'h2.am.ShiftingConstants': {
		'nameStaff': '姓名/员编',
		'remainingSpecialHolidayHours': '剩余特休(时)',
		'remainingCompensatoryTimeOffHours': '剩余补休(时)',
		'actualCreditCardSwipingManHours': '实际刷卡工时',
		'hoursShouldBeScheduled': '应排时数',
		'differentialWork': '差异工时',
		'linedShouldBeArranged': '已排-应排',
		'workingDaysShouldBeScheduled': '应排工作日',
		'nationalHolidaysShouldBeScheduled': '应排国定假日',
		'restDaysShouldBeScheduled': '应排休息日',
		'holidaysShouldBeScheduled': '应排例假日',
		'shiftsShouldBeEmptied': '应排空班',
	},
	'hp.m4.m410210': {
		'shiftSchedules': '员工预排班表 >',
		'rehearsingIsNoLongerAllowed': '已不允许预排',
		'unableToFindASavetableSchedule': '找不到可储存班表',
		'storageSuccessful': '储存成功',
		'savedAndSubmittedTheScheduleSuccessfully': '储存并提交班表成功',
		'rehearsableAvailable': '可预排',
		'unableToPreRehearse': '无法预排',
		'scheduledTime': '预排时间',
	},
	'hp.m3.m310410_inspection.index': {
		'jobCheck': '岗位检核',
		'postManpowerCheck': '岗位人力检核',
		'classGroups': '班别群组',
	},
	'hp.m3.m310410_inspection.group_config_dialog': {
		'selectAGroupClass': '选择群组班别',
	},
	'hp.m3.m310410_inspection.inspect_config': {
		'selectedClass': '已选班别',
		'theFileFormatIsIncorrect': '档案格式错误',
	},
	'hp.m3.m310410_inspection.inspect_dialog': {
		'thereIsNoInformationAfterSelecting': '无资讯，选择班别后，点选＋，即可设定该班别的岗位应排人力',
		'addedAClassGroup': '新增班别群组',
		'classGroupSetting': '班别群组设定',
		'postStaffingSample': '岗位应排人力导入格式',
		'postStaffingFail': '错误岗位应排人力导入数据',
		'tagState': '标签状态',
		'noEdit': '请勿异动导入格式，导入后一律覆盖当前数据，确定导入数据正确后，点击「确定」按钮即可储存设置。',
		'notPlus': '非正整数',
		'exceeded': '超过上限',
	},
	'hp.m3.m310410_inspection.view_dialog': {
		'noInformationTryToResetThe': '无信息，试试重新设定岗位应排人力吧！',
		'manpowerShouldBeArrangedForThe': '设定岗位应排人力',
		'noteMeansThatTheDifferenceIs': '备注：「-」表示差额等于0，「/」 表示无法计算差额',
	},
	'h2.am.ShiftingFieldSetting': {
		'pleaseSelectTheItemsYouNeed': '请勾选您需要的项目，再拖曳「(图片)」排序位置',
		'staffNameNameStaffEnglishName': '员编、姓名、姓名/员编、英文姓名，择一必填',
		'illustrate': '说明',
	},
	'h2.am.ShiftingDialog': {
		'remainingSpecialHolidayHours': '剩余特休时数',
		'remainingCompensatoryHours': '剩余补休时数',
		'validStartDates': '可休起始日',
		'closedEndDays': '可休结束日',
		'specialSabbaticalYear': '特休年度',
	},
	'h2.am.ShiftingContext': {
		'realTimeScheduleStatistics': '实时班表统计',
	},
	'components.Pdf': {
		'download':	' 下载',
		'page': '第 <%=temp1%> 页',
		'total': '共 <%=temp1%> 页',
	},
	'sp.sa.am.emp.skd.autoInsertShift': {
		'code11': '未自定义任何工作时间',
		'code12': '工作时间重迭',
		'code13': '休息时间与多个班别工作时间重迭',
		'code14': '休息时间重迭',
		'code15': '「工作时间」结束时间早于起始时间',
		'code16': '「休息时间」结束时间早于起始时间',
		'code17': '历日资料有误',
	},
	'hp.m5.m510010.wf101': {
		'basicInfo': '基本资讯',
		'tripInfo': '行程资讯',
		'reasonAttachment': '原因/附件',
		'transStloc': '出发地',
		'transDtloc': '目的地',
		'number': '输入数字',
		'km': '公里',
		'addTrip': '新增行程',
		'delTrip': '删除行程',
		'transKm': '里程数',
		'requiredTrans': '需填写出发地、目的地、里程数',
		'requiredRail': '需填写出发地、目的地',
		'verifyDeactivation': '<%=f%> <%=n%> 已停用',
		'verifyDeletion': '<%=f%> <%=n%> 已刪除',
		'sameTransportation': '同一个交通工具的出发地、目的地不可相同',
	},
	'104service.redirection': {
		490: '账号状态异常(锁定、关闭、未验证等)，请联络系统管理者',
		491: '非员工无法使用',
		492: '未设置邮箱无法使用',
		493: '服务参数未设置，请联系104',
		494: '暂时无法获取服务Token，请联系104',
		495: '服务异常，请联系104',
		496: '104企业学习平台未启用，无法使用',
		489: '姓名/英文姓名皆为符号，无法使用104服务，请联系系统管理员',
	},
	'sso.verify': {
		'verificationFailed': 'SSO验证失败',
		'linkExpired': '此链接已过期，请重新申请',
		'verificationSuccessful': 'SSO验证成功',
	}
};
